function checkDiscountLimitFull(thisId) {
  var currentCartItems = CartJS.cart.items || [];
  var qtyLimit = Number($('body').attr('data-qty-limit')) || 0;

  var discountQty = 0;
  var productInCart = false;
  var thisItemHasDiscount = false;

  for (var i = 0; i < currentCartItems.length; i++) {
    var prod = currentCartItems[i];

    // Count total discounted quantity
    if (prod.discounts && prod.discounts.length > 0) {
      discountQty += prod.quantity;
    }

    // Check the product being added
    if (prod.variant_id == thisId) {
      productInCart = true;
      if (prod.discounts && prod.discounts.length > 0) {
        thisItemHasDiscount = true;
      }
    }
  }

  console.log('discounted product count: ' + discountQty);

  // If adding this product (which does NOT have a discount)
  // would put us over the discount limit, block it.
  if (productInCart && thisItemHasDiscount && qtyLimit > 0) {
    if (discountQty + 1 > qtyLimit) {
      console.log("discount limit reached");
      return true;  
    }
  }
  
  console.log("discount limit not reached");
  return false;
}
(function ($, root, undefined) {

	function getNearestWeekdayTwoDaysAhead() {
      const date = new Date();
      date.setDate(date.getDate() + 2);

      // Adjust if the resulting day is Saturday or Sunday
      const day = date.getDay();
      if (day === 6) { // Saturday
        date.setDate(date.getDate() + 2);
      } else if (day === 0) { // Sunday
        date.setDate(date.getDate() + 1);
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      return `${yyyy}/${mm}/${dd}`;
    }

	$(document).ready(function () {
		AOS.init();

		console.log('test');

		var colorLib = {
			aliceblue: '#f0f8ff',
			antiquewhite: '#faebd7',
			aqua: '#00ffff',
			aquamarine: '#7fffd4',
			azure: '#f0ffff',
			beige: '#f5f5dc',
			bisque: '#ffe4c4',
			black: '#000000',
			blanchedalmond: '#ffebcd',
			blue: '#0000ff',
			blueviolet: '#8a2be2',
			brown: '#a52a2a',
			burlywood: '#deb887',
			cadetblue: '#5f9ea0',
			chartreuse: '#7fff00',
			chocolate: '#d2691e',
			coral: '#ff7f50',
			chrome: '#D4AF37',
			cornflowerblue: '#6495ed',
			cornsilk: '#fff8dc',
			crimson: '#dc143c',
			cyan: '#00ffff',
			darkblue: '#00008b',
			darkcyan: '#008b8b',
			darkgoldenrod: '#b8860b',
			darkgray: '#a9a9a9',
			darkgreen: '#006400',
			darkkhaki: '#bdb76b',
			darkmagenta: '#8b008b',
			darkolivegreen: '#556b2f',
			darkorange: '#ff8c00',
			darkorchid: '#9932cc',
			darkred: '#8b0000',
			darksalmon: '#e9967a',
			darkseagreen: '#8fbc8f',
			darkslateblue: '#483d8b',
			darkslategray: '#2f4f4f',
			darkturquoise: '#00ced1',
			darkviolet: '#9400d3',
			deeppink: '#ff1493',
			deepskyblue: '#00bfff',
			dimgray: '#696969',
			dodgerblue: '#1e90ff',
			firebrick: '#b22222',
			floralwhite: '#fffaf0',
			forestgreen: '#228b22',
			fuchsia: '#ff00ff',
			gainsboro: '#dcdcdc',
			ghostwhite: '#f8f8ff',
			gold: '#ffd700',
			goldenrod: '#daa520',
			gray: '#808080',
			green: '#008000',
			greenyellow: '#adff2f',
			honeydew: '#f0fff0',
			hotpink: '#ff69b4',
			indianred: '#cd5c5c',
			indigo: '#4b0082',
			ivory: '#fffff0',
			khaki: '#f0e68c',
			lavender: '#e6e6fa',
			lavenderblush: '#fff0f5',
			lawngreen: '#7cfc00',
			lemonchiffon: '#fffacd',
			lightblue: '#add8e6',
			lightcoral: '#f08080',
			lightcyan: '#e0ffff',
			lightgoldenrodyellow: '#fafad2',
			lightgrey: '#d3d3d3',
			lightgreen: '#90ee90',
			lightpink: '#ffb6c1',
			lightsalmon: '#ffa07a',
			lightseagreen: '#20b2aa',
			lightskyblue: '#87cefa',
			lightslategray: '#778899',
			lightsteelblue: '#b0c4de',
			lightyellow: '#ffffe0',
			lime: '#00ff00',
			limegreen: '#32cd32',
			linen: '#faf0e6',
			magenta: '#ff00ff',
			maroon: '#800000',
			mediumaquamarine: '#66cdaa',
			mediumblue: '#0000cd',
			mediumorchid: '#ba55d3',
			mediumpurple: '#9370d8',
			mediumseagreen: '#3cb371',
			mediumslateblue: '#7b68ee',
			mediumspringgreen: '#00fa9a',
			mediumturquoise: '#48d1cc',
			mediumvioletred: '#c71585',
			midnightblue: '#191970',
			mintcream: '#f5fffa',
			mistyrose: '#ffe4e1',
			moccasin: '#ffe4b5',
			navajowhite: '#ffdead',
			navy: '#000080',
			ochra: '#fdf5e6',
			oldlace: '#fdf5e6',
			olive: '#808000',
			olivedrab: '#6b8e23',
			orange: '#ffa500',
			orangered: '#ff4500',
			orchid: '#da70d6',
			palegoldenrod: '#eee8aa',
			palegreen: '#98fb98',
			paleturquoise: '#afeeee',
			palevioletred: '#d87093',
			papayawhip: '#ffefd5',
			peachpuff: '#ffdab9',
			peru: '#cd853f',
			pink: '#ffc0cb',
			plum: '#dda0dd',
			powderblue: '#b0e0e6',
			purple: '#800080',
			rebeccapurple: '#663399',
			red: '#ff0000',
			rosybrown: '#bc8f8f',
			royalblue: '#4169e1',
			saddlebrown: '#8b4513',
			salmon: '#fa8072',
			sandybrown: '#f4a460',
			seagreen: '#2e8b57',
			seashell: '#fff5ee',
			sienna: '#a0522d',
			silver: '#c0c0c0',
			silverdigitaldoorviewer: '#c0c0c0',
			silverdigitaldoorviewerwithrecorder: '#c0c0c0',
			skyblue: '#87ceeb',
			slateblue: '#6a5acd',
			slategray: '#708090',
			snow: '#fffafa',
			springgreen: '#00ff7f',
			steelblue: '#4682b4',
			tan: '#d2b48c',
			teal: '#008080',
			thistle: '#d8bfd8',
			tomato: '#ff6347',
			turquoise: '#40e0d0',
			violet: '#ee82ee',
			wheat: '#f5deb3',
			white: '#e9efea',
			whitesmoke: '#f5f5f5',
			yellow: '#ffff00',
			lifetimebrass:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/lifetimeBrass_fb14dd8b-af95-4d8e-9214-643ac1c90a91.png?v=1627593807',
			yellowgreen: '#9acd32',
			blackorange:
				'https://cdn.shopify.com/s/files/1/2592/4270/files/swatch-black-orange.jpg?11677064816970603054',
			naturalwood:
				'https://cdn.shopify.com/s/files/1/2592/4270/files/swatch-natural-wood.jpg?5914773578951770782',
			oilrubbedbronzepermanent:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/2.png?117760',
			polishedbrass:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/1.png?117760',
			satinnickel:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
			satinnickellaminated:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
			laminatedsatinnickel:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760',
			satinchrome:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image4.png?133410',
			antiquebrass:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
			brass: 'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
			brasscoated:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image1.png?133410',
			antiquenickel:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
			anitquenickel: '#727472',
			polishedbrasscoated: '#D0D5DB',
			coatedpolishedbrass: '#cc9933',
			coatedsatinnickel: '#727472',
			oilrubbedbronzecoated: '#cd7f32',
			brasspolished: '#E3D343',
			satinnickelcoated: '#B5B6B5',
			permanentoilrubbedbronze: '#665d1e',
			nickelcoated:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
			nickel: 'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image3.png?133410',
			oilrubbedbronze:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image2.png?133410',
			polishedchrome:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image5.png?133410',
			blacksuede:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Capture.jpg?213391',
			matteblack:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Capture.jpg?213391',
			gunmetal:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Gun-matel.png?219497',
			antiquenickel:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Antique_Nickel.png?219497',
			suedeblack:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
			blackdigitaldoorviewerwithrecorder:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
			blackdigitaldoorviewer:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/suedo-black.png?219498',
			lookdoorviewerwithwifi: '#a0522d',
			powdercoatedexteriorblackral9004: '#000',
			carbonbrown:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Smart_Del_Box-Carbon_Brown-Finish_1500px.png?v=1601042376',
			manorgray:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Smart_Del_Box-Manor_Gray-Finish_1500px.png?v=1601043535',
			vivamagenta:
				'https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Magenta-swatch_1.png?v=1689719593',
			ash: '#6C7576',
		};

		function compareProdTypes(prodType, groupType) {
			console.log(
				'comparing product types ' +
					prodType +
					' against ' +
					groupType +
					'.'
			);
			var smartLockTypes = [
				'Smart Lock',
				'Keypad Lock',
				'Patio Door Locks',
				'Front Door Bundle',
			];
			var mechanicalLockTypes = [
				'Mechanical Deadbolt',
				'Mechanical Lever',
				'Mechanical Knob',
				'Mechanical Handleset',
			];

			if (
				smartLockTypes.includes(prodType) &&
				smartLockTypes.includes(groupType)
			) {
				console.log('smart lock');
				return true;
			} else if (
				mechanicalLockTypes.includes(prodType) &&
				mechanicalLockTypes.includes(groupType)
			) {
				console.log('mechanical lock');
				return true;
			} else {
				console.log('they do not match');
				return false;
			}
		}

		if (
			$('#shopify-section-crossBanner').length ||
			$('#shopify-section-newCoBrandBanner').length
		) {
			console.log('test');
			$('.navbar-main').attr('style', 'display:none!important;');
			$('.section-content').attr(
				'style',
				'padding-top:0!important;overflow:hidden;'
			);
			$('.site-footer').attr(
				'style',
				'background-color:rgb(26,26,26);padding-top:50px;color:white!important;'
			);
			$('.topbar .row .d-flex .d-block').attr(
				'style',
				'opacity:0;height:24px;'
			);
		}

		$('.smVideoButton').on('click', function (e) {
			e.preventDefault();
			var thisVideo = $(this).attr('video-code');
			$('.smVideoModal').fadeIn();
			$('.smVideoModal__wrapper').html(thisVideo);
		});

		if ($('.buy-pro-section .smVideoButton').length > 0) {
			$('.buy-pro-section').on('click', function (e) {
				e.preventDefault();
				var thisVideo = $(this)
					.find('.smVideoButton')
					.attr('video-code');
				$('.smVideoModal').fadeIn();
				$('.smVideoModal__wrapper').html(thisVideo);
			});
		}

		$('.smVideoModal__bkg, .smVideoModa__close').on('click', function () {
			$('.smVideoModal').fadeOut();
			$('.smVideoModal__wrapper').html('');
		});

		$('.crossSeven__mobSlider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
		});

		$('.slo3Mob__slider').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
		});

		$('[note-data]').on('click', function () {
			var textData = $(this).attr('note-data');
			var target = $('.sm-techNote');
			target.html(textData);
		});

		$('.sm-techSelected').each(function () {
			var textData = $(this).parent().find('label').attr('note-data');
			var target = $('.sm-techNote');
			target.html(textData);
		});

		$('.sm-techButton').on('click', function (e) {
			e.preventDefault();
		});

		$('#shopify-section-newHeaderSlider .newHero__slider').slick({
			dots: true,
			adaptiveHeight: true,
		});

		var addonPriceSet = false;
		var addonInterval = setInterval(function () {
			if ($('.template-product').length > 0) {
				$('.product-addons .price').text(
					'Get the same key cut for all keyed locks on your order ($3.99/lock).'
				);
				addonPriceSet = true;
			}
		}, 100);

		var variantId = $('#extend-offer').attr('data-product');
		var variantPrice = $('#extend-offer').attr('data-price');
		var variantType = $('#extend-offer').attr('data-type');
		// renders the Extend offer buttons for the product
		if (variantId) {
			Extend.buttons.render('#extend-offer', {
				referenceId: variantId,
				price: thisPrice,
				category: thisType,
			});
		}

		$('.abPhones__slider').slick({
			dots: true,
		});

		$('.abProduct__imageSlider').slick({
			dots: true,
		});

		$('.abProduct__specTitle').on('click', function () {
			var thisThing = $(this);
			var thisPar = thisThing.closest('.abProduct__specWrapper');
			thisPar.find('.abProduct__specContent').slideToggle();
			thisPar
				.find('.abProduct__specTitleArrow')
				.toggleClass('abProduct__specTitleArrow--active');
		});

		function selectActiveVariant(thisThing) {
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			var color = thisParent
				.find('.abProduct__color--selected')
				.attr('datacolor');
			thisParent
				.find('.abProduct__hiddenSelect')
				.find('option')
				.each(function () {
					if ($(this).attr('data-option').includes(color)) {
						var newVal = $(this).attr('value');
						thisParent
							.find('.abProduct__hiddenSelect')
							.val(newVal)
							.change();
						thisParent
							.find('.abProduct__hiddenSelect')
							.find('option')
							.attr('selected', false);
						$(this).attr('selected', true);
					}
				});
		}

		function updateVariant(thisThing) {
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			var selected = thisParent.find(
				'.abProduct__hiddenSelect [selected]'
			);
			thisParent
				.find('.abProduct__spec--model')
				.text(selected.attr('sku'));
			thisParent
				.find('.abProduct__spec--finish, .colorName')
				.text(
					thisParent
						.find('.abProduct__color--selected')
						.attr('datacolor')
				);
			thisParent
				.find('.abProduct__spec--weight')
				.text(selected.attr('weight'));
			thisParent.find('.abProduct__image').each(function () {
				if ($(this).attr('src') == selected.attr('data-image')) {
					var index = $(this)
						.parent()
						.parent()
						.attr('data-slick-index');
					thisParent
						.find('.abProduct__imageSlider')
						.slick('slickGoTo', index);
					return false;
				}
			});
			if (selected.attr('available') == 'true') {
				thisParent.find('.abProduct__buy').text('Buy Now');
				thisParent.find('.abProduct__buy').prop('disabled', false);
			} else {
				thisParent.find('.abProduct__buy').text('Sold Out');
				thisParent.find('.abProduct__buy').prop('disabled', true);
			}
		}
		$('.abProduct__hiddenSelect [selected]').each(function () {
			var thisThing = $(this);
			updateVariant(thisThing);
		});

		$('.abProduct__color').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			if (!$(this).hasClass('abProduct__color--selected')) {
				thisParent
					.find('.abProduct__color')
					.removeClass('abProduct__color--selected');
				$(this).addClass('abProduct__color--selected');
				selectActiveVariant(thisThing);
				updateVariant(thisThing);
			}
		});

		function showHideMiniCartKeyedAlike() {
			var count = 0;
			var alreadyGroups = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (
					CartJS.cart.items[i].properties['_keyed_alike_available'] ==
					'true'
				) {
					var qty = CartJS.cart.items[i].quantity;
					count += 1 * qty;
				}
				if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
					alreadyGroups = true;
				}
			}
			console.log(count);
			if (count > 1 && alreadyGroups == false) {
				$('.miniCartKA').show();
			} else {
				$('.miniCartKA').hide();
			}
		}
		$('a[data-target="#cartDrawer"]').on('click', function () {
			showHideMiniCartKeyedAlike();
		});

		function updateCart(openCart) {
			app._getCartData();
			app._vibrateDevice();
			app.$snotify.clear();
			showHideMiniCartKeyedAlike();
			setTimeout(function () {
				if (
					((app.isLoading = false),
					(app.loadingEvent = null),
					app.storeUtilities.cartUpsells.settings.showOnPopUp)
				) {
					var origin = app.cart.items.find(function (data) {
						return data.variant_id === keys;
					});
					app._openModalCartUpsell(origin);
				} else {
					if (openCart == true) {
						app._openCartDrawer();
					} else {
						app._touchCartDrawer();
					}
				}
			}, 300);
		}

		$('.abProduct__buy').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			console.log('pressed');
			if (
				checkDiscountLimitFull(
					thisParent.find('.abProduct__hiddenSelect').val()
				)
			) {
				alert(
					'You can only order up to ' +
						$('body').attr('data-qty-limit') * 1 +
						' discounted items.'
				);
				return;
			}
			CartJS.addItem(
				thisParent.find('.abProduct__hiddenSelect').val(),
				thisParent.find('.abProduct__qty').val(),
				{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
				{
					success: function (data, textStatus, jqXHR) {
						setTimeout(function () {
							updateCart(true);
						}, 200);
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				}
			);
		});

		$('.abProduct__qtyMinus').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			var currentVal = thisParent.find('.abProduct__qty').val();
			if (currentVal > 1) {
				thisParent.find('.abProduct__qty').val(currentVal - 1);
			}
		});

		$('.abProduct__qtyPlus').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest(
				'.abProduct__inner, .nestPDP__inner'
			);
			var currentVal = thisParent.find('.abProduct__qty').val();
			thisParent.find('.abProduct__qty').val(currentVal / 1 + 1);
		});

		$('.abProduct__toolButton').hover(
			function () {
				var thisThing = $(this);
				var thisParent = thisThing.closest(
					'.abProduct__inner, .nestPDP__inner'
				);
				thisParent.find('.abProduct__toolTip').fadeIn();
			},
			function () {
				var thisThing = $(this);
				var thisParent = thisThing.closest(
					'.abProduct__inner, .nestPDP__inner'
				);
				thisParent.find('.abProduct__toolTip').fadeOut();
			}
		);

		$('[datastyle]').each(function () {
			$(this).attr('style', $(this).attr('datastyle'));
		});

		$('.ABHalfHero__inner').slick({
			dots: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
		});

		$('.nestSwapper__slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
		});

		$('.nestGallery__slider').slick({
			infinite: true,
			centerMode: true,
			centerPadding: '60px',
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		$('.cabGallery__slider').slick({
			infinite: true,
			centerMode: false,
			centerPadding: '60px',
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						centerPadding: '20px',
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						centerPadding: '20px',
					},
				},
			],
		});

		$('.nestOther__slider').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '60px',
						dots: true,
					},
				},
			],
		});

		$('.nestSwapper__button')
			.first()
			.addClass('nestSwapper__button--active');
		$('.nestSwapper__button').on('click', function () {
			var index = $(this).attr('data-index');
			$('.nestSwapper__button').removeClass(
				'nestSwapper__button--active'
			);
			$(this).addClass('nestSwapper__button--active');
			$('.nestSwapper__slider').slick('slickGoTo', index);
		});

		if ($('.nestPDP').length) {
			$('html').attr('style', 'scroll-behavior: smooth;');

			var match = false;
			$('.abProduct__color').each(function () {
				var thisThing = $(this);
				if ($('.abProduct__buy').text() == 'Sold Out') {
					match = thisThing;
					match.click();
				}
			});

			var nestInterval = setInterval(function () {
				if ($('.abProduct__imageSlider.slick-initialized').length) {
					clearInterval(nestInterval);
					$('.abProduct__color').first().click();
					setTimeout(function () {
						match.click();
					}, 2000);
				}
			}, 100);
		}

		$('.nestFaq__dropWrapper').hide();

		$('.nestFaq__shelfTop').on('click', function () {
			$(this).parent().find('.nestFaq__dropWrapper').slideToggle();
			$(this)
				.parent()
				.find('.nestFaq__shelfArrow')
				.toggleClass('nestFaq__shelfArrow--active');
		});

		$('.nestPDP .abProduct__color').on('click', function () {
			var dataColor = $(this).attr('datacolor');
			$('.nestPDP__colorName').text(dataColor);
			if (dataColor == 'Black Suede') {
				$('.nestPDP__new').slideDown();
			} else {
				$('.nestPDP__new').slideUp();
			}
		});

		$('.nestProdCard__buyButton').on('click', function () {
			console.log('pressed');
			var thisThing = $(this);
			var keyedAlike = thisThing.attr('data-keyed-alike');

			console.log(keyedAlike);
			if (checkDiscountLimitFull(thisThing.attr('data-id'))) {
				alert(
					'You can only order up to ' +
						$('body').attr('data-qty-limit') * 1 +
						' discounted items.'
				);
				return;
			}

			if (keyedAlike == 'true') {
				CartJS.addItem(
					thisThing.attr('data-id'),
					1,
					{ _keyed_alike_available: 'true', "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
					{
						success: function (data, textStatus, jqXHR) {
							setTimeout(function () {
								updateCart(true);
							}, 200);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			} else {
				CartJS.addItem(
					thisThing.attr('data-id'),
					1,
					{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
					{
						success: function (data, textStatus, jqXHR) {
							updateCart(true);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			}
		});

		var polishedBrass =
			'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/1.png?117760")';
		var satinNickel =
			'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/3.png?117760")';
		var oilRubbedBronze =
			'url("https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Image2.png?133410")';

		$('.nestProdCard__color').each(function () {
			var thisThing = $(this);
			if (thisThing.attr('data-name') == 'Satin Nickel') {
				thisThing.attr(
					'style',
					'background-image:' + satinNickel + ';'
				);
			}
			if (thisThing.attr('data-name') == 'Polished Brass') {
				thisThing.attr(
					'style',
					'background-image:' + polishedBrass + ';'
				);
			}
			if (thisThing.attr('data-name') == 'Oil Rubbed Bronze') {
				thisThing.attr(
					'style',
					'background-image:' + oilRubbedBronze + ';'
				);
			}
			thisThing.on('click', function () {
				thisThing
					.closest('.shopify-section')
					.find('.nestProdCard__image')
					.attr('src', thisThing.attr('data-image'));
				thisThing
					.closest('.shopify-section')
					.find('.nestProdCard__currentColor')
					.text(thisThing.attr('data-name'));
				thisThing
					.closest('.shopify-section')
					.find('.nestProdCard__buyButton')
					.attr('data-id', thisThing.attr('data-id'));
				thisThing
					.closest('.shopify-section')
					.find('.nestProdCard__buyButton')
					.attr(
						'data-keyed-alike',
						thisThing.attr('data-keyed-alike')
					);
				if (thisThing.attr('data-available') == 'false') {
					thisThing
						.closest('.shopify-section')
						.find('.nestProdCard__buyButton')
						.prop('disabled', true);
					thisThing
						.closest('.shopify-section')
						.find('.nestProdCard__buyButton')
						.text('Sold Out');
				} else {
					thisThing
						.closest('.shopify-section')
						.find('.nestProdCard__buyButton')
						.prop('disabled', false);
					thisThing
						.closest('.shopify-section')
						.find('.nestProdCard__buyButton')
						.text('Buy Now');
				}
			});
		});

		$('.boxWorks__slider').slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 990,
					settings: {
						slidesToShow: 3,
						arrows: true,
						dots: true,
					},
				},
				{
					breakpoint: 750,
					settings: {
						slidesToShow: 2,
						arrows: true,
						dots: true,
					},
				},
				{
					breakpoint: 510,
					settings: {
						slidesToShow: 1,
						arrows: true,
						dots: true,
					},
				},
			],
		});

		if ($('.boxPDP').length) {
			function preload(arrayOfImages) {
				$(arrayOfImages).each(function () {
					$('<img/>')[0].src = this;
				});
			}
			preload([
				$('.boxPDP__colorButton--brown').attr('wifi-img'),
				$('.boxPDP__colorButton--brown').attr('keypad-img'),
				$('.boxPDP__colorButton--gray').attr('wifi-img'),
				$('.boxPDP__colorButton--gray').attr('keypad-img'),
			]);

			var boxColor = 'brown';
			var boxOption = 'wifi';

			var currentImg = $('.boxPDP__colorButton--brown').attr('wifi-img');
			var currentPrice = $('.boxPDP__colorButton--brown').attr(
				'wifi-price'
			);
			var currentId = $('.boxPDP__colorButton--brown').attr('wifi-id');
			var currentAvailable = $('.boxPDP__colorButton--brown').attr(
				'wifi-available'
			);

			function calculateItem() {
				if (boxColor == 'brown') {
					if (boxOption == 'wifi') {
						currentImg = $('.boxPDP__colorButton--brown').attr(
							'wifi-img'
						);
						currentPrice = $('.boxPDP__colorButton--brown').attr(
							'wifi-price'
						);
						currentId = $('.boxPDP__colorButton--brown').attr(
							'wifi-id'
						);
						currentAvailable = $(
							'.boxPDP__colorButton--brown'
						).attr('wifi-available');
					} else {
						currentImg = $('.boxPDP__colorButton--brown').attr(
							'keypad-img'
						);
						currentPrice = $('.boxPDP__colorButton--brown').attr(
							'keypad-price'
						);
						currentId = $('.boxPDP__colorButton--brown').attr(
							'keypad-id'
						);
						currentAvailable = $(
							'.boxPDP__colorButton--brown'
						).attr('keypad-available');
					}
				} else {
					if (boxOption == 'wifi') {
						currentImg = $('.boxPDP__colorButton--gray').attr(
							'wifi-img'
						);
						currentPrice = $('.boxPDP__colorButton--gray').attr(
							'wifi-price'
						);
						currentId = $('.boxPDP__colorButton--gray').attr(
							'wifi-id'
						);
						currentAvailable = $('.boxPDP__colorButton--gray').attr(
							'wifi-available'
						);
					} else {
						currentImg = $('.boxPDP__colorButton--gray').attr(
							'keypad-img'
						);
						currentPrice = $('.boxPDP__colorButton--gray').attr(
							'keypad-price'
						);
						currentId = $('.boxPDP__colorButton--gray').attr(
							'keypad-id'
						);
						currentAvailable = $('.boxPDP__colorButton--gray').attr(
							'keypad-available'
						);
					}
				}

				$('.boxPDP__price').text(currentPrice);
				$('.boxPDP__image').attr('src', currentImg);

				if (currentAvailable == 'true') {
					$('.boxPDP__buy').prop('disabled', false);
					$('.boxPDP__buy').text('Buy Now');
				} else {
					$('.boxPDP__buy').prop('disabled', true);
					$('.boxPDP__buy').text('Sold Out');
				}
			}
			calculateItem();

			$('.boxPDP__colorButton').on('click', function () {
				var thisThing = $(this);
				if (thisThing.hasClass('boxPDP__colorButton--brown')) {
					boxColor = 'brown';
				} else {
					boxColor = 'gray';
				}
				$('.boxPDP__colorButton').removeClass(
					'boxPDP__colorButton--active'
				);
				thisThing.addClass('boxPDP__colorButton--active');
				calculateItem();
			});

			$('.boxPDP__colorButton--gray').click();

			$('.boxPDP__option').on('click', function () {
				var thisThing = $(this);
				if (thisThing.hasClass('boxPDP__option--wifi')) {
					boxOption = 'wifi';
				} else {
					boxOption = 'keypad';
				}
				$('.boxPDP__option').removeClass('boxPDP__option--active');
				thisThing.addClass('boxPDP__option--active');
				calculateItem();
			});

			$('.boxPDP__buy').on('click', function () {
				var thisThing = $(this);
				if (checkDiscountLimitFull(currentId)) {
					alert(
						'You can only order up to ' +
							$('body').attr('data-qty-limit') * 1 +
							' discounted items.'
					);
					return;
				}
				CartJS.addItem(
					currentId,
					1,
					{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
					{
						success: function (data, textStatus, jqXHR) {
							updateCart(true);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			});

			$('.boxVideo__playButton').on('click', function () {
				var thisThing = $(this);
				var videoCode = thisThing.attr('data-video');
				$('.boxVideoModal').fadeIn();
				$('.boxVideoModal__bucket').html(videoCode);
			});

			$('.boxVideoModal__overlay, .boxVideoModal__close').on(
				'click',
				function () {
					$('.boxVideoModal').fadeOut();
					$('.boxVideoModal__bucket').html('');
				}
			);
		}

		// Smart Cabinet Page
		$('.cabPDP .pdp__options button').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest('.cabPDP');

			var varId = $(this).data('id');

			thisParent.find('.pdp__options button').removeClass('active');
			$(this).addClass('active');

			thisParent.find('.pdp__price .price').removeClass('active');
			thisParent
				.find('.pdp__price .price[data-id="' + varId + '"]')
				.addClass('active');

			thisParent.find('.pdp__select select').removeClass('active');
			thisParent
				.find('.pdp__select select[data-id="' + varId + '"]')
				.addClass('active');

			thisParent
				.find('.pdp__features--cabinet .pdp__featuresContainer')
				.html(
					'<strong>Features</strong>' + $(this).attr('data-features')
				);
			thisParent
				.find('.pdp__technical--cabinet .pdp__nestFaq__drop')
				.html($(this).attr('data-specs'));

			$(this)
				.closest('.cabPDP')
				.find('.pdp__features')
				.html(
					'<strong>Features</strong>' + $(this).attr('data-features')
				);
		});

		$('.cabPDP .pdp__buy button').on('click', function () {
			var thisThing = $(this);
			var thisParent = thisThing.closest('.cabPDP');
			if (
				checkDiscountLimitFull(
					thisParent.find('.pdp__select select.active').val()
				)
			) {
				alert(
					'You can only order up to ' +
						$('body').attr('data-qty-limit') * 1 +
						' discounted items.'
				);
				return;
			}
			CartJS.addItem(
				thisParent.find('.pdp__select select.active').val(),
				1,
				{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
				{
					success: function (data, textStatus, jqXHR) {
						updateCart(true);
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				}
			);
		});

		$('.accessDesktop__slider').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			fade: true,
		});

		$('.accessDesktop__button').on('click', function () {
			var slideIndex = $(this).attr('data-slide') * 1;
			$('.accessDesktop__slider').slick('slickGoTo', slideIndex);
			$('.accessDesktop__button').removeClass(
				'accessDesktop__button--active'
			);
			$(this).addClass('accessDesktop__button--active');
		});

		$('.accessFAQ__titleButton').on('click', function () {
			if ($(this).hasClass('accessFAQ__titleButton--active')) {
				$(this).removeClass('accessFAQ__titleButton--active');
				$(this).parent().find('.accessFAQ__accordionWrapper').slideUp();
			} else {
				$('.accessFAQ__titleButton').removeClass(
					'accessFAQ__titleButton--active'
				);
				$('.accessFAQ__titleButton')
					.parent()
					.find('.accessFAQ__accordionWrapper')
					.slideUp();
				$(this).addClass('accessFAQ__titleButton--active');
				$(this)
					.parent()
					.find('.accessFAQ__accordionWrapper')
					.slideDown();
			}
		});

		$('.accessMobile__slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			asNavFor: '.accessMobile__textSliderInner',
		});

		$('.accessMobile__textSliderInner').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			asNavFor: '.accessMobile__slider',
		});

		$('.accessMobile__previous').on('click', function () {
			$('.accessMobile__slider').slick('slickPrev');
			$('.accessMobile__textSliderInner').slick('slickPrev');
			var newIndex = $('.accessMobile__slider')
				.find('.slick-current')
				.attr('data-slick-index');
			$('.accessMobile__dot--active').removeClass(
				'accessMobile__dot--active'
			);
			$('.accessMobile__dots')
				.find('[data-slide="' + newIndex + '"]')
				.addClass('accessMobile__dot--active');
		});

		$('.accessMobile__next').on('click', function () {
			$('.accessMobile__slider').slick('slickNext');
			$('.accessMobile__textSliderInner').slick('slickNext');
			var newIndex = $('.accessMobile__slider')
				.find('.slick-current')
				.attr('data-slick-index');
			$('.accessMobile__dot--active').removeClass(
				'accessMobile__dot--active'
			);
			$('.accessMobile__dots')
				.find('[data-slide="' + newIndex + '"]')
				.addClass('accessMobile__dot--active');
		});

		$('.accessMobile__slider').on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				$('.accessMobile__dot--active').removeClass(
					'accessMobile__dot--active'
				);
				$('.accessMobile__dots')
					.find('[data-slide="' + nextSlide + '"]')
					.addClass('accessMobile__dot--active');
			}
		);

		$('.accessMobile__dot').on('click', function () {
			var newIndex = $(this).attr('data-slide');
			$('.accessMobile__slider').slick('slickGoTo', newIndex);
			$('.accessMobile__dot--active').removeClass(
				'accessMobile__dot--active'
			);
			$('.accessMobile__dots')
				.find('[data-slide="' + newIndex + '"]')
				.addClass('accessMobile__dot--active');
		});

		$('.accessCollection__slider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		$('.accessCollection__prev').on('click', function () {
			console.log('test');
			$('.accessCollection__slider').slick('slickPrev');
			var newIndex =
				$('.accessCollection__slider')
					.find('.slick-current')
					.attr('data-slick-index') * 1;
			$('.accessCollection__counterChanger').text(newIndex + 1);
		});

		$('.accessCollection__next').on('click', function () {
			$('.accessCollection__slider').slick('slickNext');
			var newIndex =
				$('.accessCollection__slider')
					.find('.slick-current')
					.attr('data-slick-index') * 1;
			$('.accessCollection__counterChanger').text(newIndex + 1);
		});

		$('.accessCollection__slider').on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				$('.accessCollection__counterChanger').text(nextSlide + 1);
			}
		);

		$('.accessCollectionCard__colorButton').each(function () {
			var colorName = $(this)
				.attr('color-name')
				.toLowerCase()
				.replace(/\s/g, '');
			var colorCode = colorLib[colorName];
			if (colorCode) {
				if (colorCode.includes('http')) {
					$(this)
						.find('.accessCollectionCard__colorBack')
						.attr('style', 'background:url(' + colorCode + ');');
				} else {
					$(this)
						.find('.accessCollectionCard__colorBack')
						.attr('style', 'background:' + colorCode + ';');
				}
			}
		});

		$('.sloFeatured__slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			asNavFor: '.sloFeatured__thumbSlider',
		});

		$('.sloFeatured__thumbSlider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			focusOnSelect: true,
			asNavFor: '.sloFeatured__slider',
		});

		$('.sloFeatured__prevButton').on('click', function () {
			$('.sloFeatured__slider').slick('slickPrev');
		});

		$('.sloFeatured__nextButton').on('click', function () {
			$('.sloFeatured__slider').slick('slickNext');
		});

		$('.accessCollectionCard__colorButton').on('click', function () {
			var image = $(this).attr('color-image');
			var name = $(this).attr('color-name');
			var target = $(this)
				.parent()
				.parent()
				.find('.accessCollectionCard__image');
			var available = $(this).attr('data-available');
			target.attr('src', image);
			$(this)
				.parent()
				.find('.accessCollectionCard__colorButton')
				.removeClass('accessCollectionCard__colorButton--active');
			$(this).addClass('accessCollectionCard__colorButton--active');
			$(this)
				.closest('.accessCollectionCard')
				.find('.accessCollectionCard__colorName')
				.text(name);
			var hasAddButton =
				$(this).parent().parent().find('.nestProdCard__buyButton')
					.length > 0;
			console.log(hasAddButton);
			if (hasAddButton) {
				$(this)
					.closest('.accessCollectionCard')
					.find('.nestProdCard__buyButton')
					.attr('data-id', $(this).attr('data-variant'));
				$(this)
					.closest('.accessCollectionCard')
					.find('.nestProdCard__buyButton')
					.attr('data-keyed-alike', $(this).attr('data-keyed-alike'));
				$(this)
					.closest('.accessCollectionCard')
					.find('.nestProdCard__notifyButton')
					.attr('variant-id', $(this).attr('data-variant'));
			}
		});

		$('.sloFeatured__colorButton').each(function () {
			var colorName = $(this)
				.attr('color-name')
				.toLowerCase()
				.replace(/\s/g, '');
			var colorCode = colorLib[colorName];
			if (colorCode) {
				if (colorCode.includes('http')) {
					$(this)
						.find('.sloFeatured__colorBack')
						.attr('style', 'background:url(' + colorCode + ');');
				} else {
					$(this)
						.find('.sloFeatured__colorBack')
						.attr('style', 'background:' + colorCode + ';');
				}
			}
		});

		$('.sloFeatured__colorButton').on('click', function () {
			var container = $(this).closest('.sloFeatured');
			var image = $(this).attr('color-image');
			var name = $(this).attr('color-name');
			var prod = $(this).attr('data-variant');
			var target = container
				.find('.sloFeatured__slider')
				.find('[data-slick-index="0"]')
				.find('.sloFeatured__img')
				.attr('src', image);
			var target2 = container
				.find('.sloFeatured__slider')
				.find('[data-slick-index="4"]')
				.find('.sloFeatured__img')
				.attr('src', image);
			var target3 = container
				.find('.sloFeatured__thumbSlider ')
				.find('[data-slick-index="0"]')
				.find('.sloFeatured__thumbImg')
				.attr('src', image)
				.click();
			var target4 = container
				.find('.sloFeatured__thumbSlider ')
				.find('[data-slick-index="4"]')
				.find('.sloFeatured__thumbImg')
				.attr('src', image);
			target.attr('src', image);
			container
				.find('.sloFeatured__colorButton')
				.removeClass('sloFeatured__colorButton--active');
			$(this).addClass('sloFeatured__colorButton--active');
			container.find('.sloFeatured__colorName').text(name);
			container.find('.nestProdCard__buyButton').attr('data-id', prod);
		});

		$('.sloZwave__slider').slick({
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		$('.sloZWave__toggle').on('click', function () {
			$('.sloZWave__toggle').removeClass('sloZWave__toggle--active');
			$(this).addClass('sloZWave__toggle--active');
			if ($(this).attr('data-tech') == 'bluetooth') {
				$('.sloZwave__inner--bluetooth').removeClass(
					'sloZwave__inner--hidden'
				);
				$('.sloZwave__inner--wifi').addClass('sloZwave__inner--hidden');
			} else {
				$('.sloZwave__inner--wifi').removeClass(
					'sloZwave__inner--hidden'
				);
				$('.sloZwave__inner--bluetooth').addClass(
					'sloZwave__inner--hidden'
				);
			}
		});

		$('.sloZwave__prevButton').on('click', function () {
			$(this).parent().find('.sloZwave__slider').slick('slickPrev');
		});

		$('.sloZwave__nextButton').on('click', function () {
			$(this).parent().find('.sloZwave__slider').slick('slickNext');
		});

		$('.sloZwave__prev').on('click', function () {
			$(this)
				.parent()
				.parent()
				.find('.sloZwave__slider')
				.slick('slickPrev');
			var newIndex =
				$(this)
					.parent()
					.parent()
					.find('.sloZwave__slider ')
					.find('.slick-current')
					.attr('data-slick-index') * 1;
			$(this)
				.parent()
				.find('.sloZwave__counterChanger')
				.text(newIndex + 1);
		});

		$('.sloZwave__next').on('click', function () {
			$(this)
				.parent()
				.parent()
				.find('.sloZwave__slider')
				.slick('slickNext');
			var newIndex =
				$(this)
					.parent()
					.parent()
					.find('.sloZwave__slider ')
					.find('.slick-current')
					.attr('data-slick-index') * 1;
			$(this)
				.parent()
				.find('.sloZwave__counterChanger')
				.text(newIndex + 1);
		});

		$('.accessCollection__slider').on(
			'beforeChange',
			function (event, slick, currentSlide, nextSlide) {
				$(this)
					.parent()
					.parent()
					.find('.sloZwave__counterChanger')
					.text(nextSlide + 1);
			}
		);

		$('.sloTableM__dropSelected').on('click', function () {
			if ($(this).parent().hasClass('sloTableM__dropWrapper--open')) {
				$(this).parent().removeClass('sloTableM__dropWrapper--open');
				$(this).parent().find('.sloTableM__dropDownInner').slideUp();
			} else {
				$(this).parent().addClass('sloTableM__dropWrapper--open');
				$(this).parent().find('.sloTableM__dropDownInner').slideDown();
			}
		});

		$('.sloTableM__dropWrapper--left')
			.find('.sloTableM__dropButton')
			.on('click', function () {
				var buttonVal = $(this).attr('data-button');
				console.log(buttonVal);
				var swapVal = $('.sloTableM__dropWrapper--left')
					.find('.sloTableM__dropSelected span')
					.text();
				console.log(swapVal);
				$('.sloTableM__dropWrapper--left')
					.find('.sloTableM__dropSelected span')
					.text(buttonVal);
				$(this).attr('data-button', swapVal);
				$(this).text(swapVal);
				$('.sloTableM__dropWrapper--left')
					.find('.sloTableM__dropSelected')
					.click();

				if (buttonVal == 'Assure Lock 2') {
					$('.sloTableM__left').each(function () {
						$(this).text($(this).attr('data-wifi'));
					});
					$('.sloTableM__leftLink').attr(
						'href',
						$(this).attr('data-wifi')
					);
				} else if (buttonVal == 'Assure Lock 2 with Wi-Fi') {
					$('.sloTableM__left').each(function () {
						$(this).text($(this).attr('data-zwave'));
					});
					$('.sloTableM__leftLink').attr(
						'href',
						$(this).attr('data-zwave')
					);
				} else if (buttonVal == 'Nest x Yale Lock') {
					$('.sloTableM__left').each(function () {
						$(this).text($(this).attr('data-zigbee'));
					});
					$('.sloTableM__leftLink').attr(
						'href',
						$(this).attr('data-zigbee')
					);
				} else if (buttonVal == 'Assure with Z-Wave Plus') {
					$('.sloTableM__left').each(function () {
						$(this).text($(this).attr('data-fifth'));
					});
					$('.sloTableM__leftLink').attr(
						'href',
						$(this).attr('data-fifth')
					);
				}
			});

		$('.sloTableM__dropWrapper--right')
			.find('.sloTableM__dropButton')
			.on('click', function () {
				var buttonVal = $(this).attr('data-button');
				console.log(buttonVal);
				var swapVal = $('.sloTableM__dropWrapper--right')
					.find('.sloTableM__dropSelected span')
					.text();
				console.log(swapVal);
				$('.sloTableM__dropWrapper--right')
					.find('.sloTableM__dropSelected span')
					.text(buttonVal);
				$(this).attr('data-button', swapVal);
				$(this).text(swapVal);
				$('.sloTableM__dropWrapper--right')
					.find('.sloTableM__dropSelected')
					.click();

				if (buttonVal == 'Assure Lock 2') {
					$('.sloTableM__right').each(function () {
						$(this).text($(this).attr('data-wifi'));
					});
					$('.sloTableM__rightLink').attr(
						'href',
						$(this).attr('data-wifi')
					);
				} else if (buttonVal == 'Assure Lock 2 with Wi-Fi') {
					$('.sloTableM__right').each(function () {
						$(this).text($(this).attr('data-zwave'));
					});
					$('.sloTableM__rightLink').attr(
						'href',
						$(this).attr('data-zwave')
					);
				} else if (buttonVal == 'Nest x Yale Lock') {
					$('.sloTableM__right').each(function () {
						$(this).text($(this).attr('data-zigbee'));
					});
					$('.sloTableM__rightLink').attr(
						'href',
						$(this).attr('data-zigbee')
					);
				} else if (buttonVal == 'Assure with Z-Wave Plus') {
					$('.sloTableM__right').each(function () {
						$(this).text($(this).attr('data-fifth'));
					});
					$('.sloTableM__rightLink').attr(
						'href',
						$(this).attr('data-fifth')
					);
				}
			});

		if ($('.zigbee-hidden').length > 0) {
			$('.sloTableD__cell--zigbee').hide();
		}
		if ($('.nest-hidden').length > 0) {
			$('.sloTableD__cell--nest').hide();
		}
		if ($('.zwave-hidden').length > 0) {
			$('.sloTableD__cell--zwave').hide();
		}

		if ($('#shopify-section-template-product').length > 0) {
			function showCheck(variantID) {
				//select object by passed id
				var selected = varLib.find((x) => x.id === variantID);
				//show-hide notify me box
				if (selected.available == 'false') {
					jQuery('.prodHideRow').attr(
						'style',
						'display:none!important;'
					);
					jQuery('.notifyMe').show();
				} else {
					jQuery('.prodHideRow').attr('style', 'display:flex;');
					jQuery('.notifyMe').hide();
				}

				console.log('SELECTED PROD DATA HERE');
				console.log(selected);

				//show-hide keyed alike box
				if (selected.keyed_alike == 'true') {
					$('#keyedAlike').val('true');

					var count = 0;
					var type = '';
					for (i = 0; i < CartJS.cart.items.length; i++) {
						if (
							CartJS.cart.items[i].properties[
								'_keyed_alike_available'
							] == 'true'
						) {
							var qty = CartJS.cart.items[i].quantity;
							count += 1;
						}
						if (type == '') {
							if (
								CartJS.cart.items[i].properties[
									'_keyed_alike_group'
								] > 0
							) {
								type = CartJS.cart.items[i].product_type;
							}
						}
					}

					if (
						type == '' ||
						compareProdTypes(selected['_type'], type)
					) {
						if ($('.quantity').val() > 1) {
							jQuery('.pdpKA').show();
							jQuery('.pdpKA').attr(
								'data-type',
								selected['_type']
							);
						} else if (count > 0) {
							jQuery('.pdpKA').show();
							jQuery('.pdpKA').attr(
								'data-type',
								selected['_type']
							);
						} else {
							jQuery('.pdpKA').hide();
						}
					} else {
						jQuery('.pdpKA').hide();
					}
				} else {
					jQuery('.pdpKA').hide();
					$('#keyedAlike').val('false');
				}
			}

			if (varLib[0].available == 'false') {
				jQuery('.prodHideRow').attr('style', 'display:none!important;');
				jQuery('.notifyMe').show();
			} else {
				jQuery('.prodHideRow').attr('style', 'display:flex;');
				jQuery('.notifyMe').hide();
			}

			var initialInterval = setInterval(function () {
				console.log('interval Running');
				if (typeof CartJS.cart.items !== 'undefined') {
					var urlString = window.location.search;
					var variantID = urlString.split('=')[1];
					$('.notifyMe__submit').attr('data-variant', variantID);
					showCheck(variantID);
					clearInterval(initialInterval);
				}
			}, 10);

			console.log(varLib);

			if ($('.template-product').length > 0) {
				setInterval(function () {
					var newSku = $('.hiddenSelectorForPDP')
						.find(':selected')
						.attr('data-sku');
					var newFinish = $('input[name="color"]:checked').val();
					$('.swapModel').text(newSku);
					$('.swapFinish').text(newFinish);
				}, 100);

				var variantId = '';
				setInterval(function () {
					var testVar = $('.hiddenProdOption')
						.first()
						.attr('name')
						.replace('product_options_', '')
						.replace('[]', '');
					if (testVar !== variantId) {
						variantId = testVar;
						console.log(variantId);
						$('[src-' + variantId + ']').each(function () {
							var htmlString = $(this).prop('outerHTML');
							var element = $('<div></div>')
								.append(htmlString)
								.find('img');
							element = element[0];
							var newSrc =
								element.attributes['src-' + variantId].value;
							console.log(newSrc);
							$(this).attr('src', newSrc);
						});
					}
				}, 100);
			}

			$('.selector-wrapper')
				.find('input')
				.on('change', function () {
					var urlString = window.location.search;
					var variantID = urlString.split('=')[1];
					$('.notifyMe__submit').attr('data-variant', variantID);
					showCheck(variantID);
				});
			$('[data-qty-increase], [data-qty-decrease]').on(
				'click',
				function () {
					var urlString = window.location.search;
					var variantID = urlString.split('=')[1];
					showCheck(variantID);
				}
			);

			function watchForPopup(reference) {
				var lookForPopup = setInterval(function () {
					if ($('#extend-offers-modal-iframe').length > 0) {
						var waitForClose = setInterval(function () {
							if ($('#extend-offers-modal-iframe').length <= 0) {
								reference
									.closest('.shopify-section')
									.find('.pdpKAPop')
									.show();
								clearInterval(waitForClose);
							}
						}, 1);
						clearInterval(lookForPopup);
					} else {
						clearInterval(lookForPopup);
						var groupCount = 0;
						var frozenCart = JSON.parse(JSON.stringify(CartJS));
						for (i = 0; i < frozenCart.cart.items.length; i++) {
							if (
								frozenCart.cart.items[i].properties['_name'] ==
								'keyed_alike_group'
							) {
								var qty = frozenCart.cart.items[i].quantity;
								groupCount += 1;
							}
							if (
								frozenCart.cart.items[i].properties['_groups'] *
									1 >
								1
							) {
								$('.pdpKAPop__addToExisting').hide();
							}
						}
						if (groupCount > 0) {
							$('.pdpKAPop__inner--existing').show();
							$('.pdpKAPop__inner--new').hide();
							reference
								.closest('.shopify-section')
								.find('.pdpKAPop')
								.show();
						} else {
							if (
								$('#cartDrawer').find(
									'.cart-item[data-variant-id="32146864832644"]'
								).length > 0
							) {
							} else {
								var _itemsToGroup = [];
								var _newKAItemCount = 0;
								var firstType = '';
								for (
									i = 0;
									i < frozenCart.cart.items.length;
									i++
								) {
									if (i == 0) {
										firstType =
											frozenCart.cart.items[i][
												'product_type'
											];
									}
									if (
										frozenCart.cart.items[i].properties[
											'_keyed_alike_available'
										] == 'true'
									) {
										if (
											compareProdTypes(
												frozenCart.cart.items[i][
													'product_type'
												],
												firstType
											)
										) {
											_itemsToGroup.push({
												id: frozenCart.cart.items[i].id,
												quantity:
													frozenCart.cart.items[i]
														.quantity,
												properties: {
													_name: 'keyed_alike_group',
													_value: 1,
													_keyed_alike_group: 1,
													_keyed_alike_available:
														'true',
													_type: firstType,
													_requested_ship_date: getNearestWeekdayTwoDaysAhead()
												},
											});
											_newKAItemCount +=
												frozenCart.cart.items[i]
													.quantity * 1;
										}
									}
								}

								for (j = 0; j < _itemsToGroup.length; j++) {
									CartJS.removeItemById(_itemsToGroup[j].id);
								}

								_itemsToGroup.push({
									id: 32146864832644,
									quantity: _newKAItemCount,
									properties: {
										_groups: 1,
										_type: firstType,
									},
								});
								CartJS.addItems(_itemsToGroup, {
									success: function (
										data,
										textStatus,
										jqXHR
									) {
										updateCart(true);
										$('.pdpKAPop').fadeOut();
									},
									error: function (
										jqXHR,
										textStatus,
										errorThrown
									) {
										console.log(
											'Error: ' + errorThrown + '!'
										);
									},
								});
							}

							/*
              $('.pdpKAPop__inner--existing').hide();
              $('.pdpKAPop__inner--new').show();
              */
						}
					}
				}, 10);
				var cancelEverything = setTimeout(function () {
					if ($('#extend-offers-modal-iframe').length <= 0) {
						clearInterval(lookForPopup);
						console.log('did not find popup');
					}
				}, 1000);
			}

			$('form button[type="submit"]').on('click', function () {
				var cartCount = CartJS.cart.item_count * 1;
				var cartInterval = setInterval(function () {
					if (CartJS.cart.item_count * 1 != cartCount) {
						var urlString = window.location.search;
						var variantID = urlString.split('=')[1];
						showCheck(variantID);
						clearInterval(cartInterval);
						if ($('.pdpKA__checkbox').prop('checked')) {
							watchForPopup($(this));
						}
					}
				}, 10);
			});

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});

			$('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
				'click',
				function () {
					$('.pdpKAPop').fadeOut();
				}
			);

			$('.pdpKAPop__continueButton').on('click', function () {
				var itemsToGroup = [];
				var newKAItemCount = 0;
				var type = '';
				type = $(this)
					.closest('.shopify-section')
					.find('.pdpKA__inner')
					.parent()
					.attr('data-type');

				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties[
							'_keyed_alike_available'
						] == 'true'
					) {
						if (
							compareProdTypes(
								CartJS.cart.items[i].product_type,
								type
							)
						) {
							itemsToGroup.push({
								id: CartJS.cart.items[i].id,
								quantity: CartJS.cart.items[i].quantity,
								properties: {
									_name: 'keyed_alike_group',
									_value: 1,
									_keyed_alike_group: 1,
									_keyed_alike_available: 'true',
									_requested_ship_date: getNearestWeekdayTwoDaysAhead()
								},
							});
							newKAItemCount += CartJS.cart.items[i].quantity * 1;
						}
					}
				}

				for (j = 0; j < itemsToGroup.length; j++) {
					CartJS.removeItemById(itemsToGroup[j].id);
				}

				itemsToGroup.push({
					id: 32146864832644,
					quantity: newKAItemCount,
					properties: {
						_groups: 1,
					},
				});

				CartJS.addItems(itemsToGroup, {
					success: function (data, textStatus, jqXHR) {
						updateCart(true);
						$('.pdpKAPop').fadeOut();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				});
			});

			$('.pdpKAPop__addToExisting').on('click', function () {
				CartJS.removeItemById(32146864832644);

				var itemsToGroup = [];
				var newKAItemCount = 0;
				var firstType = '';

				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties['_keyed_alike_group'] >
						0
					) {
						firstType = CartJS.cart.items[i].product_type;
					}
				}

				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						compareProdTypes(
							CartJS.cart.items[i].product_type,
							firstType
						)
					) {
						if (
							CartJS.cart.items[i].properties[
								'_keyed_alike_available'
							] == 'true'
						) {
							itemsToGroup.push({
								id: CartJS.cart.items[i].id,
								quantity: CartJS.cart.items[i].quantity,
								properties: {
									_name: 'keyed_alike_group',
									_value: 1,
									_keyed_alike_group: 1,
									_keyed_alike_available: 'true',
									_requested_ship_date: getNearestWeekdayTwoDaysAhead()
								},
							});
							newKAItemCount += CartJS.cart.items[i].quantity * 1;
						}
					}
				}

				for (j = 0; j < itemsToGroup.length; j++) {
					CartJS.removeItemById(itemsToGroup[j].id);
				}

				itemsToGroup.push({
					id: 32146864832644,
					quantity: newKAItemCount,
					properties: {
						_groups: 1,
					},
				});

				CartJS.addItems(itemsToGroup, {
					success: function (data, textStatus, jqXHR) {
						updateCart(true);
						$('.pdpKAPop').fadeOut();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				});
			});
		}

		if ($('#shopify-section-nestPDP').length > 0) {
			function showCheck(variantID) {
				console.log(varLib);
				console.log(variantID);
				if (
					varLib.find((x) => x.id === variantID).available == 'false'
				) {
					jQuery('.abProduct__buy').attr(
						'style',
						'display:none!important;'
					);
					jQuery('.notifyMe').show();
				} else {
					jQuery('.abProduct__buy').attr('style', 'display:flex;');
					jQuery('.notifyMe').hide();
				}
			}

			if (varLib[0].available == 'false') {
				jQuery('.abProduct__buy').attr(
					'style',
					'display:none!important;'
				);
				jQuery('.notifyMe').show();
			} else {
				jQuery('.abProduct__buy').attr('style', 'display:flex;');
				jQuery('.notifyMe').hide();
			}

			console.log(varLib);

			$('.abProduct__hiddenSelect').on('change', function () {
				var urlString = window.location.search;
				var variantID = $(this).val();
				$('.notifyMe__submit').attr('data-variant', variantID);
				showCheck(variantID);
			});

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}

		if ($('#shopify-section-cabinetPDP').length > 0) {
			function showCheck(variantID) {
				if (
					varLib.find((x) => x.id === variantID).available == 'false'
				) {
					jQuery('.pdp__buy').attr(
						'style',
						'display:none!important;'
					);
					jQuery('.pdp__disclaimer').attr(
						'style',
						'display:none!important;'
					);
					jQuery('.notifyMe').show();
				} else {
					jQuery('.pdp__buy').attr('style', 'display:block;');
					jQuery('.pdp__disclaimer').attr('style', 'display:block;');
					jQuery('.notifyMe').hide();
				}
			}

			if (varLib[0].available == 'false') {
				jQuery('.pdp__buy').attr('style', 'display:none!important;');
				jQuery('.pdp__disclaimer').attr(
					'style',
					'display:none!important;'
				);
				jQuery('.notifyMe').show();
			} else {
				jQuery('.pdp__buy').attr('style', 'display:block;');
				jQuery('.pdp__disclaimer').attr('style', 'display:block;');
				jQuery('.notifyMe').hide();
			}

			console.log(varLib);

			$('.pdp__options')
				.find('button')
				.on('click', function () {
					var variantID = $('.pdp__options')
						.find('.active')
						.attr('data-variant');
					var productID = $('.pdp__options')
						.find('.active')
						.attr('data-id');
					$('.notifyMe__submit').attr('data-variant', variantID);
					$('.notifyMe__submit').attr('data-product', productID);
					showCheck(variantID);
				});

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}

		if ($('#shopify-section-smartStoragePDPMulti').length > 0) {
			console.log('varLib: ' + varLibMulti);
			function showCheck(variantID) {
				if (
					varLibMulti.find((x) => x.id === variantID).available ==
					'false'
				) {
					jQuery(
						'#shopify-section-smartStoragePDPMulti .pdp__buy'
					).attr('style', 'display:none!important;');
					jQuery(
						'#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
					).attr('style', 'display:none!important;');
					$('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
						'style',
						'display:none!important;'
					);
					jQuery(
						'#shopify-section-smartStoragePDPMulti .notifyMe'
					).show();
				} else {
					jQuery(
						'#shopify-section-smartStoragePDPMulti .pdp__buy'
					).attr('style', 'display:block;');
					jQuery(
						'#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
					).attr('style', 'display:block;');
					$('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
						'style',
						'display:block!important;'
					);
					jQuery(
						'#shopify-section-smartStoragePDPMulti .notifyMe'
					).hide();
				}
			}

			if (varLibMulti[0].available == 'false') {
				jQuery('#shopify-section-smartStoragePDPMulti .pdp__buy').attr(
					'style',
					'display:none!important;'
				);
				jQuery(
					'#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
				).attr('style', 'display:none!important;');
				$('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
					'style',
					'display:none!important;'
				);
				jQuery(
					'#shopify-section-smartStoragePDPMulti .notifyMe'
				).show();
			} else {
				jQuery('#shopify-section-smartStoragePDPMulti .pdp__buy').attr(
					'style',
					'display:block;'
				);
				jQuery(
					'#shopify-section-smartStoragePDPMulti .pdp__disclaimer'
				).attr('style', 'display:block;');
				$('#shopify-section-smartStoragePDPMulti .pdp__learn').attr(
					'style',
					'display:block!important;'
				);
				jQuery(
					'#shopify-section-smartStoragePDPMulti .notifyMe'
				).hide();
			}

			console.log('$( this ): ' + $(this));
			$(
				'#shopify-section-smartStoragePDPMulti .pdp__options .group button'
			).on('click', function () {
				var variantID = $(this)
					.closest('.cabPDP')
					.find('.pdp__options .group .active')
					.attr('data-variant');
				var productID = $(this)
					.closest('.cabPDP')
					.find('.pdp__options .group .active')
					.attr('data-id');
				console.log('variantID: ' + variantID);
				$(this)
					.closest('.cabPDP')
					.find('.notifyMe__submit')
					.attr('data-variant', variantID);
				$(this)
					.closest('.cabPDP')
					.find('.notifyMe__submit')
					.attr('data-product', productID);
				showCheck(variantID);
			});
			// $('.pdp__options').find('button').on('click', function(){

			// });

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}

		if ($('#shopify-section-boxProd').length > 0) {
			function showCheck(variantID) {
				if (
					varLib.find((x) => x.id === variantID).available == 'false'
				) {
					jQuery('.boxPDP__buy').attr(
						'style',
						'display:none!important;'
					);
					jQuery('.notifyMe').show();
				} else {
					jQuery('.boxPDP__buy').attr('style', 'display:block;');
					jQuery('.notifyMe').hide();
				}
			}

			if (varLib[0].available == 'false') {
				jQuery('.boxPDP__buy').attr('style', 'display:none!important;');
				jQuery('.notifyMe').show();
			} else {
				jQuery('.boxPDP__buy').attr('style', 'display:block;');
				jQuery('.notifyMe').hide();
			}

			console.log(varLib);

			$('.boxPDP__option').on('click', function () {
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				$('.notifyMe__submit').attr('data-variant', variantID);
				$('.notifyMe__submit').attr('data-product', productID);
				showCheck(variantID);
				$('.pdp__features--box .pdp__featuresContainer').html(
					$(this).attr('data-features')
				);
				$('.pdp__technical--box .nestFaq__drop').html(
					$(this).attr('data-specs')
				);
			});

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});

			$('.boxPDP__colorButton').on('click', function () {
				var wifiProd = $(this).attr('wifi-product');
				var wifiVariant = $(this).attr('wifi-id');
				var wifiAvailable = $(this).attr('wifi-available');
				var keypadProd = $(this).attr('keypad-product');
				var keypadVariant = $(this).attr('keypad-id');
				var keypadAvailable = $(this).attr('keypad-available');

				var wifi = $('.boxPDP__option--wifi');
				var keypad = $('.boxPDP__option--keypad');

				wifi.attr('data-product', wifiProd);
				wifi.attr('data-variant', wifiVariant);
				if (wifiAvailable == 'false') {
					wifi.addClass('boxPDP__option--unavailable');
				} else {
					wifi.removeClass('boxPDP__option--unavailable');
				}

				keypad.attr('data-product', keypadProd);
				keypad.attr('data-variant', keypadVariant);
				if (keypadAvailable == 'false') {
					keypad.addClass('boxPDP__option--unavailable');
				} else {
					keypad.removeClass('boxPDP__option--unavailable');
				}

				showCheck($('.boxPDP__option--active').attr('data-variant'));
			});
		}

		var colorOnly = true;
		$('.product-details-wrapper form')
			.find('.selector-wrapper')
			.each(function () {
				console.log($(this).find('.color-swatch').length);
				if ($(this).find('.color-swatch').length == 0) {
					if ($(this).find('input').length > 1) {
						colorOnly = false;
					}
				}
			});

		if (colorOnly && typeof varLib !== 'undefined') {
			var index = 0;
			$('.color-swatch').each(function () {
				if (varLib[index].available == 'false') {
					$(this).addClass('color-swatch--unavailable');
				}
				index++;
			});
		}

		$('.accessCollectionCard__colorButton').on('click', function () {
			if ($(this).attr('data-available') == 'true') {
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__buyButton')
					.show();
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__notifyButton')
					.hide();
			} else {
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__buyButton')
					.hide();
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__notifyButton')
					.show();
			}
		});

		$('.nestProdCard__color').on('click', function () {
			if ($(this).attr('data-available') == 'true') {
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__buyButton')
					.show();
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__notifyButton')
					.hide();
			} else {
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__buyButton')
					.hide();
				$(this)
					.parent()
					.parent()
					.find('.nestProdCard__notifyButton')
					.show();
			}
		});

		function openNotify(target) {
			target.attr('style', 'max-height:100%;');
		}

		function closeNotify(target) {
			target.attr('style', 'max-height:0%;');
		}

		$('.nestProdCard__notifyButton').on('click', function () {
			var target = $(this)
				.parent()
				.parent()
				.parent()
				.find('.prodCardNotify__frame');
			openNotify(target);
			var activeColor = target
				.parent()
				.find('.accessCollectionCard__colorButton--active')
				.attr('color-name');
			var activeVariant = target
				.parent()
				.find('.accessCollectionCard__colorButton--active')
				.attr('data-variant');
			target
				.find('[data-option="Finish"], [data-option="Color"]')
				.find('.prodCardNotify__selector')
				.attr('data-value', activeColor);
			target
				.find('[data-option="Finish"], [data-option="Color"]')
				.find('.prodCardNotify__title')
				.text(activeColor);
			target
				.find('.prodCardNotify__hiddenSelector')
				.val(activeVariant)
				.change();
			target
				.find('.prodCardNotify__hiddenSelector')
				.find('[value="' + activeVariant + '"]')
				.prop('selected', true);
			target
				.find('.notifyMe__submit ')
				.attr('data-variant', activeVariant);
		});

		$('.prodCardNotify__close').on('click', function () {
			var target = $(this).parent().parent();
			closeNotify(target);
		});

		$('.prodCardNotify__selected').on('click', function () {
			$(this).parent().find('.prodCardNotify__slider').slideToggle();
			$(this).parent().toggleClass('prodCardNotify__selector--active');
		});

		function changeNotifyVariant(target) {
			var textArray = [];
			target
				.parent()
				.find('.prodCardNotify__selector')
				.each(function () {
					textArray.push($(this).attr('data-value'));
				});
			var textString = textArray.join(' / ');
			console.log(textString);
			var button = target.parent().find('.notifyMe__submit');
			var selected = target.find('[data-title="' + textString + '"]');
			var value = selected.attr('value');
			target.val(value).change();
			selected.prop('selected', true);
			button.attr('data-variant', value);
		}

		$('.prodCardNotify__choice').on('click', function () {
			$(this).parent().parent().find('.prodCardNotify__slider').slideUp();
			$(this)
				.parent()
				.parent()
				.removeClass('prodCardNotify__selector--active');
			var name = $(this).attr('data-value');
			$(this).parent().parent().attr('data-value', name);
			$(this).parent().parent().find('.prodCardNotify__title').text(name);
			var target = $(this)
				.parent()
				.parent()
				.parent()
				.parent()
				.find('.prodCardNotify__hiddenSelector');
			changeNotifyVariant(target);
		});

		$('.prodCardNotify__inner .notifyMe__submit').on('click', function (e) {
			e.preventDefault();
			var thisThing = $(this);
			var email = $(this).parent().find('.notifyMe__input').val();
			var variantID = $(this).attr('data-variant');
			var productID = $(this).attr('data-product');
			if (email.includes('@')) {
				notifyMeCard(email, variantID, productID, thisThing);
			} else {
				$('.notifyMe__error').show();
			}
		});

		$('#shopify-section-sloFeatured')
			.find('.notifyMe__submit')
			.on('click', function (e) {
				e.preventDefault();

				var email = $(this).parent().find('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$(this)
						.parent()
						.parent()
						.parent()
						.find('.notifyMe__error')
						.show();
				}
			});

		$('.sloFeatured__colorButton').on('click', function () {
			var thisThing = $(this);
			var variant = thisThing.attr('data-variant');
			var available = thisThing.attr('data-available');
			$('#shopify-section-sloFeatured')
				.find('.notifyMe__submit')
				.attr('data-variant', variant);
			if (available == 'true') {
				$('#shopify-section-sloFeatured .notifyMe').hide();
				$(
					'#shopify-section-sloFeatured .nestProdCard__buttonRow'
				).show();
			} else {
				$('#shopify-section-sloFeatured .notifyMe').show();
				$(
					'#shopify-section-sloFeatured .nestProdCard__buttonRow'
				).hide();
			}
		});

		if (
			$('#shopify-section-al2Product1').length > 0 ||
			$('#shopify-section-hdProduct1').length > 0 ||
			$('#shopify-section-lowesProduct1').length > 0 ||
			$('#shopify-section-costcoProduct1').length > 0 ||
			$('#shopify-section-smartMod-newProd').length > 0 ||
			$('.assureLock2Touch').length > 0 ||
			$('.approachPDP--code').length > 0 ||
			$('.al2Prod--matter2025').length > 0
		) {
			$('.al2Prod__slider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
			});

			function addToCart(variant, qty, keyed) {
				if (checkDiscountLimitFull(variant)) {
					alert(
						'You can only order up to ' +
							$('body').attr('data-qty-limit') * 1 +
							' discounted items.'
					);
					return;
				}
				if (typeof keyed !== 'undefined' && keyed) {
					CartJS.addItem(
						variant,
						qty,
						{ _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
						{
							success: function (data, textStatus, jqXHR) {
								setTimeout(function () {
									updateCart(true);
								}, 200);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				} else {
					CartJS.addItem(
						variant,
						qty,
						{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
						{
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			}

			if (typeof createLib === 'function') {
				var libs1 = createLib();
				console.log(libs1);
			}
			if (typeof createLib2 === 'function') {
				var libs2 = createLib2();
				console.log(libs2);
			}
			if (typeof createLib3 === 'function') {
				var libs3 = createLib3();
				console.log(libs3);
			}

			function colorSetup(target) {
				$(target)
					.find('.al2Prod__colorButton')
					.each(function () {
						var thisThing = $(this);
						var fullParent = thisThing.closest('.al2Prod');
						if (thisThing.attr('data-color') == 'false') {
							thisThing.hide();
						} else {
							thisThing.show();

							if (fullParent.hasClass('al2Prod--1')) {
								var ctarget = libs1.colors.find(
									(x) =>
										x.title === thisThing.attr('data-color')
								);
							} else if (fullParent.hasClass('al2Prod--2')) {
								var ctarget = libs2.colors.find(
									(x) =>
										x.title === thisThing.attr('data-color')
								);
							} else {
								var ctarget = libs3.colors.find(
									(x) =>
										x.title === thisThing.attr('data-color')
								);
							}

							if (ctarget) {
								thisThing
									.find('.al2Prod__colorButtonInner')
									.attr(
										'style',
										'background-image:url(' +
											ctarget.src +
											')'
									);
							}
						}
					});
			}

			colorSetup('.al2Prod--1');
			colorSetup('.al2Prod--2');
			colorSetup('.al2Prod--3');

			function getActiveProductInfo(target) {
				var prodOption = target
					.find('.al2Prod__prodButton--active')
					.attr('data-prod-option');
				var keyOption = target
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-key-option');
				var colorOption = target
					.find('.al2Prod__colorButton--active')
					.attr('data-color');
				if (target.hasClass('al2Prod--1')) {
					var lib = libs1;
				} else if (target.hasClass('al2Prod--2')) {
					var lib = libs2;
				} else {
					var lib = libs3;
				}
				for (i = 0; i < lib.products.length; i++) {
					var descString = lib.products[i]['prod-desc'].toLowerCase();
					if (
						descString == 'viva magenta' &&
						colorOption == 'Viva Magenta'
					) {
						console.log('viva magenta');
						var variant = false;
						variant = lib.products[i].variants[0];
						if (variant) {
							var variantId = variant.id;
							var variantImg = variant.image;
							var variantPrice = variant.price;
							var variantAvailable = variant.available;
							var variantUrl = variant.url;
							var variantProdId = variant['prod-id'];
							var variantKeyed = variant.keyedalike;
						}
					} else {
						var optionArray = descString.split(' ');
						if (
							prodOption == optionArray[0] &&
							keyOption == optionArray[1]
						) {
							if (
								target.find('.al2Prod__techButton--active')
									.length > 0
							) {
								var techOption = target
									.find('.al2Prod__techButton--active')
									.attr('data-tech-option');
								if (techOption == optionArray[2]) {
									var variant = false;
									if (
										lib.products[i][
											'option-one'
										].toLowerCase() == 'finish' ||
										lib.products[i][
											'option-one'
										].toLowerCase() == 'color'
									) {
										var variant = lib.products[
											i
										].variants.find(
											(x) =>
												x['option-one'] === colorOption
										);
									} else if (
										lib.products[i][
											'option-two'
										].toLowerCase() == 'finish' ||
										lib.products[i][
											'option-two'
										].toLowerCase() == 'color'
									) {
										var variant = lib.products[
											i
										].variants.find(
											(x) =>
												x['option-two'] === colorOption
										);
									} else {
										var variant = lib.products[
											i
										].variants.find(
											(x) =>
												x['option-three'] ===
												colorOption
										);
									}
									if (variant) {
										var variantId = variant.id;
										var variantImg = variant.image;
										var variantPrice = variant.price;
										var variantAvailable =
											variant.available;
										var variantUrl = variant.url;
										var variantProdId = variant['prod-id'];
										var variantKeyed = variant.keyedalike;
										var variantTitle = false;
										var prodHandle = variant['prod-handle'];
									}
									if ('title' in lib.products[i]) {
										variantTitle = lib.products[i].title;
									}
								}
							} else {
								var variant = false;
								if (
									lib.products[i][
										'option-one'
									].toLowerCase() == 'finish' ||
									lib.products[i][
										'option-one'
									].toLowerCase() == 'color'
								) {
									var variant = lib.products[i].variants.find(
										(x) => x['option-one'] === colorOption
									);
								} else if (
									lib.products[i][
										'option-two'
									].toLowerCase() == 'finish' ||
									lib.products[i][
										'option-two'
									].toLowerCase() == 'color'
								) {
									var variant = lib.products[i].variants.find(
										(x) => x['option-two'] === colorOption
									);
								} else {
									var variant = lib.products[i].variants.find(
										(x) => x['option-three'] === colorOption
									);
								}
								if (variant) {
									var variantId = variant.id;
									var variantImg = variant.image;
									var variantPrice = variant.price;
									var variantAvailable = variant.available;
									var variantUrl = variant.url;
									var variantProdId = variant['prod-id'];
									var variantKeyed = variant.keyedalike;
									var variantTitle = false;
									var prodHandle = variant['prod-handle'];
								}
								if ('title' in lib.products[i]) {
									variantTitle = lib.products[i].title;
								}
							}
						}
						/*
            else{
              var variant = false;
              if (lib.products[i]['option-one'].toLowerCase() == 'finish' || lib.products[i]['option-one'].toLowerCase() == 'color'){
                var variant = lib.products[i].variants.find(x => x['option-one'] === colorOption );
              }
              else if (lib.products[i]['option-two'].toLowerCase() == 'finish' || lib.products[i]['option-two'].toLowerCase() == 'color'){
                var variant = lib.products[i].variants.find(x => x['option-two'] === colorOption );
              }
              else{
                var variant = lib.products[i].variants.find(x => x['option-three'] === colorOption );
              }
              if (variant){
                var variantId = variant.id;
                var variantImg = variant.image;
                var variantPrice = variant.price;
                var variantAvailable = variant.available;
                var variantUrl = variant.url;
                var variantProdId = variant['prod-id'];
                var variantKeyed = variant.keyedalike;
              }
            }
            */
					}
				}
				if (variant) {
					var selectedProductInfo = {
						productHandle: prodHandle,
						productOption: prodOption,
						keyOption: keyOption,
						color: colorOption,
						id: variantId,
						image: variantImg,
						price: variantPrice,
						available: variantAvailable,
						url: variantUrl,
						prodId: variantProdId,
						keyedalike: variantKeyed,
					};
					if (
						target.find('.al2Prod__techButton--active').length > 0
					) {
						selectedProductInfo['techOption'] = target
							.find('.al2Prod__techButton--active')
							.attr('data-tech-option');
					}
					if (variantTitle) {
						selectedProductInfo['title'] = variantTitle;
					}
				} else {
					var selectedProductInfo = false;
				}

				if (selectedProductInfo) {
					fetch(
						window.Shopify.routes.root +
							'products/' +
							prodHandle +
							'.js'
					)
						.then((response) => response.json())
						.then(
							(product) =>
								function () {
									window.dataLayer.push({ ecommerce: null });
									window.dataLayer.push({
										event: 'view_item',
										fired_from: 'shopify',
										ecommerce: {
											currency: 'USD',
											value: product.price,
											items: [
												{
													item_id: product.id,
													item_name: product.title,
													item_brand: product.vendor,
													item_category: product.type,
													item_variant:
														product.variants[0]
															.title,
													item_variant_id:
														product.variants[0].sku,
													price: product.price,
													quantity: 1,
												},
											],
										},
									});
								}
						);
				}

				return selectedProductInfo;
			}

			function preloadImage(url) {
				var img = new Image();
				img.src = url;
			}

			if (typeof createLib === 'function') {
				for (i = 0; i < libs1.images.length; i++) {
					preloadImage(libs1.images[i].src);
					preloadImage(libs1.images[i].srcBlack);
					preloadImage(libs1.images[i].srcBronze);
					preloadImage(libs1.images[i].srcAsh);
            preloadImage(libs1.images[i].srcSnow);
				}
			}

			if (typeof createLib2 === 'function') {
				for (i = 0; i < libs2.images.length; i++) {
					preloadImage(libs2.images[i].src);
					preloadImage(libs2.images[i].srcBlack);
					preloadImage(libs2.images[i].srcBronze);
					preloadImage(libs2.images[i].srcAsh);
            preloadImage(libs2.images[i].srcSnow);
				}
			}

			if (typeof createLib3 === 'function' && libs3 != false) {
				for (i = 0; i < libs3.images.length; i++) {
					preloadImage(libs3.images[i].src);
					preloadImage(libs3.images[i].srcBlack);
					preloadImage(libs3.images[i].srcBronze);
					preloadImage(libs3.images[i].srcAsh);
            preloadImage(libs3.images[i].srcSnow);
				}
			}

			$(document).on('click change', '.pdpKA__checkbox', function () {
				console.log("clicked the checkbox");

				var count = 0;

				if (window.CartJS && CartJS.cart && CartJS.cart.items) {
					for (let i = 0; i < CartJS.cart.items.length; i++) {
					if (CartJS.cart.items[i].properties && CartJS.cart.items[i].properties['_keyed_alike_available'] === 'true') {
						count += 1; // or += CartJS.cart.items[i].quantity;
					}
					}
				}

				if (count === 0) {
					$('.pdpKA__checkbox').prop('checked', false);
					$('.pdpKA--assureLanding').hide();
				}
			});

			function setActiveProduct(target, activeProduct) {
				if (activeProduct == 'false' || activeProduct == false) {
					console.log('error - no active product found');
					return false;
				}
				if (target.hasClass('al2Prod--1')) {
					var lib = libs1;
				} else if (target.hasClass('al2Prod--2')) {
					var lib = libs2;
				} else {
					var lib = libs3;
				}

				console.log(lib.images);

				var matchString =
					activeProduct.productOption + '/' + activeProduct.keyOption;

				for (i = 0; i < lib.images.length; i++) {
					if (lib.images[i].product == matchString) {
						if (lib.images[i].order == '1') {
							//target.find('[data-order="1"]').find('img').attr('src', lib.images[i].src);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-silver', lib.images[i].src);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-bronze', lib.images[i].srcBronze);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-magenta', lib.images[i].srcMagenta);
						} else if (lib.images[i].order == '2') {
							//target.find('[data-order="2"]').find('img').attr('src', lib.images[i].src);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-silver', lib.images[i].src);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-bronze', lib.images[i].srcBronze);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-magenta', lib.images[i].srcMagenta);
						} else if (lib.images[i].order == '3') {
							//target.find('[data-order="3"]').find('img').attr('src', lib.images[i].src);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-silver', lib.images[i].src);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-bronze', lib.images[i].srcBronze);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-magenta', lib.images[i].srcMagenta);
						} else {
							//target.find('[data-order="4"]').find('img').attr('src', lib.images[i].src);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-silver', lib.images[i].src);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-bronze', lib.images[i].srcBronze);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-magenta', lib.images[i].srcMagenta);
						}
					}
				}

				target.find('.al2Prod__finishName').text(activeProduct.color);

				if (activeProduct.color == 'Bronze') {
					target
						.find('.al2Prod__finishName')
						.text('Oil Rubbed Bronze');
				}

				if (
					$('.approachPDP').length > 0 &&
					$('.approachPDP--code').length <= 0
				) {
					if (activeProduct.color == 'Satin Nickel') {
						target.find('.al2Prod__finishName').text('Silver');
					}
				}

				var formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				});
				var formatPrice = (activeProduct.price / 100).toFixed(2);
				var price = formatter.format(formatPrice);
				target.find('.al2Prod__price').text(price);
				target
					.find('.al2Prod__buyButton')
					.attr('data-id', activeProduct.id);
				target
					.find('.al2Prod__buyButton')
					.attr('data-keyed', activeProduct.keyedalike);

				if ('title' in activeProduct) {
					var textTitle = activeProduct.title;
					target.find('.al2Prod__title').text(textTitle);
				}

				if (
					target
						.find('[data-key-option="keyed"]')
						.hasClass('al2Prod__keyOptionButton--active')
				) {
					target.find('.al2Prod__accessCard--key').show();
				} else {
					target.find('.al2Prod__accessCard--key').hide();
				}
				target.find('.smartPDP__learn').attr('href', activeProduct.url);

				target
					.closest('.al2Prod')
					.find('.notifyMe__submit')
					.attr('data-variant', activeProduct.id);
				target
					.closest('.al2Prod')
					.find('.notifyMe__submit')
					.attr('data-product', activeProduct.prodId);
				console.log(activeProduct);

				if (activeProduct.available == 'false') {
					target
						.find('.al2Prod__buyButton')
						.addClass('al2Prod__buyButton--soldOut')
						.text('Sold Out');
					target.find('.smartPDP__buyWrapper').hide();
					target
						.find('.al2Prod__buyButtonRow')
						.addClass('al2Prod__buyButtonRow--soldOut');
					target.closest('.al2Prod').find('.notifyMe').slideDown();
					target
						.find('.al2Prod__learnButton')
						.attr('style', 'margin-left:0;margin-bottom:15px;');
				} else {
					target
						.find('.al2Prod__buyButton')
						.removeClass('al2Prod__buyButton--soldOut')
						.text('Buy Now');
					target.find('.smartPDP__buyWrapper').show();
					target
						.find('.al2Prod__buyButtonRow')
						.removeClass('al2Prod__buyButtonRow--soldOut');
					target.closest('.al2Prod').find('.notifyMe').slideUp();
					target.find('.al2Prod__learnButton').attr('style', '');
				}
			}

			$('.al2Prod').each(function () {
				var thisThing = $(this);
				var selectedProduct = getActiveProductInfo(thisThing);
				setActiveProduct(thisThing, selectedProduct);
				//showCheck(thisThing);
			});

			$('.al2Prod__colorButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__colorButton')
					.removeClass('al2Prod__colorButton--active');
				thisThing.addClass('al2Prod__colorButton--active');

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);
				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				var targets = thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__slideImg');
				targets.each(function(){
					if (thisThing.attr('data-color').toLowerCase().indexOf('black') >= 0){
						$(this).attr('src', $(this).attr('src-black'));
					}
					else if (thisThing.attr('data-color').toLowerCase().indexOf('bronze') >= 0){
						$(this).attr('src', $(this).attr('src-bronze'));
					}
					else if (thisThing.attr('data-color').toLowerCase().indexOf('silver') >= 0 || thisThing.attr('data-color').toLowerCase().indexOf('nickel') >= 0){
						$(this).attr('src', $(this).attr('src-silver'));
					}
					else if (thisThing.attr('data-color').toLowerCase().indexOf('magenta') >= 0){
						$(this).attr('src', $(this).attr('src-magenta'));
					}
					else if (thisThing.attr('data-color').toLowerCase().indexOf('snow') >= 0){
						$(this).attr('src', $(this).attr('src-snow'));
					}
					else if (thisThing.attr('data-color').toLowerCase().indexOf('ash') >= 0){
						$(this).attr('src', $(this).attr('src-ash'));
					}
				});
			});

			$('.al2Prod__prodButton').on('click', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				//change active class
				thisThing
					.parent()
					.find('.al2Prod__prodButton')
					.removeClass('al2Prod__prodButton--active');
				thisThing.addClass('al2Prod__prodButton--active');

				//show magenta color on some, hide on others
				if (
					parentContainer.find(
						'.al2Prod__colorButton[data-color="Viva Magenta"]'
					).length > 0
				) {
					if (
						parentContainer
							.find('.al2Prod__techButton--active')
							.attr('data-tech-option') == 'wifi' &&
						parentContainer
							.find('.al2Prod__keyOptionButton--active')
							.attr('data-key-option') == 'key-free' &&
						parentContainer
							.find('.al2Prod__prodButton--active')
							.attr('data-prod-option') == 'touchscreen'
					) {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.show();
					} else {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.hide();
						if (
							parentContainer
								.find(
									'.al2Prod__colorButton[data-color="Viva Magenta"]'
								)
								.hasClass('al2Prod__colorButton--active')
						) {
							parentContainer
								.find('.al2Prod__colorButton')
								.removeClass('al2Prod__colorButton--active');
							parentContainer
								.find('.al2Prod__colorButton')
								.first()
								.addClass('al2Prod__colorButton--active');
						}
					}
				}

				//set the active product for the buy code
				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();

				if (thisThing.attr('data-prod-option') === 'bluetooth') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-bluetooth');
					parentContainer.find('.al2Prod__list').html(newHtml);

					parentContainer.find('.al2Prod__accessCard--wifi').hide();
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.hide();
					$('.assure-works').slideUp();

					if ($('.approachPDP').length > 0) {
						if ($('.approachPDP--keypad').length > 0) {
							if (
								$('[data-key-option="key-free"]').hasClass(
									'al2Prod__keyOptionButton--active'
								)
							) {
								var newHtmlTwo = parentContainer
									.find('.al2Prod__techContent')
									.attr('data-bluetooth');
								parentContainer
									.find('.al2Prod__techContent')
									.html(newHtmlTwo);
							} else {
								var newHtmlTwo = parentContainer
									.find('.al2Prod__techContent')
									.attr('data-touchpad');
								parentContainer
									.find('.al2Prod__techContent')
									.html(newHtmlTwo);
							}
						} else {
							var newHtmlTwo = parentContainer
								.find('.al2Prod__techContent')
								.attr('data-bluetooth');
							parentContainer
								.find('.al2Prod__techContent')
								.html(newHtmlTwo);
						}
					}
				} else if (thisThing.attr('data-prod-option') === 'wifi') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-wifi');
					parentContainer.find('.al2Prod__list').html(newHtml);
					if ($('.approachPDP').length > 0) {
						var newHtmlTwo = parentContainer
							.find('.al2Prod__techContent')
							.attr('data-wifi');
						parentContainer
							.find('.al2Prod__techContent')
							.html(newHtmlTwo);
					}
					parentContainer.find('.al2Prod__accessCard--wifi').show();
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.show();
					$('.assure-works').slideDown();
				}
			});

			$('.al2Prod__colorButton[data-color="Viva Magenta"]').hide();

			$('#shopify-section-hdProduct1')
				.find('.al2Prod__colorButton--active')
				.click();

			$('.al2Prod__keyOptionButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__keyOptionButton')
					.removeClass('al2Prod__keyOptionButton--active');
				thisThing.addClass('al2Prod__keyOptionButton--active');

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				if (
					parentContainer.find(
						'.al2Prod__colorButton[data-color="Viva Magenta"]'
					).length > 0
				) {
					if (
						parentContainer
							.find('.al2Prod__techButton--active')
							.attr('data-tech-option') == 'wifi' &&
						parentContainer
							.find('.al2Prod__keyOptionButton--active')
							.attr('data-key-option') == 'key-free' &&
						parentContainer
							.find('.al2Prod__prodButton--active')
							.attr('data-prod-option') == 'touchscreen'
					) {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.show();
					} else {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.hide();
						if (
							parentContainer
								.find(
									'.al2Prod__colorButton[data-color="Viva Magenta"]'
								)
								.hasClass('al2Prod__colorButton--active')
						) {
							parentContainer
								.find('.al2Prod__colorButton')
								.removeClass('al2Prod__colorButton--active');
							parentContainer
								.find('.al2Prod__colorButton')
								.first()
								.addClass('al2Prod__colorButton--active');
						}
					}
				}

				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();
			});

			$('.al2Prod__keyOptionButton').on('mousedown', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');

				if ($('.approachPDP').length > 0) {
					console.log('mouseup');
					if ($(this).attr('data-key-option') == 'key-free') {
						var newHtml = parentContainer
							.find('.al2Prod__list')
							.attr('data-bluetooth');
						parentContainer.find('.al2Prod__list').html(newHtml);
						var newHtmlTwo = parentContainer
							.find('.al2Prod__techContent')
							.attr('data-bluetooth');
						parentContainer
							.find('.al2Prod__techContent')
							.html(newHtmlTwo);
					} else {
						var newHtml = parentContainer
							.find('.al2Prod__list')
							.attr('data-touchpad');
						parentContainer.find('.al2Prod__list').html(newHtml);
						var newHtmlTwo = parentContainer
							.find('.al2Prod__techContent')
							.attr('data-touchpad');
						parentContainer
							.find('.al2Prod__techContent')
							.html(newHtmlTwo);
					}
				}
			});

			$('.al2Prod__techButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__techButton')
					.removeClass('al2Prod__techButton--active');
				thisThing.addClass('al2Prod__techButton--active');

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				if (
					parentContainer.find(
						'.al2Prod__colorButton[data-color="Viva Magenta"]'
					).length > 0
				) {
					if (
						parentContainer
							.find('.al2Prod__techButton--active')
							.attr('data-tech-option') == 'wifi' &&
						parentContainer
							.find('.al2Prod__keyOptionButton--active')
							.attr('data-key-option') == 'key-free' &&
						parentContainer
							.find('.al2Prod__prodButton--active')
							.attr('data-prod-option') == 'touchscreen'
					) {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.show();
					} else {
						parentContainer
							.find(
								'.al2Prod__colorButton[data-color="Viva Magenta"]'
							)
							.hide();
						if (
							parentContainer
								.find(
									'.al2Prod__colorButton[data-color="Viva Magenta"]'
								)
								.hasClass('al2Prod__colorButton--active')
						) {
							parentContainer
								.find('.al2Prod__colorButton')
								.removeClass('al2Prod__colorButton--active');
							parentContainer
								.find('.al2Prod__colorButton')
								.first()
								.addClass('al2Prod__colorButton--active');
						}
					}
				}

				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				if (thisThing.attr('data-tech-option') === 'bluetooth') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-bluetooth');
					parentContainer.find('.al2Prod__list').html(newHtml);
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.hide();
				} else if (thisThing.attr('data-tech-option') === 'wifi') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-wifi');
					parentContainer.find('.al2Prod__list').html(newHtml);
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.show();
				}

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();
			});

			$('.smartPDP__qtyBox input').on('change', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				showCheck(parentContainer);
			});

			var CartJSInterval = setInterval(function () {
				if (typeof CartJS.cart.items !== 'undefined') {
					$('.al2Prod').each(function () {
						var thisThing = $(this);
						showCheck(thisThing);
					});
					clearInterval(CartJSInterval);
				}
			}, 10);

			function showCheck(targetSection) {
				var keyed = targetSection
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-key-option');
				var selectedType = targetSection
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-type');
				if ($('.approachPDP--code').length > 0) {
					keyed = 'keyed';
					selectedType = 'Smart Lock';
				}

				//show-hide keyed alike box
				if (keyed == 'keyed') {
					var count = 0;
					var type = 0;
					for (i = 0; i < CartJS.cart.items.length; i++) {
						if (
							CartJS.cart.items[i].properties[
								'_keyed_alike_available'
							] == 'true'
						) {
							var qty = CartJS.cart.items[i].quantity;
							count += 1;
						}
						if (type == '') {
							if (
								CartJS.cart.items[i].properties[
									'_keyed_alike_group'
								] > 0
							) {
								type = CartJS.cart.items[i].product_type;
							}
						}
					}

					if (type == '' || compareProdTypes(selectedType, type)) {
						if (targetSection.find('.smartPDP__qty').val() > 1) {
							targetSection.find('.pdpKA--assureLanding').show();
							targetSection
								.find('.pdpKA--assureLanding')
								.attr('data-type', selectedType);
						} else if (count > 0) {
							targetSection.find('.pdpKA--assureLanding').show();
							targetSection
								.find('.pdpKA--assureLanding')
								.attr('data-type', selectedType);
						} else {
							targetSection.find('.pdpKA--assureLanding').hide();
							targetSection
								.find('.pdpKA__checkbox')
								.prop('checked', false);
						}
					} else {
						targetSection.find('.pdpKA--assureLanding').hide();
						targetSection
							.find('.pdpKA__checkbox')
							.prop('checked', false);
					}
				} else {
					targetSection.find('.pdpKA--assureLanding').hide();
					targetSection
						.find('.pdpKA__checkbox')
						.prop('checked', false);
				}
			}

			$('.pdpKAPop__continueButton').on('click', function () {
				var itemsToGroup = [];
				var newKAItemCount = 0;
				var type = '';
				type = $(this)
					.closest('.shopify-section')
					.find('.pdpKA__inner')
					.parent()
					.attr('data-type');

				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties[
							'_keyed_alike_available'
						] == 'true'
					) {
						if (
							compareProdTypes(
								CartJS.cart.items[i].product_type,
								type
							)
						) {
							itemsToGroup.push({
								id: CartJS.cart.items[i].id,
								quantity: CartJS.cart.items[i].quantity,
								properties: {
									_name: 'keyed_alike_group',
									_value: 1,
									_keyed_alike_group: 1,
									_keyed_alike_available: 'true',
									_requested_ship_date: getNearestWeekdayTwoDaysAhead()
								},
							});
							newKAItemCount += CartJS.cart.items[i].quantity * 1;
						}
					}
				}

				for (j = 0; j < itemsToGroup.length; j++) {
					CartJS.removeItemById(itemsToGroup[j].id);
				}

				itemsToGroup.push({
					id: 32146864832644,
					quantity: newKAItemCount,
					properties: {
						_groups: 1,
					},
				});

				CartJS.addItems(itemsToGroup, {
					success: function (data, textStatus, jqXHR) {
						updateCart(true);
						$('.pdpKAPop').fadeOut();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				});
			});

			$('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
				'click',
				function () {
					$('.pdpKAPop').fadeOut();
				}
			);

			function newKeyedSkipPopup(reference) {
				var groupCount = 0;
				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties['_name'] ==
						'keyed_alike_group'
					) {
						var qty = CartJS.cart.items[i].quantity;
						groupCount += 1;
					}
					if (CartJS.cart.items[i].properties['_groups'] * 1 > 1) {
						$('.pdpKAPop__addToExisting').hide();
					}
				}
				console.log(groupCount);
				if (groupCount > 0) {
					$('.pdpKAPop__inner--existing').show();
					$('.pdpKAPop__inner--new').hide();
					reference
						.closest('.shopify-section')
						.find('.pdpKAPop')
						.show();
				} else {
					if (
						$('#cartDrawer').find(
							'.cart-item[data-variant-id="32146864832644"]'
						).length > 0
					) {
						console.log('there is already a key in the cart');
					} else {
						var _itemsToGroup = [];
						var _newKAItemCount = 0;
						var firstType = '';
						for (i = 0; i < CartJS.cart.items.length; i++) {
							if (i == 0) {
								firstType =
									CartJS.cart.items[i]['product_type'];
							}
							if (
								CartJS.cart.items[i].properties[
									'_keyed_alike_available'
								] == 'true'
							) {
								if (
									compareProdTypes(
										CartJS.cart.items[i]['product_type'],
										firstType
									)
								) {
									_itemsToGroup.push({
										id: CartJS.cart.items[i].id,
										quantity: CartJS.cart.items[i].quantity,
										properties: {
											_name: 'keyed_alike_group',
											_value: 1,
											_keyed_alike_group: 1,
											_keyed_alike_available: 'true',
											_type: firstType,
											_requested_ship_date: getNearestWeekdayTwoDaysAhead()
										},
									});
									_newKAItemCount +=
										CartJS.cart.items[i].quantity * 1;
								}
							}
						}

						for (j = 0; j < _itemsToGroup.length; j++) {
							CartJS.removeItemById(_itemsToGroup[j].id);
						}

						_itemsToGroup.push({
							id: 32146864832644,
							quantity: _newKAItemCount,
							properties: {
								_groups: 1,
								_type: firstType,
							},
						});

						console.log('about');
						CartJS.addItems(_itemsToGroup, {
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
								$('.pdpKAPop').fadeOut();
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						});
					}

					/*
          $('.pdpKAPop__inner--existing').hide();
          $('.pdpKAPop__inner--new').show();
          */
				}
			}

			$('.al2Prod__buyButton').on('click', function () {
				var oldCart = CartJS.cart.item_count * 1;
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				if ($(this).hasClass('al2Prod__buyButton--soldOut')) {
				} else {
					var varId = $(this).attr('data-id') * 1;
					var qty = $(this)
						.closest('.al2Prod__buyButtonRow')
						.find('.smartPDP__qty')
						.val();
					if ($(this).attr('data-keyed') == 'true') {
						addToCart(varId, qty, true);
						if (
							parentContainer
								.find('.pdpKA__checkbox')
								.prop('checked')
						) {
							var keyCartWatch = setInterval(function () {
								if (CartJS.cart.item_count != oldCart) {
									newKeyedSkipPopup(thisThing);
									clearInterval(keyCartWatch);
								}
							}, 50);
						}
					} else {
						addToCart(varId, qty);
					}
				}
			});

			$('.al2Prod__accessButton').on('click', function () {
				if ($(this).hasClass('al2Prod__accessButton--active')) {
					$(this).removeClass('al2Prod__accessButton--active');
					$(this).parent().find('.al2Prod__accessShelf').slideUp();
				} else {
					$(this).addClass('al2Prod__accessButton--active');
					$(this).parent().find('.al2Prod__accessShelf').slideDown();
				}
			});

			$('.al2Prod__techTitleButton').on('click', function () {
				if ($(this).hasClass('al2Prod__techTitleButton--active')) {
					$(this).removeClass('al2Prod__techTitleButton--active');
					$(this).parent().find('.al2Prod__techShelf').slideUp();
				} else {
					$(this).addClass('al2Prod__techTitleButton--active');
					$(this).parent().find('.al2Prod__techShelf').slideDown();
				}
			});

			$('.al2App__button').each(function () {
				preloadImage($(this).attr('data-image'));
			});

			$('.al2App__button').on('click', function () {
				$(this)
					.parent()
					.find('.al2App__button')
					.removeClass('al2App__button--active');
				$(this).addClass('al2App__button--active');

				var imgSrc = $(this).attr('data-image');
				$('.al2App__image').attr('src', imgSrc);
			});

			$('.al2MobApp__topSlider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				asNavFor: '.al2MobApp__bottomSlider',
			});

			$('.al2MobApp__bottomSlider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				adaptiveHeight: true,
				dots: false,
				asNavFor: '.al2MobApp__topSlider',
			});

			$('.al2MobTable__dropTitle').on('click', function () {
				var target = $(this).parent();
				if (target.hasClass('al2MobTable__dropWrapper--active')) {
					target.removeClass('al2MobTable__dropWrapper--active');
					target.find('.al2MobTable__dropShelf').slideUp();
				} else {
					target.addClass('al2MobTable__dropWrapper--active');
					target.find('.al2MobTable__dropShelf').slideDown();
				}
			});
			$('.al2MobTable__dropOption').on('click', function () {
				var newText = $(this).text();
				var dataType = $(this).attr('data-type');
				var target = $(this).closest('.al2MobTable__dropWrapper');
				target.removeClass('al2MobTable__dropWrapper--active');
				target.find('.al2MobTable__dropShelf').slideUp();
				target.find('.al2MobTable__dropTitle span').text(newText);
				if (target.hasClass('al2MobTable__dropWrapper--left')) {
					$('.al2MobTable__cell--left').each(function () {
						if (dataType == 'standard') {
							$(this)
								.find('span')
								.text($(this).attr('data-standard'));
						} else if (dataType == 'wifi') {
							$(this)
								.find('span')
								.text($(this).attr('data-wifi'));
						} else {
							$(this)
								.find('span')
								.text($(this).attr('data-zwave'));
						}
					});
				} else {
					$('.al2MobTable__cell--right').each(function () {
						if (dataType == 'standard') {
							$(this)
								.find('span')
								.text($(this).attr('data-standard'));
						} else if (dataType == 'wifi') {
							$(this)
								.find('span')
								.text($(this).attr('data-wifi'));
						} else {
							$(this)
								.find('span')
								.text($(this).attr('data-zwave'));
						}
					});
				}
			});

			$('.al2Prod--2')
				.find('.al2Prod__keyOptionButton[data-key-option="key-free"]')
				.click();
		}

		if ($('.al2Prod--matter2025').length > 0) {
			$('.al2Prod__slider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
			});

			function addToCart(variant, qty, keyed) {
				if (checkDiscountLimitFull(variant)) {
					alert(
						'You can only order up to ' +
							$('body').attr('data-qty-limit') * 1 +
							' discounted items.'
					);
					return;
				}
				if (typeof keyed !== 'undefined' && keyed) {
					CartJS.addItem(
						variant,
						qty,
						{ _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
						{
							success: function (data, textStatus, jqXHR) {
								setTimeout(function () {
									updateCart(true);
								}, 200);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				} else {
					CartJS.addItem(
						variant,
						qty,
						{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
						{
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			}

			if (typeof createLib === 'function') {
				var libs1 = createLib();
				console.log(libs1);
			}

			function colorSetup(target) {
				$(target)
					.find('.al2Prod__colorButton')
					.each(function () {
						var thisThing = $(this);
						var fullParent = thisThing.closest('.al2Prod');
						if (thisThing.attr('data-color') == 'false') {
							thisThing.hide();
						} else {
							thisThing.show();
							var ctarget = libs1.colors.find(
								(x) => x.title === thisThing.attr('data-color')
							);

							if (ctarget) {
								thisThing
									.find('.al2Prod__colorButtonInner')
									.attr(
										'style',
										'background-image:url(' +
											ctarget.src +
											')'
									);
							}
						}
					});
			}

			colorSetup('.al2Prod--1');

			function getActiveProductInfo(target) {
				var prodOption = target
					.find('.al2Prod__prodButton--active')
					.attr('data-prod-option');
				var keyOption = target
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-key-option');
				var colorOption = target
					.find('.al2Prod__colorButton--active')
					.attr('data-color');
				if (target.hasClass('al2Prod--1')) {
					var lib = libs1;
				} else if (target.hasClass('al2Prod--2')) {
					var lib = libs2;
				} else {
					var lib = libs3;
				}
				for (i = 0; i < lib.products.length; i++) {
					var descString = lib.products[i]['prod-desc'].toLowerCase();

					var optionArray = descString.split(' ');
					if (
						prodOption == optionArray[0] &&
						keyOption == optionArray[1]
					) {
						var variant = false;
						if (
							lib.products[i]['option-one'].toLowerCase() ==
								'finish' ||
							lib.products[i]['option-one'].toLowerCase() ==
								'color'
						) {
							var variant = lib.products[i].variants.find(
								(x) => x['option-one'] === colorOption
							);
						} else if (
							lib.products[i]['option-two'].toLowerCase() ==
								'finish' ||
							lib.products[i]['option-two'].toLowerCase() ==
								'color'
						) {
							var variant = lib.products[i].variants.find(
								(x) => x['option-two'] === colorOption
							);
						} else {
							var variant = lib.products[i].variants.find(
								(x) => x['option-three'] === colorOption
							);
						}
						if (variant) {
							var variantId = variant.id;
							var variantImg = variant.image;
							var variantPrice = variant.price;
							var variantAvailable = variant.available;
							var variantUrl = variant.url;
							var variantProdId = variant['prod-id'];
							var variantKeyed = variant.keyedalike;
							var variantTitle = false;
							var prodHandle = variant['prod-handle'];
						}
						if ('title' in lib.products[i]) {
							variantTitle = lib.products[i].title;
						}
					}
				}
				if (variant) {
					var selectedProductInfo = {
						productHandle: prodHandle,
						productOption: prodOption,
						keyOption: keyOption,
						color: colorOption,
						id: variantId,
						image: variantImg,
						price: variantPrice,
						available: variantAvailable,
						url: variantUrl,
						prodId: variantProdId,
						keyedalike: variantKeyed,
					};
					if (
						target.find('.al2Prod__techButton--active').length > 0
					) {
						selectedProductInfo['techOption'] = target
							.find('.al2Prod__techButton--active')
							.attr('data-tech-option');
					}
					if (variantTitle) {
						selectedProductInfo['title'] = variantTitle;
					}
				} else {
					var selectedProductInfo = false;
				}

				if (selectedProductInfo) {
					fetch(
						window.Shopify.routes.root +
							'products/' +
							prodHandle +
							'.js'
					)
						.then((response) => response.json())
						.then(
							(product) =>
								function () {
									window.dataLayer.push({ ecommerce: null });
									window.dataLayer.push({
										event: 'view_item',
										fired_from: 'shopify',
										ecommerce: {
											currency: 'USD',
											value: product.price,
											items: [
												{
													item_id: product.id,
													item_name: product.title,
													item_brand: product.vendor,
													item_category: product.type,
													item_variant:
														product.variants[0]
															.title,
													item_variant_id:
														product.variants[0].sku,
													price: product.price,
													quantity: 1,
												},
											],
										},
									});
								}
						);
				}

				return selectedProductInfo;
			}

			function preloadImage(url) {
				var img = new Image();
				img.src = url;
			}

			if (typeof createLib === 'function') {
				for (i = 0; i < libs1.images.length; i++) {
					preloadImage(libs1.images[i].srcSnow);
					preloadImage(libs1.images[i].srcBlack);
					preloadImage(libs1.images[i].srcAsh);
				}
			}

			function setActiveProduct(target, activeProduct) {
				if (activeProduct == 'false' || activeProduct == false) {
					console.log('error - no active product found');
					return false;
				}
				var lib = libs1;

				console.log(lib.images);

				var matchString =
					activeProduct.productOption + '/' + activeProduct.keyOption;

				for (i = 0; i < lib.images.length; i++) {
					if (lib.images[i].product == matchString) {
						if (lib.images[i].order == '1') {
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-snow', lib.images[i].srcSnow);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="1"]')
								.find('img')
								.attr('src-ash', lib.images[i].srcAsh);
						} else if (lib.images[i].order == '2') {
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-snow', lib.images[i].srcSnow);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="2"]')
								.find('img')
								.attr('src-ash', lib.images[i].srcAsh);
						} else if (lib.images[i].order == '3') {
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-snow', lib.images[i].srcSnow);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="3"]')
								.find('img')
								.attr('src-ash', lib.images[i].srcAsh);
						} else {
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-snow', lib.images[i].srcSnow);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-black', lib.images[i].srcBlack);
							target
								.find('[data-order="4"]')
								.find('img')
								.attr('src-ash', lib.images[i].srcAsh);
						}
					}
				}

				target.find('.al2Prod__finishName').text(activeProduct.color);

				var formatter = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				});
				var formatPrice = (activeProduct.price / 100).toFixed(2);
				var price = formatter.format(formatPrice);
				target.find('.al2Prod__price').text(price);
				target
					.find('.al2Prod__buyButton')
					.attr('data-id', activeProduct.id);
				target
					.find('.al2Prod__buyButton')
					.attr('data-keyed', activeProduct.keyedalike);

				if ('title' in activeProduct) {
					var textTitle = activeProduct.title;
					target.find('.al2Prod__title').text(textTitle);
				}

				if (
					target
						.find('[data-key-option="keyed"]')
						.hasClass('al2Prod__keyOptionButton--active')
				) {
					target.find('.al2Prod__accessCard--key').show();
				} else {
					target.find('.al2Prod__accessCard--key').hide();
				}
				target.find('.smartPDP__learn').attr('href', activeProduct.url);

				target
					.closest('.al2Prod')
					.find('.notifyMe__submit')
					.attr('data-variant', activeProduct.id);
				target
					.closest('.al2Prod')
					.find('.notifyMe__submit')
					.attr('data-product', activeProduct.prodId);
				console.log(activeProduct);

				if (activeProduct.available == 'false') {
					target
						.find('.al2Prod__buyButton')
						.addClass('al2Prod__buyButton--soldOut')
						.text('Sold Out');
					target.find('.smartPDP__buyWrapper').hide();
					target
						.find('.al2Prod__buyButtonRow')
						.addClass('al2Prod__buyButtonRow--soldOut');
					target.closest('.al2Prod').find('.notifyMe').slideDown();
					target
						.find('.al2Prod__learnButton')
						.attr('style', 'margin-left:0;margin-bottom:15px;');
				} else {
					target
						.find('.al2Prod__buyButton')
						.removeClass('al2Prod__buyButton--soldOut')
						.text('Buy Now');
					target.find('.smartPDP__buyWrapper').show();
					target
						.find('.al2Prod__buyButtonRow')
						.removeClass('al2Prod__buyButtonRow--soldOut');
					target.closest('.al2Prod').find('.notifyMe').slideUp();
					target.find('.al2Prod__learnButton').attr('style', '');
				}
			}

			$('.al2Prod').each(function () {
				var thisThing = $(this);
				var selectedProduct = getActiveProductInfo(thisThing);
				setActiveProduct(thisThing, selectedProduct);
				//showCheck(thisThing);
			});

			$('.al2Prod__colorButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__colorButton')
					.removeClass('al2Prod__colorButton--active');
				thisThing.addClass('al2Prod__colorButton--active');

				if (thisThing.hasClass('al2Prod__colorButton--comingSoon')) {
					$('.al2Prod__comingSoon').addClass(
						'al2Prod__comingSoon--show'
					);
				} else {
					$('.al2Prod__comingSoon').removeClass(
						'al2Prod__comingSoon--show'
					);
				}

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);
				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				var targets = thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__slideImg');
				targets.each(function () {
					if (
						thisThing
							.attr('data-color')
							.toLowerCase()
							.indexOf('snow') >= 0
					) {
						$(this).attr('src', $(this).attr('src-snow'));
					} else if (
						thisThing
							.attr('data-color')
							.toLowerCase()
							.indexOf('black') >= 0
					) {
						$(this).attr('src', $(this).attr('src-black'));
					} else if (
						thisThing
							.attr('data-color')
							.toLowerCase()
							.indexOf('ash') >= 0
					) {
						$(this).attr('src', $(this).attr('src-ash'));
					}
				});
			});

			$('.al2Prod__prodButton').on('click', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				//change active class
				thisThing
					.parent()
					.find('.al2Prod__prodButton')
					.removeClass('al2Prod__prodButton--active');
				thisThing.addClass('al2Prod__prodButton--active');

				//set the active product for the buy code
				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();
			});

			$('.al2Prod__colorButton--active').click();

			$('.al2Prod__keyOptionButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__keyOptionButton')
					.removeClass('al2Prod__keyOptionButton--active');
				thisThing.addClass('al2Prod__keyOptionButton--active');

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();
			});

			$('.al2Prod__keyOptionButton').on('mousedown', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');

				if ($('.approachPDP').length > 0) {
					console.log('mouseup');
					if ($(this).attr('data-key-option') == 'key-free') {
						var newHtml = parentContainer
							.find('.al2Prod__list')
							.attr('data-bluetooth');
						parentContainer.find('.al2Prod__list').html(newHtml);
						var newHtmlTwo = parentContainer
							.find('.al2Prod__techContent')
							.attr('data-bluetooth');
						parentContainer
							.find('.al2Prod__techContent')
							.html(newHtmlTwo);
					} else {
						var newHtml = parentContainer
							.find('.al2Prod__list')
							.attr('data-touchpad');
						parentContainer.find('.al2Prod__list').html(newHtml);
						var newHtmlTwo = parentContainer
							.find('.al2Prod__techContent')
							.attr('data-touchpad');
						parentContainer
							.find('.al2Prod__techContent')
							.html(newHtmlTwo);
					}
				}
			});

			$('.al2Prod__techButton').on('click', function () {
				var thisThing = $(this);
				thisThing
					.parent()
					.find('.al2Prod__techButton')
					.removeClass('al2Prod__techButton--active');
				thisThing.addClass('al2Prod__techButton--active');

				var parentContainer = thisThing.closest('.al2Prod');
				var selectedProduct = getActiveProductInfo(parentContainer);

				setActiveProduct(parentContainer, selectedProduct);
				showCheck(parentContainer);

				if (thisThing.attr('data-tech-option') === 'bluetooth') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-bluetooth');
					parentContainer.find('.al2Prod__list').html(newHtml);
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.hide();
				} else if (thisThing.attr('data-tech-option') === 'wifi') {
					var newHtml = parentContainer
						.find('.al2Prod__list')
						.attr('data-wifi');
					parentContainer.find('.al2Prod__list').html(newHtml);
					parentContainer
						.find('.al2Prod__worksIconWrapper--wifi')
						.show();
				}

				thisThing
					.closest('.al2Prod__inner')
					.find('.al2Prod__colorButton--active')
					.click();
			});

			$('.smartPDP__qtyBox input').on('change', function () {
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				showCheck(parentContainer);
			});

			var CartJSInterval = setInterval(function () {
				if (typeof CartJS.cart.items !== 'undefined') {
					$('.al2Prod').each(function () {
						var thisThing = $(this);
						showCheck(thisThing);
					});
					clearInterval(CartJSInterval);
				}
			}, 10);

			function showCheck(targetSection) {
				var keyed = targetSection
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-key-option');
				var selectedType = targetSection
					.find('.al2Prod__keyOptionButton--active')
					.attr('data-type');

				//show-hide keyed alike box
				if (keyed == 'keyed') {
					var count = 0;
					var type = 0;
					for (i = 0; i < CartJS.cart.items.length; i++) {
						if (
							CartJS.cart.items[i].properties[
								'_keyed_alike_available'
							] == 'true'
						) {
							var qty = CartJS.cart.items[i].quantity;
							count += 1;
						}
						if (type == '') {
							if (
								CartJS.cart.items[i].properties[
									'_keyed_alike_group'
								] > 0
							) {
								type = CartJS.cart.items[i].product_type;
							}
						}
					}

					if (type == '' || compareProdTypes(selectedType, type)) {
						if (targetSection.find('.smartPDP__qty').val() > 1) {
							targetSection.find('.pdpKA--assureLanding').show();
							targetSection
								.find('.pdpKA--assureLanding')
								.attr('data-type', selectedType);
						} else if (count > 0) {
							targetSection.find('.pdpKA--assureLanding').show();
							targetSection
								.find('.pdpKA--assureLanding')
								.attr('data-type', selectedType);
						} else {
							targetSection.find('.pdpKA--assureLanding').hide();
							targetSection
								.find('.pdpKA__checkbox')
								.prop('checked', false);
						}
					} else {
						targetSection.find('.pdpKA--assureLanding').hide();
						targetSection
							.find('.pdpKA__checkbox')
							.prop('checked', false);
					}
				} else {
					targetSection.find('.pdpKA--assureLanding').hide();
					targetSection
						.find('.pdpKA__checkbox')
						.prop('checked', false);
				}
			}

			$('.pdpKAPop__continueButton').on('click', function () {
				var itemsToGroup = [];
				var newKAItemCount = 0;
				var type = '';
				type = $(this)
					.closest('.shopify-section')
					.find('.pdpKA__inner')
					.parent()
					.attr('data-type');

				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties[
							'_keyed_alike_available'
						] == 'true'
					) {
						if (
							compareProdTypes(
								CartJS.cart.items[i].product_type,
								type
							)
						) {
							itemsToGroup.push({
								id: CartJS.cart.items[i].id,
								quantity: CartJS.cart.items[i].quantity,
								properties: {
									_name: 'keyed_alike_group',
									_value: 1,
									_keyed_alike_group: 1,
									_keyed_alike_available: 'true',
									_requested_ship_date: getNearestWeekdayTwoDaysAhead()
								},
							});
							newKAItemCount += CartJS.cart.items[i].quantity * 1;
						}
					}
				}

				for (j = 0; j < itemsToGroup.length; j++) {
					CartJS.removeItemById(itemsToGroup[j].id);
				}

				itemsToGroup.push({
					id: 32146864832644,
					quantity: newKAItemCount,
					properties: {
						_groups: 1,
					},
				});

				CartJS.addItems(itemsToGroup, {
					success: function (data, textStatus, jqXHR) {
						updateCart(true);
						$('.pdpKAPop').fadeOut();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				});
			});

			$('.pdpKAPop__close, .pdpKAPop__no, .pdpKAPop__background').on(
				'click',
				function () {
					$('.pdpKAPop').fadeOut();
				}
			);

			function newKeyedSkipPopup(reference) {
				var groupCount = 0;
				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties['_name'] ==
						'keyed_alike_group'
					) {
						var qty = CartJS.cart.items[i].quantity;
						groupCount += 1;
					}
					if (CartJS.cart.items[i].properties['_groups'] * 1 > 1) {
						$('.pdpKAPop__addToExisting').hide();
					}
				}
				console.log(groupCount);
				if (groupCount > 0) {
					$('.pdpKAPop__inner--existing').show();
					$('.pdpKAPop__inner--new').hide();
					reference
						.closest('.shopify-section')
						.find('.pdpKAPop')
						.show();
				} else {
					if (
						$('#cartDrawer').find(
							'.cart-item[data-variant-id="32146864832644"]'
						).length > 0
					) {
						console.log('there is already a key in the cart');
					} else {
						var _itemsToGroup = [];
						var _newKAItemCount = 0;
						var firstType = '';
						for (i = 0; i < CartJS.cart.items.length; i++) {
							if (i == 0) {
								firstType =
									CartJS.cart.items[i]['product_type'];
							}
							if (
								CartJS.cart.items[i].properties[
									'_keyed_alike_available'
								] == 'true'
							) {
								if (
									compareProdTypes(
										CartJS.cart.items[i]['product_type'],
										firstType
									)
								) {
									_itemsToGroup.push({
										id: CartJS.cart.items[i].id,
										quantity: CartJS.cart.items[i].quantity,
										properties: {
											_name: 'keyed_alike_group',
											_value: 1,
											_keyed_alike_group: 1,
											_keyed_alike_available: 'true',
											_type: firstType,
											_requested_ship_date: getNearestWeekdayTwoDaysAhead()
										},
									});
									_newKAItemCount +=
										CartJS.cart.items[i].quantity * 1;
								}
							}
						}

						for (j = 0; j < _itemsToGroup.length; j++) {
							CartJS.removeItemById(_itemsToGroup[j].id);
						}

						_itemsToGroup.push({
							id: 32146864832644,
							quantity: _newKAItemCount,
							properties: {
								_groups: 1,
								_type: firstType,
							},
						});

						console.log('about');
						CartJS.addItems(_itemsToGroup, {
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
								$('.pdpKAPop').fadeOut();
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						});
					}

					/*
          $('.pdpKAPop__inner--existing').hide();
          $('.pdpKAPop__inner--new').show();
          */
				}
			}

			$('.al2Prod__buyButton').on('click', function () {
				var oldCart = CartJS.cart.item_count * 1;
				console.log('buy now button pressed');
				var thisThing = $(this);
				var parentContainer = thisThing.closest('.al2Prod');
				if ($(this).hasClass('al2Prod__buyButton--soldOut')) {
				} else {
					var varId = $(this).attr('data-id') * 1;
					var qty = $(this)
						.closest('.al2Prod__buyButtonRow')
						.find('.smartPDP__qty')
						.val();
					if ($(this).attr('data-keyed') == 'true') {
						addToCart(varId, qty, true);
						if (
							parentContainer
								.find('.pdpKA__checkbox')
								.prop('checked')
						) {
							var keyCartWatch = setInterval(function () {
								if (CartJS.cart.item_count != oldCart) {
									newKeyedSkipPopup($(this));
									clearInterval(keyCartWatch);
								}
							}, 50);
						}
					} else {
						addToCart(varId, qty);
					}
				}
			});

			$('.al2Prod__accessButton').on('click', function () {
				if ($(this).hasClass('al2Prod__accessButton--active')) {
					$(this).removeClass('al2Prod__accessButton--active');
					$(this).parent().find('.al2Prod__accessShelf').slideUp();
				} else {
					$(this).addClass('al2Prod__accessButton--active');
					$(this).parent().find('.al2Prod__accessShelf').slideDown();
				}
			});

			$('.al2Prod__techTitleButton').on('click', function () {
				if ($(this).hasClass('al2Prod__techTitleButton--active')) {
					$(this).removeClass('al2Prod__techTitleButton--active');
					$(this).parent().find('.al2Prod__techShelf').slideUp();
				} else {
					$(this).addClass('al2Prod__techTitleButton--active');
					$(this).parent().find('.al2Prod__techShelf').slideDown();
				}
			});

			$('.al2App__button').each(function () {
				preloadImage($(this).attr('data-image'));
			});

			$('.al2App__button').on('click', function () {
				$(this)
					.parent()
					.find('.al2App__button')
					.removeClass('al2App__button--active');
				$(this).addClass('al2App__button--active');

				var imgSrc = $(this).attr('data-image');
				$('.al2App__image').attr('src', imgSrc);
			});

			$('.al2MobApp__topSlider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				asNavFor: '.al2MobApp__bottomSlider',
			});

			$('.al2MobApp__bottomSlider').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				adaptiveHeight: true,
				dots: false,
				asNavFor: '.al2MobApp__topSlider',
			});

			$('.al2MobTable__dropTitle').on('click', function () {
				var target = $(this).parent();
				if (target.hasClass('al2MobTable__dropWrapper--active')) {
					target.removeClass('al2MobTable__dropWrapper--active');
					target.find('.al2MobTable__dropShelf').slideUp();
				} else {
					target.addClass('al2MobTable__dropWrapper--active');
					target.find('.al2MobTable__dropShelf').slideDown();
				}
			});
			$('.al2MobTable__dropOption').on('click', function () {
				var newText = $(this).text();
				var dataType = $(this).attr('data-type');
				var target = $(this).closest('.al2MobTable__dropWrapper');
				target.removeClass('al2MobTable__dropWrapper--active');
				target.find('.al2MobTable__dropShelf').slideUp();
				target.find('.al2MobTable__dropTitle span').text(newText);
				if (target.hasClass('al2MobTable__dropWrapper--left')) {
					$('.al2MobTable__cell--left').each(function () {
						if (dataType == 'standard') {
							$(this)
								.find('span')
								.text($(this).attr('data-standard'));
						} else if (dataType == 'wifi') {
							$(this)
								.find('span')
								.text($(this).attr('data-wifi'));
						} else {
							$(this)
								.find('span')
								.text($(this).attr('data-zwave'));
						}
					});
				} else {
					$('.al2MobTable__cell--right').each(function () {
						if (dataType == 'standard') {
							$(this)
								.find('span')
								.text($(this).attr('data-standard'));
						} else if (dataType == 'wifi') {
							$(this)
								.find('span')
								.text($(this).attr('data-wifi'));
						} else {
							$(this)
								.find('span')
								.text($(this).attr('data-zwave'));
						}
					});
				}
			});

			$('.al2Prod--2')
				.find('.al2Prod__keyOptionButton[data-key-option="key-free"]')
				.click();
		}

		//end

		if ($('#smart-studio').length > 0) {
			var homeLib = createHomeArray();
			var doorLib = createDoorArray();
			var lockLib = createLockArray();
			var handleLib = createHandleArray();

			console.log(homeLib);
			console.log(doorLib);
			console.log(lockLib);
			console.log(handleLib);

			function preloadImage(url) {
				var img = new Image();
				img.src = url;
			}
			for (i = 0; i < homeLib.length; i++) {
				preloadImage(homeLib[i].mobile);
				preloadImage(homeLib[i].preview);
				preloadImage(homeLib[i].src);
				preloadImage(homeLib[i].zoomed);
				preloadImage(homeLib[i].zoomedMobile);
			}
			for (i = 0; i < doorLib.length; i++) {
				preloadImage(doorLib[i].preview);
				preloadImage(doorLib[i].srcs.black);
				preloadImage(doorLib[i].srcs.blue);
				preloadImage(doorLib[i].srcs.gray);
				preloadImage(doorLib[i].srcs.green);
				preloadImage(doorLib[i].srcs.pink);
				preloadImage(doorLib[i].srcs.red);
				preloadImage(doorLib[i].srcs.sage);
				preloadImage(doorLib[i].srcs.salmon);
				preloadImage(doorLib[i].srcs.teal);
				preloadImage(doorLib[i].srcs.white);
				preloadImage(doorLib[i].srcs.yellow);
				preloadImage(doorLib[i].srcs.midgray);
				preloadImage(doorLib[i].srcs.beige);
				preloadImage(doorLib[i].srcs.eggplant);
				preloadImage(doorLib[i].srcs.mobile_black);
				preloadImage(doorLib[i].srcs.mobile_blue);
				preloadImage(doorLib[i].srcs.mobile_gray);
				preloadImage(doorLib[i].srcs.mobile_green);
				preloadImage(doorLib[i].srcs.mobile_pink);
				preloadImage(doorLib[i].srcs.mobile_red);
				preloadImage(doorLib[i].srcs.mobile_sage);
				preloadImage(doorLib[i].srcs.mobile_salmon);
				preloadImage(doorLib[i].srcs.mobile_teal);
				preloadImage(doorLib[i].srcs.mobile_white);
				preloadImage(doorLib[i].srcs.mobile_yellow);
				preloadImage(doorLib[i].srcs.mobile_midgray);
				preloadImage(doorLib[i].srcs.mobile_beige);
				preloadImage(doorLib[i].srcs.mobile_eggplant);
				preloadImage(doorLib[i].srcs.zoom_black);
				preloadImage(doorLib[i].srcs.zoom_blue);
				preloadImage(doorLib[i].srcs.zoom_gray);
				preloadImage(doorLib[i].srcs.zoom_green);
				preloadImage(doorLib[i].srcs.zoom_pink);
				preloadImage(doorLib[i].srcs.zoom_red);
				preloadImage(doorLib[i].srcs.zoom_sage);
				preloadImage(doorLib[i].srcs.zoom_salmon);
				preloadImage(doorLib[i].srcs.zoom_teal);
				preloadImage(doorLib[i].srcs.zoom_white);
				preloadImage(doorLib[i].srcs.zoom_yellow);
				preloadImage(doorLib[i].srcs.zoom_midgray);
				preloadImage(doorLib[i].srcs.zoom_beige);
				preloadImage(doorLib[i].srcs.zoom_eggplant);
				preloadImage(doorLib[i].srcs.zoom_mobile_black);
				preloadImage(doorLib[i].srcs.zoom_mobile_blue);
				preloadImage(doorLib[i].srcs.zoom_mobile_gray);
				preloadImage(doorLib[i].srcs.zoom_mobile_green);
				preloadImage(doorLib[i].srcs.zoom_mobile_pink);
				preloadImage(doorLib[i].srcs.zoom_mobile_red);
				preloadImage(doorLib[i].srcs.zoom_mobile_sage);
				preloadImage(doorLib[i].srcs.zoom_mobile_salmon);
				preloadImage(doorLib[i].srcs.zoom_mobile_teal);
				preloadImage(doorLib[i].srcs.zoom_mobile_white);
				preloadImage(doorLib[i].srcs.zoom_mobile_yellow);
				preloadImage(doorLib[i].srcs.zoom_mobile_midgray);
				preloadImage(doorLib[i].srcs.zoom_mobile_beige);
				preloadImage(doorLib[i].srcs.zoom_mobile_eggplant);
			}
			for (i = 0; i < lockLib.length; i++) {
				preloadImage(lockLib[i].previews.black);
				preloadImage(lockLib[i].previews.bronze);
				preloadImage(lockLib[i].previews.silver);
				preloadImage(lockLib[i].srcs.black);
				preloadImage(lockLib[i].srcs.bronze);
				preloadImage(lockLib[i].srcs.silver);
				preloadImage(lockLib[i].srcs.mobile_black);
				preloadImage(lockLib[i].srcs.mobile_bronze);
				preloadImage(lockLib[i].srcs.mobile_silver);
				preloadImage(lockLib[i].srcs.zoom_black);
				preloadImage(lockLib[i].srcs.zoom_bronze);
				preloadImage(lockLib[i].srcs.zoom_silver);
				preloadImage(lockLib[i].srcs.zoom_mobile_black);
				preloadImage(lockLib[i].srcs.zoom_mobile_bronze);
				preloadImage(lockLib[i].srcs.zoom_mobile_silver);
				if (typeof lockLib[i].previews.pantone !== 'undefined') {
					preloadImage(lockLib[i].previews.pantone);
					preloadImage(lockLib[i].srcs.pantone);
					preloadImage(lockLib[i].srcs.mobile_pantone);
					preloadImage(lockLib[i].srcs.zoom_pantone);
					preloadImage(lockLib[i].srcs.zoom_mobile_pantone);
				}
			}
			for (i = 0; i < handleLib.length; i++) {
				preloadImage(handleLib[i].mobile);
				preloadImage(handleLib[i].preview);
				preloadImage(handleLib[i].src);
				preloadImage(handleLib[i].zoom_src);
				preloadImage(handleLib[i].zoom_mobile);
			}

			showBoxData = {
				home: homeLib[0].src,
				zoomHome: homeLib[0].zoomed,
				door: doorLib[0].srcs.white,
				zoomDoor: doorLib[0].srcs.zoom_white,
				lock: '',
				zoomLock: '',
				handle: '',
				zoomHandle: '',
			};

			mobileBoxData = {
				home: homeLib[0].mobile,
				zoomHome: homeLib[0].zoomedMobile,
				door: doorLib[0].srcs.mobile_white,
				zoomDoor: doorLib[0].srcs.zoom_mobile_white,
				lock: '',
				zoomLock: '',
				handle: '',
				zoomHandle: '',
			};

			selectedData = {
				color: 'white',
				doorIndex: 0,
				style: 'standard',
				lock: 'touchscreen',
				key: 'keyfree',
				tech: 'bluetooth',
			};

			urlData = {
				home: 0,
				door: 0,
				color: 'white',
				style: 'standard',
				lock: 'touchscreen',
				key: 'keyfree',
				tech: 'bluetooth',
				finish: 0,
				handle: 0,
			};

			function setDesktopShowBox(data) {
				$('.smartStudioD__wideHouse').attr('src', data.home);
				$('.smartStudioD__wideDoor').attr('src', data.door);
				$('.smartStudioD__wideLock').attr('src', data.lock);
				$('.smartStudioD__wideHandle').attr('src', data.handle);

				$('.smartStudioD__zoomHouse').attr('src', data.zoomHome);
				$('.smartStudioD__zoomDoor').attr('src', data.zoomDoor);
				$('.smartStudioD__zoomLock').attr('src', data.zoomLock);
				$('.smartStudioD__zoomHandle').attr('src', data.zoomHandle);

				if (data.lock == '') {
					$('.smartStudioD__wideLock').hide();
					$('.smartStudioD__zoomLock').hide();
				} else {
					$('.smartStudioD__wideLock').show();
					$('.smartStudioD__zoomLock').show();
				}

				if (data.handle == '') {
					$('.smartStudioD__wideHandle').hide();
					$('.smartStudioD__zoomHandle').hide();
				} else {
					$('.smartStudioD__wideHandle').show();
					$('.smartStudioD__zoomHandle').show();
				}
			}
			setDesktopShowBox(showBoxData);

			function setMobileShowBox(data) {
				$('.smartStudioM__wideHouse').attr('src', data.home);
				$('.smartStudioM__wideDoor').attr('src', data.door);
				$('.smartStudioM__wideLock').attr('src', data.lock);
				$('.smartStudioM__wideHandle').attr('src', data.handle);

				$('.smartStudioM__zoomHouse').attr('src', data.zoomHome);
				$('.smartStudioM__zoomDoor').attr('src', data.zoomDoor);
				$('.smartStudioM__zoomLock').attr('src', data.zoomLock);
				$('.smartStudioM__zoomHandle').attr('src', data.zoomHandle);

				if (data.lock == '') {
					$('.smartStudioM__wideLock').hide();
					$('.smartStudioM__zoomLock').hide();
				} else {
					$('.smartStudioM__wideLock').show();
					$('.smartStudioM__zoomLock').show();
				}

				if (data.handle == '') {
					$('.smartStudioM__wideHandle').hide();
					$('.smartStudioM__zoomHandle').hide();
				} else {
					$('.smartStudioM__wideHandle').show();
					$('.smartStudioM__zoomHandle').show();
				}
			}
			setMobileShowBox(mobileBoxData);

			function setDesktopHomeButtons() {
				var target = $(
					'[data-menu="home"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < homeLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioD__sideBarButton--home'
					).last();
					currentButton.attr('data-home', i);
					currentButton
						.find('img')
						.attr('src', homeLib[i].preview)
						.attr('alt', 'home button ' + i + ' thumbnail');
					currentButton.attr('data-src', homeLib[i].src);
					currentButton.attr('data-zoom-src', homeLib[i].zoomed);
				}
				$('.smartStudioD__sideBarButton--home').on(
					'click',
					function () {
						showBoxData.home = $(this).attr('data-src');
						showBoxData.zoomHome = $(this).attr('data-zoom-src');
						setDesktopShowBox(showBoxData);
						$(this)
							.parent()
							.find('.smartStudioD__sideBarButton--active')
							.removeClass('smartStudioD__sideBarButton--active');
						$(this).addClass('smartStudioD__sideBarButton--active');

						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--active'
						);
						urlData.home = $(this).attr('data-home');
					}
				);
			}
			setDesktopHomeButtons();

			function setMobileHomeButtons() {
				var target = $(
					'[data-menu="home"].smartStudioM__settingsBar .smartStudioM__settingsBarSled'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < homeLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioM__settingsBarButton--home'
					).last();
					currentButton.attr('data-home', i);
					currentButton
						.find('img')
						.attr('src', homeLib[i].preview)
						.attr('alt', 'home button ' + i + ' thumbnail');
					currentButton.attr('data-src', homeLib[i].mobile);
					currentButton.attr(
						'data-zoom-src',
						homeLib[i].zoomedMobile
					);
				}
				$('.smartStudioM__settingsBarButton--home').on(
					'click',
					function () {
						mobileBoxData.home = $(this).attr('data-src');
						mobileBoxData.zoomHome = $(this).attr('data-zoom-src');
						setMobileShowBox(mobileBoxData);
						$(this)
							.parent()
							.find('.smartStudioM__settingsBarButton--active')
							.removeClass(
								'smartStudioM__settingsBarButton--active'
							);
						$(this).addClass(
							'smartStudioM__settingsBarButton--active'
						);

						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--active'
						);
						urlData.home = $(this).attr('data-home');
					}
				);
			}
			setMobileHomeButtons();

			function setDoor() {
				var i = selectedData.doorIndex;
				if (selectedData.color == 'white') {
					showBoxData.door = doorLib[i].srcs.white;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_white;
				} else if (selectedData.color == 'pink') {
					showBoxData.door = doorLib[i].srcs.pink;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_pink;
				} else if (selectedData.color == 'salmon') {
					showBoxData.door = doorLib[i].srcs.salmon;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_salmon;
				} else if (selectedData.color == 'blue') {
					showBoxData.door = doorLib[i].srcs.blue;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_gray;
				} else if (selectedData.color == 'gray') {
					showBoxData.door = doorLib[i].srcs.gray;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_gray;
				} else if (selectedData.color == 'red') {
					showBoxData.door = doorLib[i].srcs.red;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_red;
				} else if (selectedData.color == 'yellow') {
					showBoxData.door = doorLib[i].srcs.yellow;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_yellow;
				} else if (selectedData.color == 'teal') {
					showBoxData.door = doorLib[i].srcs.teal;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_teal;
				} else if (selectedData.color == 'black') {
					showBoxData.door = doorLib[i].srcs.black;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_black;
				} else if (selectedData.color == 'sage') {
					showBoxData.door = doorLib[i].srcs.sage;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_sage;
				} else if (selectedData.color == 'green') {
					showBoxData.door = doorLib[i].srcs.green;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_green;
				} else if (selectedData.color == 'midgray') {
					showBoxData.door = doorLib[i].srcs.midgray;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_midgray;
				} else if (selectedData.color == 'beige') {
					showBoxData.door = doorLib[i].srcs.beige;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_beige;
				} else if (selectedData.color == 'eggplant') {
					showBoxData.door = doorLib[i].srcs.eggplant;
					showBoxData.zoomDoor = doorLib[i].srcs.zoom_eggplant;
				}
			}

			function setMobileDoor() {
				var i = selectedData.doorIndex;
				if (selectedData.color == 'white') {
					mobileBoxData.door = doorLib[i].srcs.mobile_white;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_white;
				} else if (selectedData.color == 'pink') {
					mobileBoxData.door = doorLib[i].srcs.mobile_pink;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_pink;
				} else if (selectedData.color == 'salmon') {
					mobileBoxData.door = doorLib[i].srcs.mobile_salmon;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_salmon;
				} else if (selectedData.color == 'blue') {
					mobileBoxData.door = doorLib[i].srcs.mobile_blue;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_gray;
				} else if (selectedData.color == 'gray') {
					mobileBoxData.door = doorLib[i].srcs.mobile_gray;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_gray;
				} else if (selectedData.color == 'red') {
					mobileBoxData.door = doorLib[i].srcs.mobile_red;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_red;
				} else if (selectedData.color == 'yellow') {
					mobileBoxData.door = doorLib[i].srcs.mobile_yellow;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_yellow;
				} else if (selectedData.color == 'teal') {
					mobileBoxData.door = doorLib[i].srcs.mobile_teal;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_teal;
				} else if (selectedData.color == 'black') {
					mobileBoxData.door = doorLib[i].srcs.mobile_black;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_black;
				} else if (selectedData.color == 'sage') {
					mobileBoxData.door = doorLib[i].srcs.mobile_sage;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_sage;
				} else if (selectedData.color == 'green') {
					mobileBoxData.door = doorLib[i].srcs.mobile_green;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_green;
				} else if (selectedData.color == 'midgray') {
					mobileBoxData.door = doorLib[i].srcs.mobile_midgray;
					mobileBoxData.zoomDoor =
						doorLib[i].srcs.zoom_mobile_midgray;
				} else if (selectedData.color == 'beige') {
					mobileBoxData.door = doorLib[i].srcs.mobile_beige;
					mobileBoxData.zoomDoor = doorLib[i].srcs.zoom_mobile_beige;
				} else if (selectedData.color == 'eggplant') {
					mobileBoxData.door = doorLib[i].srcs.mobile_eggplant;
					mobileBoxData.zoomDoor =
						doorLib[i].srcs.zoom_mobile_eggplant;
				}
			}

			function setDesktopDoorButtons() {
				var target = $(
					'[data-menu="door"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < doorLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioD__sideBarButton--door'
					).last();
					currentButton.attr('data-door', i);
					currentButton
						.find('img')
						.attr('src', doorLib[i].preview)
						.attr('alt', 'door button ' + i + ' thumbnail');
				}
				$('.smartStudioD__sideBarButton--door').on(
					'click',
					function () {
						selectedData.doorIndex = $(this).attr('data-door') * 1;
						setDoor();
						setDesktopShowBox(showBoxData);
						$(this)
							.parent()
							.find('.smartStudioD__sideBarButton--active')
							.removeClass('smartStudioD__sideBarButton--active');
						$(this).addClass('smartStudioD__sideBarButton--active');

						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--active'
						);
						urlData.door = $(this).attr('data-door');
					}
				);
			}
			setDesktopDoorButtons();

			function setMobileDoorButtons() {
				var target = $(
					'[data-menu="door"].smartStudioM__settingsBar .smartStudioM__settingsBarSled'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < doorLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioM__settingsBarButton--door'
					).last();
					currentButton.attr('data-door', i);
					currentButton
						.find('img')
						.attr('src', doorLib[i].preview)
						.attr('alt', 'door button ' + i + ' thumbnail');
				}
				$('.smartStudioM__settingsBarButton--door').on(
					'click',
					function () {
						selectedData.doorIndex = $(this).attr('data-door') * 1;
						setMobileDoor();
						setMobileShowBox(mobileBoxData);
						$(this)
							.parent()
							.find('.smartStudioM__settingsBarButton--active')
							.removeClass(
								'smartStudioM__settingsBarButton--active'
							);
						$(this).addClass(
							'smartStudioM__settingsBarButton--active'
						);

						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--active'
						);
						urlData.door = $(this).attr('data-door');
					}
				);
			}
			setMobileDoorButtons();

			$('.smartStudioD__sideBarColorButton').on('click', function () {
				selectedData.color = $(this).attr('data-color');
				setDoor();
				setDesktopShowBox(showBoxData);
				$(this)
					.parent()
					.find('.smartStudioD__sideBarColorButton--active')
					.removeClass('smartStudioD__sideBarColorButton--active');
				$(this).addClass('smartStudioD__sideBarColorButton--active');

				$('.smartStudioD__topBarNavButton--next').addClass(
					'smartStudioD__topBarNavButton--active'
				);
				urlData.color = $(this).attr('data-color');
			});

			$('.smartStudioM__colorButton').on('click', function () {
				selectedData.color = $(this).attr('data-color');
				setMobileDoor();
				setMobileShowBox(mobileBoxData);
				$(this)
					.parent()
					.find('.smartStudioM__colorButton--active')
					.removeClass('smartStudioM__colorButton--active');
				$(this).addClass('smartStudioM__colorButton--active');

				$('.smartStudioM__controlBarButton--next').addClass(
					'smartStudioM__controlBarButton--active'
				);
				urlData.color = $(this).attr('data-color');
			});

			function setDesktopFinishButtons() {
				var pantone = false;
				var target = $(
					'[data-menu="finish"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner'
				);
				var selected = '';
				if (selectedData.style == 'standard') {
					if (selectedData.key == 'keyfree') {
						if (selectedData.lock == 'touchscreen') {
							selected = lockLib[4];
							pantone = true;
						} else {
							selected = lockLib[6];
						}
					} else {
						if (selectedData.lock == 'touchscreen') {
							selected = lockLib[3];
						} else {
							selected = lockLib[5];
						}
					}
				} else if (selectedData.style == 'touch') {
					if (selectedData.key == 'keyfree') {
						selected = lockLib[1];
					} else {
						selected = lockLib[0];
					}
				} else if (selectedData.style == 'plus') {
					selected = lockLib[2];
				}

				target
					.find('[data-finish="0"]')
					.attr('data-src', selected.srcs.black)
					.attr('data-zoom-src', selected.srcs.zoom_black)
					.find('img')
					.attr('src', selected.previews.black);
				target
					.find('[data-finish="1"]')
					.attr('data-src', selected.srcs.silver)
					.attr('data-zoom-src', selected.srcs.zoom_silver)
					.find('img')
					.attr('src', selected.previews.silver);
				target
					.find('[data-finish="2"]')
					.attr('data-src', selected.srcs.bronze)
					.attr('data-zoom-src', selected.srcs.zoom_bronze)
					.find('img')
					.attr('src', selected.previews.bronze);

				if (pantone == true) {
					target
						.find('[data-finish="3"]')
						.attr('data-src', selected.srcs.pantone)
						.attr('data-zoom-src', selected.srcs.zoom_pantone)
						.find('img')
						.attr('src', selected.previews.pantone);
					target.find('[data-finish="3"]').show();
				} else {
					target.find('[data-finish="3"]').hide();
				}

				$('.smartStudioD__sideBarButton--finish').on(
					'click',
					function () {
						showBoxData.lock = $(this).attr('data-src');
						showBoxData.zoomLock = $(this).attr('data-zoom-src');
						setDesktopShowBox(showBoxData);
						$(this)
							.parent()
							.find('.smartStudioD__sideBarButton--active')
							.removeClass('smartStudioD__sideBarButton--active');
						$(this).addClass('smartStudioD__sideBarButton--active');

						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--active'
						);
						urlData.finish = $(this).attr('data-finish');
					}
				);
			}
			setDesktopFinishButtons();

			function setMobileFinishButtons() {
				var pantone = false;
				var target = $(
					'[data-menu="finish"].smartStudioM__settingsBar .smartStudioM__settingsBarSled'
				);
				var selected = '';
				if (selectedData.style == 'standard') {
					if (selectedData.key == 'keyfree') {
						if (selectedData.lock == 'touchscreen') {
							selected = lockLib[4];
							pantone = true;
						} else {
							selected = lockLib[6];
						}
					} else {
						if (selectedData.lock == 'touchscreen') {
							selected = lockLib[3];
						} else {
							selected = lockLib[5];
						}
					}
				} else if (selectedData.style == 'touch') {
					if (selectedData.key == 'keyfree') {
						selected = lockLib[1];
					} else {
						selected = lockLib[0];
					}
				} else if (selectedData.style == 'plus') {
					selected = lockLib[2];
				}

				target
					.find('[data-finish="0"]')
					.attr('data-src', selected.srcs.mobile_black)
					.attr('data-zoom-src', selected.srcs.zoom_mobile_black)
					.find('img')
					.attr('src', selected.previews.black);
				target
					.find('[data-finish="1"]')
					.attr('data-src', selected.srcs.mobile_silver)
					.attr('data-zoom-src', selected.srcs.zoom_mobile_silver)
					.find('img')
					.attr('src', selected.previews.silver);
				target
					.find('[data-finish="2"]')
					.attr('data-src', selected.srcs.mobile_bronze)
					.attr('data-zoom-src', selected.srcs.zoom_mobile_bronze)
					.find('img')
					.attr('src', selected.previews.bronze);

				if (pantone == true) {
					target
						.find('[data-finish="3"]')
						.attr('data-src', selected.srcs.mobile_pantone)
						.attr(
							'data-zoom-src',
							selected.srcs.zoom_mobile_pantone
						)
						.find('img')
						.attr('src', selected.previews.pantone);
					target.find('[data-finish="3"]').show();
				} else {
					target.find('[data-finish="3"]').hide();
				}

				$('.smartStudioM__settingsBarButton--finish').on(
					'click',
					function () {
						mobileBoxData.lock = $(this).attr('data-src');
						mobileBoxData.zoomLock = $(this).attr('data-zoom-src');
						setMobileShowBox(mobileBoxData);
						$(this)
							.parent()
							.find('.smartStudioM__settingsBarButton--active')
							.removeClass(
								'smartStudioM__settingsBarButton--active'
							);
						$(this).addClass(
							'smartStudioM__settingsBarButton--active'
						);

						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--active'
						);
						urlData.finish = $(this).attr('data-finish');
					}
				);
			}
			setMobileFinishButtons();

			$('.smartStudioD__sideBarSlideButton').on('click', function () {
				var thisThing = $(this);
				var slide = $(this).closest('.smartStudioD__sideBarSlide');
				if (slide.attr('data-step') == 'step-1') {
					selectedData.style = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioD__sideBarSlideButton--active')
						.removeClass(
							'smartStudioD__sideBarSlideButton--active'
						);
					thisThing.addClass(
						'smartStudioD__sideBarSlideButton--active'
					);
					setDesktopFinishButtons();

					$('.smartStudioD__sideBarNextArrow').removeClass(
						'smartStudioD__sideBarNextArrow--disabled'
					);
					urlData.style = $(this).attr('data-answer');
				} else if (slide.attr('data-step') == 'step-2') {
					selectedData.tech = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioD__sideBarSlideButton--active')
						.removeClass(
							'smartStudioD__sideBarSlideButton--active'
						);
					thisThing.addClass(
						'smartStudioD__sideBarSlideButton--active'
					);
					setDesktopFinishButtons();

					$('.smartStudioD__sideBarNextArrow').removeClass(
						'smartStudioD__sideBarNextArrow--disabled'
					);
					urlData.tech = $(this).attr('data-answer');

					var selectedStyle = $(
						'.smartStudioD__sideBarSlide[data-step="step-1"]'
					)
						.find('.smartStudioD__sideBarSlideButton--active')
						.attr('data-answer');
					if (selectedStyle == 'plus') {
						selectedData.key = 'keyfree';
						selectedData.lock = 'touchscreen';
						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--active'
						);
					} else {
						$('.smartStudioD__topBarNavButton--next').removeClass(
							'smartStudioD__topBarNavButton--active'
						);
					}
				} else if (slide.attr('data-step') == 'step-3') {
					selectedData.key = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioD__sideBarSlideButton--active')
						.removeClass(
							'smartStudioD__sideBarSlideButton--active'
						);
					thisThing.addClass(
						'smartStudioD__sideBarSlideButton--active'
					);
					setDesktopFinishButtons();
					$('.smartStudioD__sideBarNextArrow').removeClass(
						'smartStudioD__sideBarNextArrow--disabled'
					);
					urlData.key = $(this).attr('data-answer');

					var selectedStyle = $(
						'.smartStudioD__sideBarSlide[data-step="step-1"]'
					)
						.find('.smartStudioD__sideBarSlideButton--active')
						.attr('data-answer');
					if (selectedStyle == 'touch') {
						selectedData.lock = 'touchscreen';
						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--active'
						);
					} else {
						$('.smartStudioD__topBarNavButton--next').removeClass(
							'smartStudioD__topBarNavButton--active'
						);
					}
				} else if (slide.attr('data-step') == 'step-4') {
					selectedData.lock = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioD__sideBarSlideButton--active')
						.removeClass(
							'smartStudioD__sideBarSlideButton--active'
						);
					thisThing.addClass(
						'smartStudioD__sideBarSlideButton--active'
					);
					setDesktopFinishButtons();

					$('.smartStudioD__topBarNavButton--next').addClass(
						'smartStudioD__topBarNavButton--active'
					);
					urlData.lock = $(this).attr('data-answer');
				}
			});

			$('.smartStudioM__typeSlideButton').on('click', function () {
				var thisThing = $(this);
				var slide = $(this).closest('.smartStudioM__typeSlide');
				if (slide.attr('data-step') == 'step-1') {
					selectedData.style = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioM__typeSlideButton--active')
						.removeClass('smartStudioM__typeSlideButton--active');
					thisThing.addClass('smartStudioM__typeSlideButton--active');
					setMobileFinishButtons();
					$('.smartStudioM__typeSlideNextArrow').removeClass(
						'smartStudioM__typeSlideNextArrow--disabled'
					);
					urlData.style = $(this).attr('data-answer');
					$('.smartStudioM__typeSlideNextArrow').click();
				} else if (slide.attr('data-step') == 'step-2') {
					selectedData.tech = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioM__typeSlideButton--active')
						.removeClass('smartStudioM__typeSlideButton--active');
					thisThing.addClass('smartStudioM__typeSlideButton--active');
					setMobileFinishButtons();
					$('.smartStudioM__typeSlideNextArrow').removeClass(
						'smartStudioM__typeSlideNextArrow--disabled'
					);
					urlData.tech = $(this).attr('data-answer');

					var selectedStyle = $(
						'.smartStudioM__typeSlide[data-step="step-1"]'
					)
						.find('.smartStudioM__typeSlideButton--active')
						.attr('data-answer');
					if (selectedStyle == 'plus') {
						selectedData.key = 'keyfree';
						selectedData.lock = 'touchscreen';
						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--active'
						);
						$('.smartStudioM__controlBarButton--next').click();
					} else {
						$('.smartStudioM__typeSlideNextArrow').click();
					}
				} else if (slide.attr('data-step') == 'step-3') {
					selectedData.key = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioM__typeSlideButton--active')
						.removeClass('smartStudioM__typeSlideButton--active');
					thisThing.addClass('smartStudioM__typeSlideButton--active');
					setMobileFinishButtons();
					$('.smartStudioM__typeSlideNextArrow').removeClass(
						'smartStudioM__typeSlideNextArrow--disabled'
					);
					urlData.key = $(this).attr('data-answer');
					var selectedStyle = $(
						'.smartStudioM__typeSlide[data-step="step-1"]'
					)
						.find('.smartStudioM__typeSlideButton--active')
						.attr('data-answer');
					if (selectedStyle == 'touch') {
						selectedData.lock = 'touchscreen';
						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--active'
						);
						$('.smartStudioM__controlBarButton--next').click();
					} else {
						$('.smartStudioM__typeSlideNextArrow').click();
					}
				} else {
					selectedData.lock = thisThing.attr('data-answer');
					thisThing
						.parent()
						.find('.smartStudioM__typeSlideButton--active')
						.removeClass('smartStudioM__typeSlideButton--active');
					thisThing.addClass('smartStudioM__typeSlideButton--active');
					setMobileFinishButtons();

					$('.smartStudioM__controlBarButton--next').addClass(
						'smartStudioM__controlBarButton--active'
					);
					urlData.lock = $(this).attr('data-answer');
					$('.smartStudioM__controlBarButton--next').click();
				}
			});

			function setDesktopHandleButtons() {
				var target = $(
					'[data-menu="handle"].smartStudioD__sideBar .smartStudioD__sideBarColumnInner'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < handleLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioD__sideBarButton--handle'
					).last();
					currentButton.attr('data-handle', i);
					currentButton
						.find('img')
						.attr('src', handleLib[i].preview)
						.attr('alt', 'handle button ' + i + ' thumbnail');
					currentButton.attr('data-src', handleLib[i].src);
					currentButton.attr('data-zoom-src', handleLib[i].zoom_src);
				}
				$('.smartStudioD__sideBarButton--handle').on(
					'click',
					function () {
						showBoxData.handle = $(this).attr('data-src');
						showBoxData.zoomHandle = $(this).attr('data-zoom-src');
						setDesktopShowBox(showBoxData);
						$(this)
							.parent()
							.find('.smartStudioD__sideBarButton--active')
							.removeClass('smartStudioD__sideBarButton--active');
						$(this).addClass('smartStudioD__sideBarButton--active');

						$('.smartStudioD__topBarNavButton--next').addClass(
							'smartStudioD__topBarNavButton--results'
						);
						urlData.handle = $(this).attr('data-handle');
					}
				);
			}
			setDesktopHandleButtons();

			function setMobileHandleButtons() {
				var target = $(
					'[data-menu="handle"].smartStudioM__settingsBar .smartStudioM__settingsBarSled'
				);
				var template = target.html();
				target.html('');
				for (i = 0; i < handleLib.length; i++) {
					target.append(template);
					var currentButton = $(
						'.smartStudioM__settingsBarButton--handle'
					).last();
					currentButton.attr('data-handle', i);
					currentButton
						.find('img')
						.attr('src', handleLib[i].preview)
						.attr('alt', 'handle button ' + i + ' thumbnail');
					currentButton.attr('data-src', handleLib[i].mobile);
					currentButton.attr(
						'data-zoom-src',
						handleLib[i].zoom_mobile
					);
				}
				$('.smartStudioM__settingsBarButton--handle').on(
					'click',
					function () {
						mobileBoxData.handle = $(this).attr('data-src');
						mobileBoxData.zoomHandle =
							$(this).attr('data-zoom-src');
						setMobileShowBox(mobileBoxData);
						$(this)
							.parent()
							.find('.smartStudioM__settingsBarButton--active')
							.removeClass(
								'smartStudioM__settingsBarButton--active'
							);
						$(this).addClass(
							'smartStudioM__settingsBarButton--active'
						);

						$('.smartStudioM__controlBarButton--next').addClass(
							'smartStudioM__controlBarButton--results'
						);
						urlData.handle = $(this).attr('data-handle');
					}
				);
			}
			setMobileHandleButtons();

			function studioZoomIn() {
				$('.smartStudioD__showBox').addClass(
					'smartStudioD__showBox--zoom'
				);
			}

			function studioZoomOut() {
				$('.smartStudioD__showBox').removeClass(
					'smartStudioD__showBox--zoom'
				);
			}

			function studioZoomInMobile() {
				$('.smartStudioM__showBox').addClass(
					'smartStudioM__showBox--zoom'
				);
			}

			function studioZoomOutMobile() {
				$('.smartStudioM__showBox').removeClass(
					'smartStudioM__showBox--zoom'
				);
			}

			function setStep(step) {
				var stepArray = [
					'intro',
					'home',
					'door',
					'color',
					'type',
					'finish',
					'handle',
				];
				var menu = stepArray[step];

				// START GTM event for Flywheel Demand
				try {
					var _gtmSelect = stepArray[currentStep];
					var dataLayer = window.dataLayer || [];

					if (step > currentStep) {
						switch (_gtmSelect) {
							case 'intro':
								dataLayer.push({ event: 'quiz_start' });
								break;
							case 'type':
								dataLayer.push({
									event: 'quiz_next',
									quiz_step: 'type',
									quiz_selection: `${urlData.style} | ${urlData.lock} | ${urlData.key} | ${urlData.tech}`,
								});
								break;
							default:
								dataLayer.push({
									event: 'quiz_next',
									quiz_step: _gtmSelect,
									quiz_selection: urlData[_gtmSelect],
								});
						}
					}
				} catch (error) {
					console.error('GTM tracking for quiz error: ', error);
				}
				// END GTM event for Flywheel Demand

				var stepTarget = $(
					'.smartStudioD__topBarButton[data-index="' + step + '"]'
				);
				var menuTarget = $(
					'.smartStudioD__sideBar[data-menu="' + menu + '"]'
				);

				var targetSlider = $('.smartStudioD__topBarButtonRow');

				var origin = targetSlider.offset().left;
				var targetPos =
					stepTarget.offset().left +
					stepTarget.outerWidth() -
					origin +
					targetSlider.scrollLeft();
				var scrollAmount = targetPos - targetSlider.outerWidth() + 6;

				if (scrollAmount > 0) {
					targetSlider.animate({ scrollLeft: scrollAmount }, 500);
				}
				stepTarget.addClass('smartStudioD__topBarButton--active');

				if ($('.smartStudioD__sideBarWrapper--open').length) {
					$('.smartStudioD__sideBarWrapper').removeClass(
						'smartStudioD__sideBarWrapper--open'
					);
					$('.smartStudioD__sideBarToolTip').fadeOut(200);
					setTimeout(function () {
						$('.smartStudioD__sideBar').hide();
						menuTarget.show();
						$('.smartStudioD__sideBarWrapper').addClass(
							'smartStudioD__sideBarWrapper--open'
						);
						if (tutorial == true) {
							setTimeout(function () {
								menuTarget
									.find('.smartStudioD__sideBarToolTip')
									.fadeIn(200);
							}, 100);
						}
					}, 200);
				} else {
					$('.smartStudioD__sideBar').hide();
					menuTarget.show();
					$('.smartStudioD__sideBarWrapper').addClass(
						'smartStudioD__sideBarWrapper--open'
					);
					if (tutorial == true) {
						setTimeout(function () {
							menuTarget
								.find('.smartStudioD__sideBarToolTip')
								.fadeIn(200);
						}, 100);
					}
				}

				if (!$('.smartStudioD__showBox--open').length) {
					$('.smartStudioD__showBox').addClass(
						'smartStudioD__showBox--open'
					);
				}

				currentStep = step;

				if (step > 1) {
					$(
						'[data-direction="back"].smartStudioD__topBarNavButton'
					).removeClass('smartStudioD__topBarNavButton--disabled');
				} else {
					$(
						'[data-direction="back"].smartStudioD__topBarNavButton'
					).addClass('smartStudioD__topBarNavButton--disabled');
				}

				if (
					menuTarget.find('.smartStudioD__sideBarButton--active')
						.length ||
					menuTarget.find('.smartStudioD__sideBarColorButton--active')
						.length ||
					menuTarget
						.find('[data-step="step-3"].smartStudioD__sideBarSlide')
						.find('.smartStudioD__sideBarSlideButton--active')
						.length
				) {
					$(
						'[data-direction="next"].smartStudioD__topBarNavButton'
					).addClass('smartStudioD__topBarNavButton--active');
				} else {
					$(
						'[data-direction="next"].smartStudioD__topBarNavButton'
					).removeClass('smartStudioD__topBarNavButton--active');
				}

				if (step > 4) {
					studioZoomIn();
				} else {
					studioZoomOut();
				}
			}

			function setStepMobile(step) {
				var stepArray = [
					'intro',
					'home',
					'door',
					'color',
					'type',
					'finish',
					'handle',
				];
				var menu = stepArray[step];

				// START GTM event for Flywheel Demand
				try {
					var _gtmSelect = stepArray[currentStep];
					var dataLayer = window.dataLayer || [];

					if (step > currentStep) {
						switch (_gtmSelect) {
							case 'intro':
								dataLayer.push({ event: 'quiz_start' });
								break;
							case 'type':
								dataLayer.push({
									event: 'quiz_next',
									quiz_step: 'type',
									quiz_selection: `${urlData.style} | ${urlData.lock} | ${urlData.key} | ${urlData.tech}`,
								});
								break;
							default:
								dataLayer.push({
									event: 'quiz_next',
									quiz_step: _gtmSelect,
									quiz_selection: urlData[_gtmSelect],
								});
						}
					}
				} catch (error) {
					console.error('GTM tracking for quiz error: ', error);
				}
				// END GTM event for Flywheel Demand

				var stepTarget = $(
					'.smartStudioM__controlBarTopButton[data-index="' +
						step +
						'"]'
				);
				var menuTarget = $(
					'.smartStudioM__settingsBar[data-menu="' + menu + '"]'
				);

				var targetSlider = $('.smartStudioM__controlBarTopFrame');

				var origin = targetSlider.offset().left;
				var targetPos =
					stepTarget.offset().left +
					stepTarget.outerWidth() -
					origin +
					targetSlider.scrollLeft();
				var scrollAmount = targetPos - targetSlider.outerWidth() + 6;

				if (scrollAmount > 0) {
					targetSlider.animate({ scrollLeft: scrollAmount }, 500);
				}
				stepTarget.addClass(
					'smartStudioM__controlBarTopButton--active'
				);

				if ($('.smartStudioM__settingsWrapper--open').length) {
					$('.smartStudioM__settingsWrapper').removeClass(
						'smartStudioM__settingsWrapper--open'
					);
					$('.smartStudioM__toolTip').fadeOut(200);
					setTimeout(function () {
						$('.smartStudioM__settingsBar').hide();
						menuTarget.show();
						$('.smartStudioM__settingsWrapper').addClass(
							'smartStudioM__settingsWrapper--open'
						);
					}, 200);
				} else {
					$('.smartStudioM__settingsBar').hide();
					menuTarget.show();
					$('.smartStudioM__settingsWrapper').addClass(
						'smartStudioM__settingsWrapper--open'
					);
				}

				if (!$('.smartStudioM__showBox--open').length) {
					$('.smartStudioM__showBox').addClass(
						'smartStudioM__showBox--open'
					);
				}

				currentStep = step;

				if (step > 1) {
					$(
						'[data-direction="back"].smartStudioM__controlBarButton'
					).removeClass('smartStudioM__controlBarButton--disabled');
				} else {
					$(
						'[data-direction="back"].smartStudioM__controlBarButton'
					).addClass('smartStudioM__controlBarButton--disabled');
				}

				if (
					menuTarget.find('.smartStudioM__settingsBarButton--active')
						.length ||
					menuTarget.find('.smartStudioM__colorButton--active')
						.length ||
					menuTarget
						.find('[data-step="step-3"].smartStudioM__typeSlide')
						.find('.smartStudioM__typeSlideButton--active').length
				) {
					$(
						'[data-direction="next"].smartStudioM__controlBarButton'
					).addClass('smartStudioM__controlBarButton--active');
				} else {
					$(
						'[data-direction="next"].smartStudioM__controlBarButton'
					).removeClass('smartStudioM__controlBarButton--active');
				}

				if (step > 4) {
					studioZoomInMobile();
				} else {
					studioZoomOutMobile();
				}
			}

			$('.smartStudioD__sideBarClose').on('click', function () {
				$('.smartStudioD__sideBarWrapper').removeClass(
					'smartStudioD__sideBarWrapper--open'
				);
				$('.smartStudioD__showBox').removeClass(
					'smartStudioD__showBox--open'
				);
				$('.smartStudioD__sideBarToolTip').fadeOut(200);
			});

			var tutorial = false;
			var started = false;
			var currentStep = 0;
			$('.smartStudioD__startPopButton').on('click', function () {
				tutorial = true;
				started = true;
				setStep(1);
				$('.smartStudioD__startPop').fadeOut(200);
			});

			$('.smartStudioM__startPopButton').on('click', function () {
				started = true;
				setStepMobile(1);
				$('.smartStudioM__startPop').fadeOut(200);
			});

			$('.smartStudioD__close').on('click', function () {
				tutorial = false;
				started = true;
				setStep(1);
				$('.smartStudioD__startPop').fadeOut(200);
			});

			$('.smartStudioD__sideBarToolTipClose').on('click', function () {
				var target = $(this).parent();
				target.fadeOut(200);
				setTimeout(function () {
					target.attr('style', 'display:none!important;');
				}, 200);
			});

			$('.smartStudioM__toolTipClose').on('click', function () {
				var target = $(this).parent();
				target.fadeOut(200);
				setTimeout(function () {
					target.attr('style', 'display:none!important;');
				}, 200);
			});

			$('[data-direction="next"].smartStudioD__topBarNavButton').on(
				'click',
				function () {
					if (
						$(this).hasClass(
							'smartStudioD__topBarNavButton--results'
						)
					) {
						var dataString = JSON.stringify(urlData);
						var trimmed = dataString.slice(1, -1);

						// START GTM event for Flywheel Demand
						try {
							var dataLayer = window.dataLayer || [];
							dataLayer.push({
								event: 'quiz_next',
								quiz_step: 'handle',
								quiz_selection: urlData.handle,
							});
						} catch (error) {
							console.error(
								'GTM tracking for quiz error: ',
								error
							);
						}
						// END GTM event for Flywheel Demand

						window.location.href =
							'/pages/smart-studio-results?answers=' + trimmed;
					} else if (
						$(this).hasClass(
							'smartStudioD__topBarNavButton--active'
						)
					) {
						var targetStep = currentStep + 1;
						setStep(targetStep);
						if (
							targetStep == '6' &&
							$('.smartStudioD__sideBarButton--handle').hasClass(
								'smartStudioD__sideBarButton--active'
							)
						) {
							$('.smartStudioD__topBarNavButton--next').addClass(
								'smartStudioD__topBarNavButton--results'
							);
						}
					}
				}
			);

			$('[data-direction="next"].smartStudioM__controlBarButton').on(
				'click',
				function () {
					if (
						$(this).hasClass(
							'smartStudioM__controlBarButton--results'
						)
					) {
						var dataString = JSON.stringify(urlData);
						var trimmed = dataString.slice(1, -1);

						// START GTM event for Flywheel Demand
						try {
							var dataLayer = window.dataLayer || [];
							dataLayer.push({
								event: 'quiz_next',
								quiz_step: 'handle',
								quiz_selection: urlData.handle,
							});
						} catch (error) {
							console.error(
								'GTM tracking for quiz error: ',
								error
							);
						}
						// END GTM event for Flywheel Demand

						window.location.href =
							'/pages/smart-studio-results?answers=' + trimmed;
					} else if (
						$(this).hasClass(
							'smartStudioM__controlBarButton--active'
						)
					) {
						var targetStep = currentStep + 1;
						setStepMobile(targetStep);
						if (
							targetStep == '6' &&
							$(
								'.smartStudioM__settingsBarButton--handle'
							).hasClass(
								'smartStudioM__settingsBarButton--active'
							)
						) {
							$('.smartStudioM__controlBarButton--next').addClass(
								'smartStudioM__controlBarButton--results'
							);
						}
					}
				}
			);

			$('[data-direction="back"].smartStudioD__topBarNavButton').on(
				'click',
				function () {
					if (
						!$(this).hasClass(
							'smartStudioD__topBarNavButton--disabled'
						)
					) {
						var targetStep = currentStep - 1;
						setStep(targetStep);
						$('.smartStudioD__topBarNavButton--next').removeClass(
							'smartStudioD__topBarNavButton--results'
						);
					}
				}
			);

			$('[data-direction="back"].smartStudioM__controlBarButton').on(
				'click',
				function () {
					if (
						!$(this).hasClass(
							'smartStudioM__controlBarButton--disabled'
						)
					) {
						var targetStep = currentStep - 1;
						setStepMobile(targetStep);
						$('.smartStudioM__controlBarButton--next').removeClass(
							'smartStudioM__controlBarButton--results'
						);
					}
				}
			);

			$('.smartStudioD__topBarButton').on('click', function () {
				if ($(this).hasClass('smartStudioD__topBarButton--active')) {
					var index = $(this).attr('data-index') * 1;
					if (
						currentStep != index ||
						$('.smartStudioD__showBox--open').length == 0
					) {
						setStep(index);
					}
				}
			});

			$('.smartStudioM__controlBarTopButton').on('click', function () {
				if (
					$(this).hasClass(
						'smartStudioM__controlBarTopButton--active'
					)
				) {
					var index = $(this).attr('data-index') * 1;
					if (
						currentStep != index ||
						$('.smartStudioM__showBox--open').length == 0
					) {
						setStepMobile(index);
					}
				}
			});

			$('.smartStudioD__sideBarInfoIcon').on('click', function () {
				var target = $(this)
					.closest('.smartStudioD__sideBarInner')
					.find('.smartStudioD__sideBarToolTip')
					.fadeIn(200);
			});

			$('.smartStudioM__settingsBarInfo').on('click', function () {
				var target = $(this)
					.closest('.smartStudioM__settingsBar')
					.find('.smartStudioM__toolTip')
					.fadeIn(200);
			});

			var slide = 0;
			function goToSlide(slide) {
				$('.smartStudioD__sideBarSliderSled').attr(
					'style',
					'transform:translateX(calc((-100% / 4) * ' + slide + '));'
				);
			}

			function goToSlideMobile(slide) {
				$('.smartStudioM__typeSlideSliderSled').attr(
					'style',
					'transform:translateX(calc((-100% / 4) * ' + slide + '));'
				);
			}

			$('.smartStudioD__sideBarNext').on('click', function () {
				if (
					!$(this)
						.find('img')
						.hasClass('smartStudioD__sideBarNextArrow--disabled') &&
					!$(this)
						.find('img')
						.hasClass('smartStudioD__sideBarNextArrow--end')
				) {
					var selectedStyle = $(
						'.smartStudioD__sideBarSlide[data-step="step-1"]'
					)
						.find('.smartStudioD__sideBarSlideButton--active')
						.attr('data-answer');

					slide += 1;

					if (slide == 1) {
						if (selectedStyle == 'plus') {
							$(this)
								.find('img')
								.addClass(
									'smartStudioD__sideBarNextArrow--end'
								);
						} else {
							$(this)
								.find('img')
								.removeClass(
									'smartStudioD__sideBarNextArrow--end'
								);
						}
					}
					if (slide == 2) {
						if (selectedStyle == 'touch') {
							$(this)
								.find('img')
								.addClass(
									'smartStudioD__sideBarNextArrow--end'
								);
						} else {
							$(this)
								.find('img')
								.removeClass(
									'smartStudioD__sideBarNextArrow--end'
								);
						}
					}

					goToSlide(slide);
					$('.smartStudioD__sideBarPrevious')
						.find('img')
						.removeClass(
							'smartStudioD__sideBarPreviousArrow--disabled'
						);
					if (
						$(
							'[data-step="step-' +
								(slide + 1) +
								'"].smartStudioD__sideBarSlide'
						).find('.smartStudioD__sideBarSlideButton--active')
					) {
						$(this)
							.find('img')
							.removeClass(
								'smartStudioD__sideBarNextArrow--disabled'
							);
					} else {
						$(this)
							.find('img')
							.addClass(
								'smartStudioD__sideBarNextArrow--disabled'
							);
					}
					if (slide == 1) {
						$('.smartStudioD__sideBarTitle--multi').text(
							$('.smartStudioD__sideBarTitle--multi').attr(
								'step-2'
							)
						);
					}
					if (slide == 2) {
						$('.smartStudioD__sideBarTitle--multi').text(
							$('.smartStudioD__sideBarTitle--multi').attr(
								'step-3'
							)
						);
					}
					if (slide == 3) {
						$(this)
							.find('img')
							.addClass('smartStudioD__sideBarNextArrow--end');
						$('.smartStudioD__sideBarTitle--multi').text(
							$('.smartStudioD__sideBarTitle--multi').attr(
								'step-4'
							)
						);
					}
					$('.smartStudioD__sideBarDot').removeClass(
						'smartStudioD__sideBarDot--active'
					);
					$(
						'.smartStudioD__sideBarDot[data-step="step-' +
							(slide + 1) +
							'"]'
					).show();
					$(
						'.smartStudioD__sideBarDot[data-step="step-' +
							(slide + 1) +
							'"]'
					).addClass('smartStudioD__sideBarDot--active');
				}
			});

			$('.smartStudioM__typeSlideNext').on('click', function () {
				if (
					!$(this)
						.find('img')
						.hasClass(
							'smartStudioM__typeSlideNextArrow--disabled'
						) &&
					!$(this)
						.find('img')
						.hasClass('smartStudioM__typeSlideNextArrow--end')
				) {
					var selectedStyle = $(
						'.smartStudioM__typeSlide[data-step="step-1"]'
					)
						.find('.smartStudioM__typeSlideButton--active')
						.attr('data-answer');

					slide += 1;

					if (slide == 1) {
						if (selectedStyle == 'plus') {
							$(this)
								.find('img')
								.addClass(
									'smartStudioM__typeSlideNextArrow--end'
								);
						} else {
							$(this)
								.find('img')
								.removeClass(
									'smartStudioM__typeSlideNextArrow--end'
								);
						}
					}
					if (slide == 2) {
						if (selectedStyle == 'touch') {
							$(this)
								.find('img')
								.addClass(
									'smartStudioM__typeSlideNextArrow--end'
								);
						} else {
							$(this)
								.find('img')
								.removeClass(
									'smartStudioM__typeSlideNextArrow--end'
								);
						}
					}

					goToSlideMobile(slide);
					$('.smartStudioM__typeSlidePrevious')
						.find('img')
						.removeClass(
							'smartStudioM__typeSlidePreviousArrow--disabled'
						);
					if (
						$(
							'[data-step="step-' +
								(slide + 1) +
								'"].smartStudioM__typeSlide'
						).find('.smartStudioM__typeSlideButton--active')
					) {
						$(this)
							.find('img')
							.removeClass(
								'smartStudioM__typeSlideNextArrow--disabled'
							);
					} else {
						$(this)
							.find('img')
							.addClass(
								'smartStudioM__typeSlideNextArrow--disabled'
							);
					}
					if (slide == 3) {
						$(this)
							.find('img')
							.addClass('smartStudioM__typeSlideNextArrow--end');
					}
					$('.smartStudioM__typeSlideBarDot').removeClass(
						'smartStudioM__typeSlideBarDot--active'
					);
					$(
						'.smartStudioM__typeSlideBarDot[data-step="step-' +
							(slide + 1) +
							'"]'
					).addClass('smartStudioM__typeSlideBarDot--active');
				}
			});

			$('.smartStudioD__sideBarDot').hide();
			$('.smartStudioD__sideBarDot[data-step="step-1"]').show();

			$('.smartStudioD__sideBarPrevious').on('click', function () {
				if (
					!$(this)
						.find('img')
						.hasClass(
							'smartStudioD__sideBarPreviousArrow--disabled'
						)
				) {
					slide -= 1;
					goToSlide(slide);
					$('.smartStudioD__sideBarNext')
						.find('img')
						.removeClass('smartStudioD__sideBarNextArrow--end');
					if (slide == 1) {
						$('.smartStudioD__sideBarTitle--multi').text(
							$('.smartStudioD__sideBarTitle--multi').attr(
								'step-2'
							)
						);
					}
					if (slide == 0) {
						$(this)
							.find('img')
							.addClass(
								'smartStudioD__sideBarPreviousArrow--disabled'
							);
						$('.smartStudioD__sideBarTitle--multi').text(
							$('.smartStudioD__sideBarTitle--multi').attr(
								'step-1'
							)
						);
					}
					$('.smartStudioD__sideBarDot').removeClass(
						'smartStudioD__sideBarDot--active'
					);
					$(
						'.smartStudioD__sideBarDot[data-step="step-' +
							(slide + 1) +
							'"]'
					).addClass('smartStudioD__sideBarDot--active');
				}
			});

			$('.smartStudioM__typeSlidePrevious').on('click', function () {
				if (
					!$(this)
						.find('img')
						.hasClass(
							'smartStudioM__typeSlidePreviousArrow--disabled'
						)
				) {
					slide -= 1;
					goToSlideMobile(slide);
					$('.smartStudioM__typeSlideNext')
						.find('img')
						.removeClass('smartStudioM__typeSlideNextArrow--end');
					if (slide == 0) {
						$(this)
							.find('img')
							.addClass(
								'smartStudioM__typeSlidePreviousArrow--disabled'
							);
					}
					$('.smartStudioM__typeSlideBarDot').removeClass(
						'smartStudioM__typeSlideBarDot--active'
					);
					$(
						'.smartStudioM__typeSlideBarDot[data-step="step-' +
							(slide + 1) +
							'"]'
					).addClass('smartStudioM__typeSlideBarDot--active');
				}
			});
		}

		if ($('#smart-studio-results').length > 0) {
			var homeLib = createHomeArray();
			var doorLib = createDoorArray();
			var lockLib = createLockArray();
			var handleLib = createHandleArray();
			var productLib = createProductArray();
			var handleProductLib = createHandleProductArray();

			function preloadImage(url) {
				var img = new Image();
				img.src = url;
			}
			for (i = 0; i < homeLib.length; i++) {
				preloadImage(homeLib[i].mobile);
				preloadImage(homeLib[i].preview);
				preloadImage(homeLib[i].src);
				preloadImage(homeLib[i].zoomed);
				preloadImage(homeLib[i].zoomedMobile);
			}
			for (i = 0; i < doorLib.length; i++) {
				preloadImage(doorLib[i].preview);
				preloadImage(doorLib[i].srcs.black);
				preloadImage(doorLib[i].srcs.blue);
				preloadImage(doorLib[i].srcs.gray);
				preloadImage(doorLib[i].srcs.green);
				preloadImage(doorLib[i].srcs.pink);
				preloadImage(doorLib[i].srcs.red);
				preloadImage(doorLib[i].srcs.sage);
				preloadImage(doorLib[i].srcs.salmon);
				preloadImage(doorLib[i].srcs.teal);
				preloadImage(doorLib[i].srcs.white);
				preloadImage(doorLib[i].srcs.midgray);
				preloadImage(doorLib[i].srcs.beige);
				preloadImage(doorLib[i].srcs.eggplant);
				preloadImage(doorLib[i].srcs.mobile_black);
				preloadImage(doorLib[i].srcs.mobile_blue);
				preloadImage(doorLib[i].srcs.mobile_gray);
				preloadImage(doorLib[i].srcs.mobile_green);
				preloadImage(doorLib[i].srcs.mobile_pink);
				preloadImage(doorLib[i].srcs.mobile_red);
				preloadImage(doorLib[i].srcs.mobile_sage);
				preloadImage(doorLib[i].srcs.mobile_salmon);
				preloadImage(doorLib[i].srcs.mobile_teal);
				preloadImage(doorLib[i].srcs.mobile_white);
				preloadImage(doorLib[i].srcs.mobile_yellow);
				preloadImage(doorLib[i].srcs.mobile_midgray);
				preloadImage(doorLib[i].srcs.mobile_beige);
				preloadImage(doorLib[i].srcs.mobile_eggplant);
				preloadImage(doorLib[i].srcs.zoom_black);
				preloadImage(doorLib[i].srcs.zoom_blue);
				preloadImage(doorLib[i].srcs.zoom_gray);
				preloadImage(doorLib[i].srcs.zoom_green);
				preloadImage(doorLib[i].srcs.zoom_pink);
				preloadImage(doorLib[i].srcs.zoom_red);
				preloadImage(doorLib[i].srcs.zoom_sage);
				preloadImage(doorLib[i].srcs.zoom_salmon);
				preloadImage(doorLib[i].srcs.zoom_teal);
				preloadImage(doorLib[i].srcs.zoom_white);
				preloadImage(doorLib[i].srcs.zoom_yellow);
				preloadImage(doorLib[i].srcs.zoom_midgray);
				preloadImage(doorLib[i].srcs.zoom_beige);
				preloadImage(doorLib[i].srcs.zoom_eggplant);
				preloadImage(doorLib[i].srcs.zoom_mobile_black);
				preloadImage(doorLib[i].srcs.zoom_mobile_blue);
				preloadImage(doorLib[i].srcs.zoom_mobile_gray);
				preloadImage(doorLib[i].srcs.zoom_mobile_green);
				preloadImage(doorLib[i].srcs.zoom_mobile_pink);
				preloadImage(doorLib[i].srcs.zoom_mobile_red);
				preloadImage(doorLib[i].srcs.zoom_mobile_sage);
				preloadImage(doorLib[i].srcs.zoom_mobile_salmon);
				preloadImage(doorLib[i].srcs.zoom_mobile_teal);
				preloadImage(doorLib[i].srcs.zoom_mobile_white);
				preloadImage(doorLib[i].srcs.zoom_mobile_yellow);
				preloadImage(doorLib[i].srcs.zoom_mobile_midgray);
				preloadImage(doorLib[i].srcs.zoom_mobile_beige);
				preloadImage(doorLib[i].srcs.zoom_mobile_eggplant);
			}
			for (i = 0; i < lockLib.length; i++) {
				preloadImage(lockLib[i].previews.black);
				preloadImage(lockLib[i].previews.bronze);
				preloadImage(lockLib[i].previews.silver);
				preloadImage(lockLib[i].srcs.black);
				preloadImage(lockLib[i].srcs.bronze);
				preloadImage(lockLib[i].srcs.silver);
				preloadImage(lockLib[i].srcs.mobile_black);
				preloadImage(lockLib[i].srcs.mobile_bronze);
				preloadImage(lockLib[i].srcs.mobile_silver);
				preloadImage(lockLib[i].srcs.zoom_black);
				preloadImage(lockLib[i].srcs.zoom_bronze);
				preloadImage(lockLib[i].srcs.zoom_silver);
				preloadImage(lockLib[i].srcs.zoom_mobile_black);
				preloadImage(lockLib[i].srcs.zoom_mobile_bronze);
				preloadImage(lockLib[i].srcs.zoom_mobile_silver);
				if (typeof lockLib[i].previews.pantone !== 'undefined') {
					preloadImage(lockLib[i].previews.pantone);
					preloadImage(lockLib[i].srcs.pantone);
					preloadImage(lockLib[i].srcs.mobile_pantone);
					preloadImage(lockLib[i].srcs.zoom_pantone);
					preloadImage(lockLib[i].srcs.zoom_mobile_pantone);
				}
			}
			for (i = 0; i < handleLib.length; i++) {
				preloadImage(handleLib[i].mobile);
				preloadImage(handleLib[i].preview);
				preloadImage(handleLib[i].src);
				preloadImage(handleLib[i].zoom_src);
				preloadImage(handleLib[i].zoom_mobile);
			}

			var urlSearch = window.location.search;
			var decodedUrlSearch = decodeURIComponent(
				(urlSearch + '').replace(/\+/g, '%20')
			);
			var urlDataString = '{' + decodedUrlSearch.split('=')[1] + '}';
			var urlData = JSON.parse(urlDataString);

			function setShowBox(data) {
				var color = data.color;
				var doorIndex = data.door * 1;
				var finishIndex = data.finish * 1;
				var handleIndex = data.handle * 1;
				var homeIndex = data.home * 1;
				var style = data.style;
				var key = data.key;
				var lock = data.lock;
				var tech = data.tech;

				var desktopDoor = '';
				var mobileDoor = '';

				if (color == 'white') {
					desktopDoor = doorLib[doorIndex].srcs.white;
					mobileDoor = doorLib[doorIndex].srcs.mobile_white;
				} else if (color == 'pink') {
					desktopDoor = doorLib[doorIndex].srcs.pink;
					mobileDoor = doorLib[doorIndex].srcs.mobile_pink;
				} else if (color == 'salmon') {
					desktopDoor = doorLib[doorIndex].srcs.salmon;
					mobileDoor = doorLib[doorIndex].srcs.mobile_salmon;
				} else if (color == 'blue') {
					desktopDoor = doorLib[doorIndex].srcs.blue;
					mobileDoor = doorLib[doorIndex].srcs.mobile_gray;
				} else if (color == 'gray') {
					desktopDoor = doorLib[doorIndex].srcs.gray;
					mobileDoor = doorLib[doorIndex].srcs.mobile_gray;
				} else if (color == 'red') {
					desktopDoor = doorLib[doorIndex].srcs.red;
					mobileDoor = doorLib[doorIndex].srcs.mobile_red;
				} else if (color == 'yellow') {
					desktopDoor = doorLib[doorIndex].srcs.yellow;
					mobileDoor = doorLib[doorIndex].srcs.mobile_yellow;
				} else if (color == 'teal') {
					desktopDoor = doorLib[doorIndex].srcs.teal;
					mobileDoor = doorLib[doorIndex].srcs.mobile_teal;
				} else if (color == 'black') {
					desktopDoor = doorLib[doorIndex].srcs.black;
					mobileDoor = doorLib[doorIndex].srcs.mobile_black;
				} else if (color == 'sage') {
					desktopDoor = doorLib[doorIndex].srcs.sage;
					mobileDoor = doorLib[doorIndex].srcs.mobile_sage;
				} else if (color == 'green') {
					desktopDoor = doorLib[i].srcs.green;
					mobileDoor = doorLib[i].srcs.mobile_green;
				} else if (color == 'midgray') {
					desktopDoor = doorLib[i].srcs.midgray;
					mobileDoor = doorLib[i].srcs.mobile_midgray;
				} else if (color == 'beige') {
					desktopDoor = doorLib[i].srcs.beige;
					mobileDoor = doorLib[i].srcs.mobile_beige;
				} else if (color == 'eggplant') {
					desktopDoor = doorLib[i].srcs.eggplant;
					mobileDoor = doorLib[i].srcs.mobile_eggplant;
				}

				var selected = 0;
				if (style == 'standard') {
					if (key == 'keyfree') {
						if (lock == 'touchscreen') {
							selected = lockLib[4];
						} else {
							selected = lockLib[6];
						}
					} else {
						if (lock == 'touchscreen') {
							selected = lockLib[3];
						} else {
							selected = lockLib[5];
						}
					}
				} else if (style == 'touch') {
					if (key == 'keyfree') {
						selected = lockLib[1];
					} else {
						selected = lockLib[0];
					}
				} else if (style == 'plus') {
					selected = lockLib[2];
				}

				var desktopLock = '';
				var mobileLock = '';
				if (finishIndex == 0) {
					desktopLock = selected.srcs.black;
					mobileLock = selected.srcs.mobile_black;
				} else if (finishIndex == 1) {
					desktopLock = selected.srcs.silver;
					mobileLock = selected.srcs.mobile_silver;
				} else if (finishIndex == 2) {
					desktopLock = selected.srcs.bronze;
					mobileLock = selected.srcs.mobile_bronze;
				} else if (finishIndex == 3) {
					desktopLock = selected.srcs.pantone;
					mobileLock = selected.srcs.mobile_pantone;
				} else {
					desktopLock = selected.srcs.bronze;
					mobileLock = selected.srcs.mobile_bronze;
				}

				$('.studioResults__heroBoxDesktopHome').attr(
					'src',
					homeLib[homeIndex].src
				);
				$('.studioResults__heroBoxDesktopDoor').attr(
					'src',
					desktopDoor
				);
				$('.studioResults__heroBoxDesktopLock').attr(
					'src',
					desktopLock
				);
				$('.studioResults__heroBoxDesktopHandle').attr(
					'src',
					handleLib[handleIndex].src
				);

				$('.studioResults__heroBoxMobileHome').attr(
					'src',
					homeLib[homeIndex].mobile
				);
				$('.studioResults__heroBoxMobileDoor').attr('src', mobileDoor);
				$('.studioResults__heroBoxMobileLock').attr('src', mobileLock);
				$('.studioResults__heroBoxMobileHandle').attr(
					'src',
					handleLib[handleIndex].mobile
				);
			}
			setShowBox(urlData);

			var chooseString = 'Yale Assure Lock 2 ';

			if (urlData.style == 'stardard') {
			} else if (urlData.style == 'touch') {
				chooseString += 'Touch ';
			} else if (urlData.style == 'plus') {
				chooseString += 'Plus ';
			}

			if (urlData.key == 'keyed') {
				chooseString += 'with Keys | ';
			} else {
				chooseString += 'without Keys | ';
			}
			if (urlData.tech == 'wifi') {
				chooseString += 'Wi-Fi Upgrade | ';
			} else if (urlData.tech == 'bluetooth') {
				chooseString += 'Bluetooth | ';
			}
			if (urlData.finish == 0) {
				chooseString += 'Matte Black | ';
			} else if (urlData.finish == 1) {
				chooseString += 'Silver | ';
			} else if (urlData.finish == 2) {
				chooseString += 'Bronze | ';
			} else if (urlData.finish == 3) {
				chooseString += 'Pantone 18-1750, Viva Magenta | ';
			} else {
				chooseString += 'Bronze | ';
			}
			var yourtext = handleProductLib[urlData.handle * 1].name;
			var capitalized =
				yourtext.substr(0, 1).toUpperCase() + yourtext.substr(1);
			chooseString += capitalized + ' Hardware';

			$('.studioResults__textBucket').text(chooseString);

			function checkBlack(string) {
				if (
					string == 'black' ||
					string == 'Black' ||
					string == 'matte black' ||
					string == 'Matte Black' ||
					string == 'black suede' ||
					string == 'Black Suede'
				) {
					return true;
				} else {
					return false;
				}
			}
			function checkSilver(string) {
				if (
					string == 'silver' ||
					string == 'Silver' ||
					string == 'satin nickel' ||
					string == 'Satin Nickel' ||
					string == 'polished chrome' ||
					string == 'Polished Chrome' ||
					string == 'satin chrome' ||
					string == 'Satin Chrome'
				) {
					return true;
				} else {
					return false;
				}
			}
			function checkBronze(string) {
				if (
					string == 'bronze' ||
					string == 'Bronze' ||
					string == 'oil rubbed bronze' ||
					string == 'Oil Rubbed Bronze' ||
					string == 'polished brass' ||
					string == 'Polished Brass'
				) {
					return true;
				} else {
					return false;
				}
			}
			function checkPantone(string) {
				if (
					string.indexOf('magenta') > 0 ||
					string.indexOf('Magenta') > 0
				) {
					return true;
				} else {
					return false;
				}
			}

			function pickProducts(data) {
				var finishIndex = data.finish * 1;
				var style = data.style;
				var key = data.key;
				var lock = data.lock;
				var tech = data.tech;
				var handleIndex = data.handle * 1;

				$('.studioCard--lock').each(function () {
					var thisStyle = $(this).attr('data-style');
					var thisKey = $(this).attr('data-key');
					var thisLock = $(this).attr('data-lock');
					var thisTech = $(this).attr('data-tech');
					var thisFinish = $(this).attr('data-finish');
					if (thisKey == key || key == 'either') {
						if (
							thisLock == lock &&
							thisTech == tech &&
							thisStyle == style
						) {
							if (finishIndex == 0 && checkBlack(thisFinish)) {
								$(this).show();
							} else if (
								finishIndex == 1 &&
								checkSilver(thisFinish)
							) {
								$(this).show();
							} else if (
								finishIndex == 2 &&
								checkBronze(thisFinish)
							) {
								$(this).show();
							} else if (
								finishIndex == 3 &&
								checkPantone(thisFinish)
							) {
								$(this).show();
							} else {
								$(this).hide();
							}
						} else {
							$(this).hide();
						}
					} else {
						$(this).hide();
					}
				});

				$('.studioCard--handle').each(function () {
					var thisFinish = $(this).attr('data-finish');
					if (
						$(this).attr('data-handle') == 'ridgefield' &&
						handleIndex == 0
					) {
						if (finishIndex == 0 && checkBlack(thisFinish)) {
							$(this).show();
						} else if (
							finishIndex == 1 &&
							checkSilver(thisFinish)
						) {
							$(this).show();
						} else if (
							finishIndex == 2 &&
							checkBronze(thisFinish)
						) {
							$(this).show();
						} else if (finishIndex == 3 && checkBlack(thisFinish)) {
							$(this).show();
						} else {
							$(this).hide();
						}
					} else if (
						$(this).attr('data-handle') == 'kincaid' &&
						handleIndex == 1
					) {
						if (finishIndex == 0 && checkBlack(thisFinish)) {
							$(this).show();
						} else if (
							finishIndex == 1 &&
							checkSilver(thisFinish)
						) {
							$(this).show();
						} else if (
							finishIndex == 2 &&
							checkBronze(thisFinish)
						) {
							$(this).show();
						} else if (finishIndex == 3 && checkBlack(thisFinish)) {
							$(this).show();
						} else {
							$(this).hide();
						}
					} else if (
						$(this).attr('data-handle') == 'valdosta' &&
						handleIndex == 2
					) {
						if (finishIndex == 0 && checkBlack(thisFinish)) {
							$(this).show();
						} else if (
							finishIndex == 1 &&
							checkSilver(thisFinish)
						) {
							$(this).show();
						} else if (
							finishIndex == 2 &&
							checkBronze(thisFinish)
						) {
							$(this).show();
						} else if (finishIndex == 3 && checkBlack(thisFinish)) {
							$(this).show();
						} else {
							$(this).hide();
						}
					} else {
						$(this).hide();
					}
				});
			}
			pickProducts(urlData);

			function addToCart(variant, qty, keyed) {
				if (checkDiscountLimitFull(variant)) {
					alert(
						'You can only order up to ' +
							$('body').attr('data-qty-limit') * 1 +
							' discounted items.'
					);
					return;
				}
				if (typeof keyed !== 'undefined' && keyed) {
					CartJS.addItem(
						variant,
						qty,
						{ _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
						{
							success: function (data, textStatus, jqXHR) {
								setTimeout(function () {
									updateCart(true);
								}, 200);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				} else {
					CartJS.addItem(
						variant,
						qty,
						{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
						{
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				}
			}

			$('.studioCard__extendWrapper').each(function () {
				var variantId = $(this).attr('data-id');
				var thisPrice = $(this).attr('data-price');
				var thisType = $(this).attr('data-type');
				var id = '#' + $(this).attr('id');
				Extend.buttons.render(id, {
					referenceId: variantId,
					price: thisPrice,
					category: thisType,
				});
				$(this)
					.parent()
					.find('.studioCard__buyButton')
					.on('click', function () {
						var qty =
							$(this)
								.parent()
								.parent()
								.find('.studioCard__quantity')
								.text() * 1;
						ExtendShopify.handleAddToCart(id, {
							quantity: qty,
							modal: false,
							done: function () {
								if (keyed == 'true') {
									addToCart(variantId, qty, 'true');
								} else {
									addToCart(variantId, qty);
								}
							},
						});
					});
			});

			$('.studioCard__quantityMinus').on('click', function () {
				var target = $(this).parent().find('.studioCard__quantity');
				if (target.text() * 1 > 1) {
					target.text(target.text() * 1 - 1);
				}
			});

			$('.studioCard__quantityPlus').on('click', function () {
				var target = $(this).parent().find('.studioCard__quantity');
				target.text(target.text() * 1 + 1);
			});
		}

		if ($('#shopify-section-matterNotify').length > 0) {
			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}

		if ($('#edit-keyed-alike').length > 0) {
			function getKeyableItems() {
				var keyableItems = [];
				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties[
							'_keyed_alike_available'
						] == 'true'
					) {
						var clone = JSON.parse(
							JSON.stringify(CartJS.cart.items[i])
						);
						clone.index = i + 1;
						keyableItems.push(clone);
					}
				}
				return keyableItems;
			}

			function getSavedItems() {
				var savedItems = [];
				for (i = 0; i < CartJS.cart.items.length; i++) {
					if (
						CartJS.cart.items[i].properties['_name'] ==
						'keyed_alike_group'
					) {
						var clone = JSON.parse(
							JSON.stringify(CartJS.cart.items[i])
						);
						savedItems.push(clone);
					}
				}
				return savedItems;
			}

			var mobileGroupItemTemplate = $('.kaMGroup__prodList').html();
			$('.kaMGroup__prodList').html('');

			function fillCartListing(prodList) {
				var template = $('.ka__cartList').html();
				$('.ka__cartList').html('');

				var mobTemplate = $('.kaM__cartItems').html();
				$('.kaM__cartItems').html('');

				for (i = 0; i < prodList.length; i++) {
					var prod = prodList[i];
					if (
						$('.kaCartItem[data-id="' + prod.variant_id + '"]')
							.length == 0
					) {
						$('.ka__cartList').html(
							$('.ka__cartList').html() + template
						);
						var target = $('.kaCartItem').last();
						target.attr('data-id', prod.variant_id);
						target.attr('data-type', prod.product_type);
						target.attr('data-qty', prod.quantity);
						target.attr('data-qtyavailable', prod.quantity);
						target
							.find('.kaCartItem__image')
							.attr('src', prod.image)
							.attr('alt', prod.title);
						if (prod.variant_title != 'default') {
							target
								.find('.kaCartItem__title')
								.html(
									prod.product_title +
										'</br>' +
										prod.variant_title
								);
						} else {
							target
								.find('.kaCartItem__title')
								.html(prod.product_title);
						}
						target
							.find(
								'.kaCartItem__showQty, .kaCartItem__editQtyAvailable, .kaCartItem__editQtyTotal'
							)
							.text(prod.quantity);

						//mobile
						$('.kaM__cartItems').html(
							$('.kaM__cartItems').html() + mobTemplate
						);
						var mobTarget = $('.kaMCartItem').last();
						mobTarget.attr('data-id', prod.variant_id);
						mobTarget.attr('data-type', prod.product_type);
						mobTarget.attr('data-qty', prod.quantity);
						mobTarget
							.find('.kaMCartItem__img')
							.attr('src', prod.image)
							.attr('alt', prod.title);
						if (prod.variant_title != 'default') {
							mobTarget
								.find('.kaMCartItem__title')
								.html(
									prod.product_title +
										'</br>' +
										prod.variant_title
								);
						} else {
							mobTarget
								.find('.kaMCartItem__title')
								.html(prod.product_title);
						}

						mobTarget
							.find('.kaMCartItem__qty')
							.text(prod.quantity + '/' + prod.quantity);
					} else {
						var target = $(
							'.kaCartItem[data-id="' + prod.variant_id + '"]'
						);
						var currentQty = target.attr('data-qty') * 1;
						target.attr('data-qty', currentQty + prod.quantity);
						target.attr(
							'data-qtyavailable',
							currentQty + prod.quantity
						);
						target.attr('data-type', prod.product_type);
						target
							.find('.kaCartItem__editQtyTotal')
							.text(currentQty + prod.quantity);
						target
							.find('.kaCartItem__showQty')
							.text(currentQty + prod.quantity);
					}

					//mobile group template generation
					var mobileCurrentProds = $('.kaMGroup__prodList').html();
					if (
						$('.kaMProd[data-id="' + prod.variant_id + '"]')
							.length == 0
					) {
						$('.kaMGroup__prodList').html(
							mobileCurrentProds + mobileGroupItemTemplate
						);
						var mobileNewProd = $('.kaMGroup__prodList')
							.find('.kaMProd')
							.last();
						mobileNewProd.attr('data-qty', prod.quantity);
						mobileNewProd.find('.kaMProd__qty').text(prod.quantity);
						mobileNewProd.attr('data-max-qty', prod.quantity);
						mobileNewProd.attr('data-id', prod.id);
						mobileNewProd.attr('data-type', prod.product_type);
						mobileNewProd.attr('data-group', '0');
						mobileNewProd
							.find('.kaMProd__image')
							.attr('src', prod.image);
						mobileNewProd
							.find('.kaMProd__image')
							.attr('alt', prod.title);
						if (prod.variant_title != 'default') {
							mobileNewProd
								.find('.kaMProd__title')
								.html(
									prod.product_title +
										'</br>' +
										prod.variant_title
								);
						} else {
							mobileNewProd
								.find('.kaMProd__title')
								.text(prod.product_title);
						}
						mobileNewProd
							.find('.kaMProd__minusButton')
							.addClass('kaMProd__minusButton--disabled');
					} else {
						var mobileTarget = $(
							'.kaMProd[data-id="' + prod.variant_id + '"]'
						);
						var mobileCurrentQty =
							mobileTarget.attr('data-qty') * 1;
						mobileTarget.attr(
							'data-qty',
							mobileCurrentQty + prod.quantity
						);
						mobileTarget.attr(
							'data-max-qty',
							mobileCurrentQty + prod.quantity
						);
						mobileTarget.attr('data-type', prod.product_type);
						mobileTarget
							.find('.kaMProd__qty')
							.text(mobileCurrentQty + prod.quantity);
						mobileTarget
							.find('.kaMProd__minusButton')
							.addClass('kaMProd__minusButton--disabled');
					}
				}

				mobileGroupTemplate = $('.kaM__groupsList').html();
				$('.kaM__groupsList').html('');

				bindPlusButton();
				bindMinusButton();
				bindMobilePlusButton();
				bindMobileCreateGroup();

				bindMobileRemoveEvents();
				bindMobileSliders();
			}

			function fillSavedProducts(prodList) {
				for (i = 0; i < prodList.length; i++) {
					var prodData = prodList[i];
					var thisGroup = prodData.properties['_value'];
					var thisQty = prodData.quantity * 1;
					var thisId = prodData.variant_id;
					var thisTitle = prodData.product_title;
					var thisType = prodData.product_type;

					var product = $('.kaCartItem[data-id="' + thisId + '"]');
					var productImage = product
						.find('.kaCartItem__image')
						.attr('src');
					var productTitle = product
						.find('.kaCartItem__image')
						.attr('alt');
					var productQty = product.attr('data-qty') * 1;
					var productMaxQty = product.attr('data-qtyavailable');

					if (
						$('.kaGroup[data-group="' + thisGroup + '"]').length ==
						0
					) {
						var groupNumber = thisGroup * 1;
						for (j = 0; j < groupNumber; j++) {
							if (
								$('.kaGroup[data-group="' + (j * 1 + 1) + '"]')
									.length == 0
							) {
								var currentGroups = $('.kaGroups').html();
								$('.kaGroups').html(
									currentGroups + groupTemplate
								);
								var target = $('.kaGroup').last();
								target.find('.kaGroup__index').text(j * 1 + 1);
								target.attr('data-group', j * 1 + 1);
								target.attr('data-state', 'saved');
								groupStateCSS(target);

								//mobile
								var mobCurrentGroups =
									$('.kaM__groupsList').html();
								$('.kaM__groupsList').html(
									mobCurrentGroups + mobileGroupTemplate
								);
								var mobTarget = $('.kaM__groupWrapper').last();
								mobTarget
									.find(
										'.kaMGroup__titleNumber, .kaM__groupNumber'
									)
									.text(j * 1 + 1);
								mobTarget.attr('data-group', j * 1 + 1);
								mobTarget.attr('data-state', 'saved');
							}
						}
					}

					var group = $('.kaGroup[data-group="' + thisGroup + '"]');

					var currentProds = group
						.find('.kaGroup__productList')
						.html();
					group
						.find('.kaGroup__productList')
						.html(currentProds + groupItemTemplate);

					var newProd = group.find('.kaGroupProd').last();
					newProd.attr('data-qty', thisQty);
					newProd.find('.kaGroupProd__qty').text(thisQty);
					newProd.attr('data-id', thisId);
					newProd.attr('data-type', thisType);
					newProd.attr('data-group', thisGroup);
					newProd
						.find('.kaGroupProd__image')
						.attr('src', productImage);
					newProd.find('.kaGroupProd__image').attr('alt', thisTitle);
					newProd.find('.kaGroupProd__title').text(thisTitle);

					product.attr('data-qty', productQty - thisQty);
					product
						.find('.kaCartItem__editQtyAvailable')
						.text(productQty - thisQty);
					product
						.find('.kaCartItem__showQty')
						.text(productQty - thisQty);
					if (
						product.find('.kaCartItem__editQtyAvailable').text() ==
						'0'
					) {
						product
							.find('.kaCartItem__plusButton')
							.addClass('kaCartItem__plusButton--disabled');
					}
				}

				$('.kaCartItem').each(function () {
					var thisQty = $(this).attr('data-qty');
					var thisId = $(this).attr('data-id');

					var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
					var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;

					mobProd.attr('data-qty', thisQty);
					var mobProdQty =
						mobProdQtyMax - mobProd.attr('data-qty') * 1;
					var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;

					mobProd.find('.kaMProd__qty').text(mobProdQtyString);
					if (mobProdQty == 0) {
						mobProd
							.find('.kaMProd__plusButton')
							.addClass('kaMProd__plusButton--disabled');
					} else if (mobProdQty == mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.addClass('kaMProd__minusButton--disabled');
					} else if (mobProdQty < mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.removeClass('kaMProd__minusButton--disabled');
					}

					$('.kaMCartItem[data-id="' + thisId + '"]')
						.find('.kaMCartItem__qty')
						.text(thisQty + '/' + thisQty);
				});

				var subtotal = 0;
				$('.kaGroupProd').each(function () {
					subtotal += $(this).attr('data-qty') * 1 * 3.99;
				});
				subtotal = subtotal.toFixed(2);
				$('.ka__groupSubtotalPrice').text('$' + subtotal);
				$('.kaMFooter__subtotalPrice').text('$' + subtotal);

				var totalQty = 0;
				$('.kaCartItem__showQty').each(function () {
					var addQty = $(this).text() * 1;
					totalQty += addQty;
				});
				if (totalQty == 0) {
					$('.kaGroups__createButton').addClass(
						'kaGroups__createButton--hidden'
					);
					$('.kaM__groupsAddNewWrapper').addClass(
						'kaM__groupsAddNew--hidden'
					);
				}

				$('.kaM__groupsAddNewWrapper').addClass(
					'kaM__groupsAddNewWrapper--remove'
				);
				$('.kaM__groupsAddNewWrapper')
					.last()
					.removeClass('kaM__groupsAddNewWrapper--remove');
				$('.kaM__groupsAddNewWrapper--remove').remove();

				if ($('.kaGroup').length > 0) {
					pageState = 'saved';
					stateCSS(pageState);
				} else {
					pageState = 'empty';
					stateCSS(pageState);
				}

				bindMinusButton();
				bindMobilePlusButton();
				bindMobileCreateGroup();

				bindSaveGroup();
				bindEditGroup();
				bindSlideGroup();
				bindRemoveGroup();

				bindMobileRemoveEvents();
				bindMobileSliders();
			}

			function afterCartJSLoad() {
				var keyableItems = getKeyableItems();
				var savedItems = getSavedItems();
				fillCartListing(keyableItems);
				fillSavedProducts(savedItems);

				if ($('.kaGroup').last().attr('data-group') == '1') {
					$('.kaGroup').each(function () {
						$(this).attr('data-active', 'false');
						$(this).attr('data-state', 'saved');
						var firstGroupedType = $(this)
							.find('.kaGroupProd')
							.attr('data-type');
						$(this).attr('data-type', firstGroupedType);
						groupStateCSS($(this));
					});
					var group = $('.kaGroup').last();
					group.attr('data-saved', 'true');
					group.attr('data-active', 'true');
					group.attr('data-state', 'editing');
					pageState = 'editing';
					groupStateCSS(group);
					stateCSS(pageState);
				}
			}

			var CartJSInterval = setInterval(function () {
				if (typeof CartJS.cart.items !== 'undefined') {
					afterCartJSLoad();
					clearInterval(CartJSInterval);
				}
			}, 10);

			// options are: 'empty', 'groups', 'editing', 'saved'
			var pageState = 'empty';

			var groupItemTemplate = $('.kaGroup__productList').html();
			$('.kaGroup__productList').html('');
			var groupTemplate = $('.kaGroups').html();
			$('.kaGroups').html('');

			var mobileGroupTemplate = '';

			function addNewGroup() {
				var groupCount = $('.kaGroup').length + 1;
				var currentGroups = $('.kaGroups').html();
				$('.kaGroups').html(currentGroups + groupTemplate);
				var target = $('.kaGroup').last();
				target.find('.kaGroup__index').text(groupCount);
				target.attr('data-group', groupCount);
				target.attr('data-state', 'empty');
				target.attr('data-active', 'true');
				target.attr('data-type', 'none');

				var mobileCurrentGroups = $('.kaM__groupsList').html();
				$('.kaM__groupsList').html(
					mobileCurrentGroups + mobileGroupTemplate
				);
				var target = $('.kaM__groupWrapper').last();
				target
					.find('.kaMGroup__titleNumber, .kaM__groupNumber')
					.text(groupCount);
				target.attr('data-group', groupCount);
				target.attr('data-state', 'empty');
				target.attr('data-active', 'true');
				target.attr('data-type', 'none');

				$('.kaCartItem').each(function () {
					var thisQty = $(this).attr('data-qty');
					var thisId = $(this).attr('data-id');

					var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
					var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;
					mobProd.attr('data-qty', thisQty);
					var mobProdQty =
						mobProdQtyMax - mobProd.attr('data-qty') * 1;
					var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;

					mobProd.find('.kaMProd__qty').text(mobProdQtyString);
					if (mobProdQty == 0) {
						mobProd
							.find('.kaMProd__plusButton')
							.addClass('kaMProd__plusButton--disabled');
					} else if (mobProdQty == mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.addClass('kaMProd__minusButton--disabled');
					} else if (mobProdQty < mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.removeClass('kaMProd__minusButton--disabled');
					}
				});

				bindSaveGroup();
				bindEditGroup();
				bindSlideGroup();
				bindRemoveGroup();

				bindMobileRemoveEvents();
				bindMobileSliders();

				$('.kaM__groupsAddNewWrapper').addClass(
					'kaM__groupsAddNewWrapper--remove'
				);
				$('.kaM__groupsAddNewWrapper')
					.last()
					.removeClass('kaM__groupsAddNewWrapper--remove');
				$('.kaM__groupsAddNewWrapper--remove').remove();
			}

			function stateCSS(state) {
				if (state == 'empty') {
					$('.kaState__empty').show();

					$('.kaState__full').hide();
					$('.ka__groupFrameLower').hide();

					$('.kaCartItem__showQty').hide();
					$('.kaCartItem__editQty').show();

					$('.kaCartItem__plusButton').show();

					$('.kaGroups__createButton').hide();
					$('.ka__groupButtonRow').slideUp();

					//mobile
					$('.kaM__groupsEmptyWrapper').show();
					$('.kaM__groupsListWrapper').hide();
					$('.kaMFooter').hide();
					$('.kaM__groupsAddNewWrapper').hide();
					$('.kaMFooter__completeButton').hide();
					$('.kaMFooter__saveGroupButton').hide();
				} else if (state == 'groups') {
					$('.kaState__empty').hide();

					$('.kaState__full').show();
					$('.ka__groupFrameLower').show();

					$('.kaCartItem__showQty').hide();
					$('.kaCartItem__editQty').show();

					$('.kaCartItem__plusButton').show();
					$('.kaGroups__createButton').hide();
					$('.ka__groupButtonRow').slideUp();

					//mobile
					$('.kaM__groupsEmptyWrapper').hide();
					$('.kaM__groupsListWrapper').show();
					$('.kaMFooter').show();
					$('.kaM__groupsAddNewWrapper').hide();
					$('.kaMFooter__completeButton').hide();
					$('.kaMFooter__saveGroupButton').hide();
				} else if (state == 'editing') {
					$('.kaState__empty').hide();

					$('.kaState__full').show();
					$('.ka__groupFrameLower').show();

					$('.kaCartItem__showQty').hide();
					$('.kaCartItem__editQty').show();

					$('.kaCartItem__plusButton').show();
					$('.kaGroups__createButton').hide();
					$('.ka__groupButtonRow').slideUp();

					//mobile
					$('.kaM__groupsEmptyWrapper').hide();
					$('.kaM__groupsListWrapper').show();
					$('.kaMFooter').show();
					$('.kaM__groupsAddNewWrapper').hide();
					$('.kaMFooter__completeButton').hide();
					$('.kaMFooter__saveGroupButton').show();
				} else if (state == 'saved') {
					$('.kaState__empty').hide();

					$('.kaState__full').show();
					$('.ka__groupFrameLower').show();

					$('.kaCartItem__showQty').hide();
					$('.kaCartItem__editQty').show();

					$('.kaCartItem__plusButton').hide();
					$('.kaGroups__createButton').show();
					$('.ka__groupButtonRow').slideDown();

					//mobile
					$('.kaM__groupsEmptyWrapper').hide();
					$('.kaM__groupsListWrapper').show();
					$('.kaMFooter').show();
					$('.kaM__groupsAddNewWrapper').show();
					$('.kaMFooter__completeButton').show();
					$('.kaMFooter__saveGroupButton').hide();
				} else if (state == 'completed') {
					$('.kaState__empty').hide();

					$('.kaState__full').show();
					$('.ka__groupFrameLower').show();

					$('.kaCartItem__showQty').hide();
					$('.kaCartItem__editQty').show();

					$('.kaCartItem__plusButton').hide();
					$('.kaGroups__createButton').show();
					$('.ka__groupButtonRow').slideUp();

					//mobile
					$('.kaM__groupsEmptyWrapper').hide();
					$('.kaM__groupsListWrapper').show();
					$('.kaMFooter').show();
					$('.kaM__groupsAddNewWrapper').show();
					$('.kaMFooter__completeButton').show();
					$('.kaMFooter__saveGroupButton').hide();
				}
			}

			function groupStateCSS(group) {
				if (group.attr('data-state') == 'empty') {
					group.find('.kaGroup__empty').show();
					group.find('.kaGroup__productList').hide();
					group.find('.kaGroup__unsavedButtonRow').hide();
					group.find('.kaGroup__savedButtonRow').show();
					group.find('.kaGroup__arroe').hide();
					group.find('.kaGroupProd__removeButton').show();
					group.find('.kaGroup__editButton').hide();
				} else if (group.attr('data-state') == 'saved') {
					group.find('.kaGroup__empty').hide();
					group.find('.kaGroup__productList').show();
					group.find('.kaGroup__unsavedButtonRow').hide();
					group.find('.kaGroup__savedButtonRow').show();
					group.find('.kaGroup__arroe').show();
					group.find('.kaGroupProd__removeButton').hide();
					group.find('.kaGroup__editButton').show();
				} else if (group.attr('data-state') == 'editing') {
					group.find('.kaGroup__empty').hide();
					group.find('.kaGroup__productList').show();
					group.find('.kaGroup__unsavedButtonRow').show();
					group.find('.kaGroup__savedButtonRow').hide();
					group.find('.kaGroup__arroe').hide();
					group.find('.kaGroupProd__removeButton').show();
					group.find('.kaGroup__editButton').show();
				}
			}

			$('.kaEmpty__startButton').on('click', function () {
				pageState = 'groups';
				stateCSS(pageState);
				addNewGroup();
				groupStateCSS($('.kaGroup').last());
			});

			$('.kaM__groupsEmptyCreateNew').on('click', function () {
				pageState = 'editing';
				stateCSS(pageState);
				addNewGroup();
				groupStateCSS($('.kaGroup').last());
			});

			function addProductToGroup(product, group) {
				var id = product.attr('data-id');
				var productImage = product
					.find('.kaCartItem__image')
					.attr('src');
				var productTitle = product
					.find('.kaCartItem__image')
					.attr('alt');
				var qty = product.attr('data-qty') * 1;

				var sameType = true;

				if (group.attr('data-type') == 'none') {
					group.attr('data-type', product.attr('data-type'));
				} else {
					if (
						!compareProdTypes(
							product.attr('data-type'),
							group.attr('data-type')
						)
					) {
						sameType = false;
						$('.kaTypePopup').fadeIn();
					}
				}

				if (sameType == true) {
					group.attr('data-state', 'editing');
					groupStateCSS(group);

					var mobileGroup = $(
						'.kaM__groupWrapper[data-group="' +
							group.attr('data-group') +
							'"]'
					);

					if (qty > 0) {
						var currentProds = group
							.find('.kaGroup__productList')
							.html();
						var mobileCurrentProds = mobileGroup
							.find('.kaMGroup__prodList')
							.html();
						if (
							group.find('.kaGroupProd[data-id="' + id + '"]')
								.length == 0
						) {
							group
								.find('.kaGroup__productList')
								.html(currentProds + groupItemTemplate);
							var prod = group.find('.kaGroupProd').last();
							prod.attr('data-qty', 1);
							prod.find('.kaGroupProd__qty').text(1);
							prod.attr('data-id', id);
							prod.attr('data-group', group.attr('data-group'));
							prod.find('.kaGroupProd__image').attr(
								'src',
								productImage
							);
							prod.find('.kaGroupProd__image').attr(
								'alt',
								productTitle
							);
							prod.find('.kaGroupProd__title').text(productTitle);
							product.attr('data-qty', qty - 1);
							product
								.find('.kaCartItem__editQtyAvailable')
								.text(qty - 1);
							product.find('.kaCartItem__showQty').text(qty - 1);
							if (qty - 1 == 0) {
								product
									.find('.kaCartItem__plusButton')
									.addClass(
										'kaCartItem__plusButton--disabled'
									);
							}
						} else {
							var prod = group.find(
								'.kaGroupProd[data-id="' + id + '"]'
							);
							var newQty = prod.attr('data-qty') * 1 + 1;
							prod.attr('data-qty', newQty);
							prod.find('.kaGroupProd__qty').text(newQty);
							product.attr('data-qty', qty - 1);
							product
								.find('.kaCartItem__editQtyAvailable')
								.text(qty - 1);
							product.find('.kaCartItem__showQty').text(qty - 1);
							if (qty - 1 == 0) {
								product
									.find('.kaCartItem__plusButton')
									.addClass(
										'kaCartItem__plusButton--disabled'
									);
							}
						}

						//mobile
						$('.kaCartItem').each(function () {
							var thisQty = $(this).attr('data-qty');
							var thisId = $(this).attr('data-id');

							var mobProd = $(
								'.kaMProd[data-id="' + thisId + '"]'
							);
							var mobProdQtyMax =
								mobProd.attr('data-max-qty') * 1;

							mobProd.attr('data-qty', thisQty);
							var mobProdQty =
								mobProdQtyMax - mobProd.attr('data-qty') * 1;
							var mobProdQtyString =
								mobProdQty + '/' + mobProdQtyMax;

							mobProd
								.find('.kaMProd__qty')
								.text(mobProdQtyString);
							if (mobProdQty == 0) {
								mobProd
									.find('.kaMProd__plusButton')
									.addClass('kaMProd__plusButton--disabled');
							} else if (mobProdQty == mobProdQtyMax) {
								mobProd
									.find('.kaMProd__minusButton')
									.addClass('kaMProd__minusButton--disabled');
							} else if (mobProdQty < mobProdQtyMax) {
								mobProd
									.find('.kaMProd__minusButton')
									.removeClass(
										'kaMProd__minusButton--disabled'
									);
							}

							$('.kaMCartItem[data-id="' + thisId + '"]')
								.find('.kaMCartItem__qty')
								.text(mobProdQtyString);
						});

						var totalQty = 0;
						$('.kaCartItem__showQty').each(function () {
							var addQty = $(this).text() * 1;
							totalQty += addQty;
						});
						if (totalQty <= 1) {
							$('.kaGroups__createButton').addClass(
								'kaGroups__createButton--hidden'
							);
							$('.kaM__groupsAddNewWrapper').addClass(
								'kaM__groupsAddNewWrapper--hidden'
							);
						}
					}

					bindMinusButton();
					bindMobilePlusButton();
				}
			}

			$(
				'.kaTypePopup__overlay, .kaTypePopup__close, .kaTypePopup__closeButton'
			).on('click', function () {
				$('.kaTypePopup').fadeOut();
			});

			function bindPlusButton() {
				$('.kaCartItem__plusButton').on('click', function () {
					var product = $(this).closest('.kaCartItem');
					if (pageState == 'empty') {
						addNewGroup();
						var group = $('.kaGroup').last();
						addProductToGroup(product, group);

						var groupQty = 0;
						group.find('.kaGroupProd__qty').each(function () {
							groupQty += $(this).text() * 1;
						});
						if (groupQty > 1) {
							group.find('.kaGroup__saveButton').show();
						} else {
							group.find('.kaGroup__saveButton').hide();
						}
					} else if (
						pageState == 'groups' ||
						pageState == 'editing'
					) {
						var group = $('.kaGroup[data-active="true"]');
						addProductToGroup(product, group);

						var groupQty = 0;
						group.find('.kaGroupProd__qty').each(function () {
							groupQty += $(this).text() * 1;
						});
						if (groupQty > 1) {
							group.find('.kaGroup__saveButton').show();
						} else {
							group.find('.kaGroup__saveButton').hide();
						}
					}

					pageState = 'editing';
					stateCSS(pageState);

					var subtotal = 0;
					$('.kaGroupProd').each(function () {
						subtotal += $(this).attr('data-qty') * 1 * 3.99;
					});
					subtotal = subtotal.toFixed(2);
					$('.ka__groupSubtotalPrice').text('$' + subtotal);
					$('.kaMFooter__subtotalPrice').text('$' + subtotal);
				});
			}

			function bindMobilePlusButton() {
				$('.kaMProd__plusButton')
					.unbind('click')
					.on('click', function () {
						console.log('test');
						var thisThing = $(this).closest('.kaMProd');
						var product = $(
							'.kaCartItem[data-id="' +
								thisThing.attr('data-id') +
								'"]'
						);

						var groupData = thisThing
							.closest('.kaM__groupWrapper')
							.attr('data-group');
						var group = $(
							'.kaGroup[data-group="' + groupData + '"]'
						);
						addProductToGroup(product, group);

						var groupQty = 0;
						group.find('.kaGroupProd__qty').each(function () {
							groupQty += $(this).text() * 1;
						});
						if (groupQty > 1) {
							group.find('.kaGroup__saveButton').show();
						} else {
							group.find('.kaGroup__saveButton').hide();
						}

						pageState = 'editing';
						stateCSS(pageState);

						var subtotal = 0;
						$('.kaGroupProd').each(function () {
							subtotal += $(this).attr('data-qty') * 1 * 3.99;
						});
						subtotal = subtotal.toFixed(2);
						$('.ka__groupSubtotalPrice').text('$' + subtotal);
						$('.kaMFooter__subtotalPrice').text('$' + subtotal);
					});
			}

			function bindMinusButton() {
				$('.kaGroupProd__removeButton, .kaMProd__minusButton')
					.unbind('click')
					.on('click', function () {
						if ($(this).hasClass('kaGroupProd__removeButton')) {
							var prod = $(this).closest('.kaGroupProd');
						} else {
							var prodId = $(this)
								.closest('.kaMProd')
								.attr('data-id');
							var prodGroup = $(this)
								.closest('.kaM__groupWrapper')
								.attr('data-group');
							var prod = $(
								'.kaGroupProd[data-id="' +
									prodId +
									'"][data-group="' +
									prodGroup +
									'"]'
							);
						}

						var id = prod.attr('data-id');
						console.log(id);
						var original = $('.kaCartItem[data-id="' + id + '"]');
						var qty = original.attr('data-qty');
						var group = prod.closest('.kaGroup');
						var newQty = prod.attr('data-qty') * 1 - 1;

						var mobileGroup = $(
							'.kaM__groupWrapper[data-group="' +
								prod.attr('data-group') +
								'"]'
						);
						var mobileProd = mobileGroup.find(
							'.kaMProd[data-prod="' + id + '"]'
						);

						if (newQty >= 0) {
							if (newQty > 0) {
								prod.attr('data-qty', newQty);
								prod.find('.kaGroupProd__qty').text(newQty);

								original.attr('data-qty', qty * 1 + 1);
								original
									.find('.kaCartItem__editQtyAvailable')
									.text(qty * 1 + 1);
								original
									.find('.kaCartItem__showQty')
									.text(qty * 1 + 1);
								original
									.find('.kaCartItem__plusButton')
									.removeClass(
										'kaCartItem__plusButton--disabled'
									);
							} else {
								prod.remove();

								original.attr('data-qty', qty * 1 + 1);
								original
									.find('.kaCartItem__editQtyAvailable')
									.text(qty * 1 + 1);
								original
									.find('.kaCartItem__showQty')
									.text(qty * 1 + 1);
								original
									.find('.kaCartItem__plusButton')
									.removeClass(
										'kaCartItem__plusButton--disabled'
									);
							}

							$('.kaCartItem').each(function () {
								var thisQty = $(this).attr('data-qty');
								var thisId = $(this).attr('data-id');

								var mobProd = $(
									'.kaMProd[data-id="' + thisId + '"]'
								);
								var mobProdQtyMax =
									mobProd.attr('data-max-qty') * 1;

								mobProd.attr('data-qty', thisQty);
								var mobProdQty =
									mobProdQtyMax -
									mobProd.attr('data-qty') * 1;
								var mobProdQtyString =
									mobProdQty + '/' + mobProdQtyMax;

								mobProd
									.find('.kaMProd__qty')
									.text(mobProdQtyString);
								if (mobProdQty == 0) {
									mobProd
										.find('.kaMProd__plusButton')
										.addClass(
											'kaMProd__plusButton--disabled'
										);
								} else if (mobProdQty == mobProdQtyMax) {
									mobProd
										.find('.kaMProd__minusButton')
										.addClass(
											'kaMProd__minusButton--disabled'
										);
								} else if (mobProdQty < mobProdQtyMax) {
									mobProd
										.find('.kaMProd__minusButton')
										.removeClass(
											'kaMProd__minusButton--disabled'
										);
								}

								$('.kaMCartItem[data-id="' + thisId + '"]')
									.find('.kaMCartItem__qty')
									.text(mobProdQtyString);

								var groupQty = 0;
								group
									.find('.kaGroupProd__qty')
									.each(function () {
										groupQty += $(this).text() * 1;
									});
								if (groupQty > 1) {
									group.find('.kaGroup__saveButton').show();
								} else {
									group.find('.kaGroup__saveButton').hide();
								}
							});

							if (group.find('.kaGroupProd').length == 0) {
								group.attr('data-state', 'empty');
								groupStateCSS(group);
							}
							var totalQty = 0;
							$('.kaCartItem__showQty').each(function () {
								var addQty = $(this).text() * 1;
								totalQty += addQty;
							});
							if (totalQty > 0) {
								$('.kaGroups__createButton').removeClass(
									'kaGroups__createButton--hidden'
								);
								$('.kaM__groupsAddNewWrapper').addClass(
									'kaM__groupsAddNewWrapper--hidden'
								);
							}
						}
						var subtotal = 0;
						$('.kaGroupProd').each(function () {
							subtotal += $(this).attr('data-qty') * 1 * 3.99;
						});
						subtotal = subtotal.toFixed(2);
						$('.ka__groupSubtotalPrice').text('$' + subtotal);
						$('.kaMFooter__subtotalPrice').text('$' + subtotal);
					});
			}

			function bindSaveGroup() {
				$('.kaGroup__saveButton')
					.unbind('click')
					.on('click', function () {
						var group = $(this).closest('.kaGroup');
						group.attr('data-saved', 'true');
						group.attr('data-active', 'false');
						group.attr('data-state', 'saved');
						pageState = 'saved';
						groupStateCSS(group);
						stateCSS(pageState);
					});
			}

			function bindEditGroup() {
				$('.kaGroup__editButton')
					.unbind('click')
					.on('click', function () {
						$('.kaGroup').each(function () {
							$(this).attr('data-active', 'false');
							$(this).attr('data-state', 'saved');
							groupStateCSS($(this));
						});
						var group = $(this).closest('.kaGroup');
						group.attr('data-saved', 'true');
						group.attr('data-active', 'true');
						group.attr('data-state', 'editing');
						pageState = 'editing';
						groupStateCSS(group);
						stateCSS(pageState);

						var groupQty = 0;
						group.find('.kaGroupProd__qty').each(function () {
							groupQty += $(this).text() * 1;
						});
						if (groupQty > 1) {
							group.find('.kaGroup__saveButton').show();
						} else {
							group.find('.kaGroup__saveButton').hide();
						}
					});
			}

			function slideUpGroup(group) {
				group.find('.kaGroup__shelf').slideUp();
				group.addClass('kaGroup--hidden');
			}
			function slideDownGroup(group) {
				group.find('.kaGroup__shelf').slideDown();
				group.removeClass('kaGroup--hidden');
			}

			function bindSlideGroup() {
				$('.kaGroup__accordionTitle')
					.unbind('click')
					.on('click', function () {
						var group = $(this).closest('.kaGroup');
						if (group.attr('data-state') == 'saved') {
							if (group.hasClass('kaGroup--hidden')) {
								slideDownGroup(group);
							} else {
								slideUpGroup(group);
							}
						}
					});
			}

			$('.kaGroups__createButton').on('click', function () {
				pageState = 'groups';
				stateCSS(pageState);
				addNewGroup();
				groupStateCSS($('.kaGroup').last());
				$('.kaGroup[data-active="false"]').each(function () {
					var group = $(this);
					slideUpGroup(group);
				});
			});

			function bindMobileCreateGroup() {
				$('.kaM__groupsAddNew')
					.unbind('click')
					.on('click', function () {
						pageState = 'groups';
						stateCSS(pageState);
						addNewGroup();
						groupStateCSS($('.kaGroup').last());
						$('.kaGroup[data-active="false"]').each(function () {
							var group = $(this);
							slideUpGroup(group);
						});
					});
			}

			function removeGroup(groupIndex) {
				var group = $('.kaGroup[data-group="' + groupIndex + '"]');
				group.find('.kaGroupProd').each(function () {
					var prod = $(this);
					var id = prod.attr('data-id');
					var original = $('.kaCartItem[data-id="' + id + '"]');
					var qtyToAdd = prod.attr('data-qty');
					var qty = original.attr('data-qty');

					original.attr('data-qty', qty * 1 + qtyToAdd * 1);
					original
						.find('.kaCartItem__editQtyAvailable')
						.text(qty * 1 + qtyToAdd * 1);
					original
						.find('.kaCartItem__showQty')
						.text(qty * 1 + qtyToAdd * 1);
					original
						.find('.kaCartItem__plusButton')
						.removeClass('kaCartItem__plusButton--disabled');
				});

				group.remove();
				$(
					'.kaM__groupWrapper[data-group="' + groupIndex + '"]'
				).remove();

				$('.kaCartItem').each(function () {
					var thisQty = $(this).attr('data-qty');
					var thisId = $(this).attr('data-id');

					var mobProd = $('.kaMProd[data-id="' + thisId + '"]');
					var mobProdQtyMax = mobProd.attr('data-max-qty') * 1;

					mobProd.attr('data-qty', thisQty);
					var mobProdQty =
						mobProdQtyMax - mobProd.attr('data-qty') * 1;
					var mobProdQtyString = mobProdQty + '/' + mobProdQtyMax;

					mobProd.find('.kaMProd__qty').text(mobProdQtyString);
					if (mobProdQty == 0) {
						mobProd
							.find('.kaMProd__plusButton')
							.addClass('kaMProd__plusButton--disabled');
					} else if (mobProdQty == mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.addClass('kaMProd__minusButton--disabled');
					} else if (mobProdQty < mobProdQtyMax) {
						mobProd
							.find('.kaMProd__minusButton')
							.removeClass('kaMProd__minusButton--disabled');
					}

					$('.kaMCartItem[data-id="' + thisId + '"]')
						.find('.kaMCartItem__qty')
						.text(prod.quantity + '/' + prod.quantity);
				});

				var groupCount = 1;
				$('.kaGroup').each(function () {
					$(this).attr('data-group', groupCount);
					$(this).find('.kaGroup__index').text(groupCount);
					groupCount += 1;
				});
				if (groupCount == 1) {
					pageState = 'empty';
					stateCSS(pageState);
				}
				groupCount = 1;
				$('.kaM__groupWrapper').each(function () {
					$(this).attr('data-group', groupCount);
					$(this)
						.find('.kaM__groupNumber, .kaMGroup__titleNumber')
						.text(groupCount);
					groupCount += 1;
				});

				$('.kaRemovePopup').fadeOut();

				var totalQty = 0;
				$('.kaCartItem__showQty').each(function () {
					var addQty = $(this).text() * 1;
					totalQty += addQty;
				});
				if (totalQty > 0) {
					$('.kaGroups__createButton').removeClass(
						'kaGroups__createButton--hidden'
					);
					$('.kaM__groupsAddNewWrapper').removeClass(
						'kaM__groupsAddNewWrapper--hidden'
					);
				}

				var subtotal = 0;
				$('.kaGroupProd').each(function () {
					subtotal += $(this).attr('data-qty') * 1 * 3.99;
				});
				subtotal = subtotal.toFixed(2);
				$('.ka__groupSubtotalPrice').text('$' + subtotal);
				$('.kaMFooter__subtotalPrice').text('$' + subtotal);

				completeKA(false);
			}

			function bindRemoveGroup() {
				$('.kaGroup__removeButton')
					.unbind('click')
					.on('click', function () {
						$('.kaState__full').addClass('kaState__full--noScroll');
						$('.kaRemovePopup').fadeIn();
						var group = $(this).closest('.kaGroup');
						$('.kaRemovePop__remove').attr(
							'data-group',
							group.attr('data-group')
						);
					});
			}

			function bindMobileRemoveEvents() {
				$('.kaMGroup__removeButton')
					.unbind('click')
					.on('click', function () {
						$(this)
							.closest('.kaM__groupWrapper')
							.find('.kaMGroup__removePopup')
							.fadeIn();
						var groupIndex = $(this)
							.closest('.kaM__groupWrapper')
							.attr('data-group');
						var group = $(
							'.kaGroup[data-group="' + groupIndex + '"]'
						);
						$(this)
							.closest('.kaM__groupWrapper')
							.find('.kaMGroup__removePopRemove')
							.attr('data-group', group.attr('data-group'));
					});

				$('.kaMGroup__removePopRemove')
					.unbind('click')
					.on('click', function () {
						var groupIndex = $(this).attr('data-group');
						removeGroup(groupIndex);
						$(this).closest('.kaMGroup__removePopup').fadeOut();
						if ($('.kaM__groupWrapper').length() < 1) {
							pageState = 'empty';
							stateCSS(pageState);
						} else {
							pageState = 'saved';
							stateCSS(pageState);
						}
					});

				$('.kaMGroup__removePopCancel')
					.unbind('click')
					.on('click', function () {
						$(this).closest('.kaMGroup__removePopup').fadeOut();
					});
			}

			function bindMobileSliders() {
				$('.kaM__group')
					.unbind('click')
					.on('click', function () {
						var target = $(this).parent().find('.kaM__groupCard');
						target.attr('style', 'transform:translateX(0%);');
						pageState = 'editing';
						stateCSS(pageState);
						bindMinusButton();
						bindMobilePlusButton();
					});
				$('.kaMGroup__close, .kaMGroup__titleArrowButton')
					.unbind('click')
					.on('click', function () {
						var target = $(this).closest('.kaM__groupCard');
						target.attr('style', 'transform:translateX(100%);');
						pageState = 'saved';
						stateCSS(pageState);
					});
			}

			$('.kaMFooter__saveGroupButton').on('click', function () {
				$('.kaM__groupCard').attr(
					'style',
					'transform:translateX(100%);'
				);
				pageState = 'saved';
				stateCSS(pageState);
				bindMobileCreateGroup();
			});

			$('.kaRemovePop__remove').on('click', function () {
				var groupIndex = $(this).attr('data-group');
				$('.kaState__full').removeClass('kaState__full--noScroll');
				$('.kaRemovePopup').fadeOut();
				removeGroup(groupIndex);
				pageState = 'saved';
				stateCSS(pageState);
			});

			$('.kaRemovePop__cancel').on('click', function () {
				$('.kaRemovePopup').fadeOut();
				$('.kaState__full').removeClass('kaState__full--noScroll');
			});

			$('.ka__groupKeepShoppingButton').on('click', function () {
				$('.kaLeavePop').fadeIn();
			});

			$(
				'.kaLeavePop__background, .kaLeavePop__close, .kaLeavePop__continue'
			).on('click', function () {
				$('.kaLeavePop').fadeOut();
			});

			function completeKA(openCart) {
				if ($('.kaGroupProd').length > 0) {
					var keyableItems = getKeyableItems();
					for (i = 0; i < keyableItems.length; i++) {
						CartJS.removeItemById(keyableItems[i].id);
					}
					var isKey = false;
					for (i = 0; i < CartJS.cart.items.length; i++) {
						if (CartJS.cart.items[i].id === 32146864832644) {
							isKey = true;
						}
					}
					if (isKey) {
						CartJS.removeItemById(32146864832644);
					}

					var kaLib = [];
					var keyCount = 0;
					$('.kaCartItem').each(function () {
						if ($(this).attr('data-qty') * 1 > 0) {
							var kaProdObj = {
								id: $(this).attr('data-id') * 1,
								quantity: $(this).attr('data-qty') * 1,
								properties: {
									_keyed_alike_available: 'true',
								},
							};
							kaLib.push(kaProdObj);
						}
					});
					$('.kaGroupProd').each(function () {
						var kaProdObj = {
							id: $(this).attr('data-id') * 1,
							quantity: $(this).attr('data-qty') * 1,
							properties: {
								_name: 'keyed_alike_group',
								_value: $(this).attr('data-group') * 1,
								_keyed_alike_group:
									$(this).attr('data-group') * 1,
								_keyed_alike_available: 'true',
								_requested_ship_date: getNearestWeekdayTwoDaysAhead()
							},
						};
						kaLib.push(kaProdObj);
						keyCount += $(this).attr('data-qty') * 1;
					});
					var keyProdObj = {
						id: 32146864832644,
						quantity: keyCount,
						properties: {
							_groups: $('.kaGroup').length,
						},
					};
					kaLib.push(keyProdObj);

					console.log(keyProdObj);
					CartJS.addItems(kaLib, {
						success: function (data, textStatus, jqXHR) {
							updateCart(openCart);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					});
				} else {
					var newKeyableItems = getKeyableItems();
					for (i = 0; i < newKeyableItems.length; i++) {
						CartJS.removeItemById(newKeyableItems[i].id);
					}
					CartJS.removeItemById(32146864832644);
					var newKaLib = [];
					console.log(newKeyableItems);
					for (i = 0; i < newKeyableItems.length; i++) {
						var newKaProdObj = {
							id: newKeyableItems[i].id,
							quantity: newKeyableItems[i].quantity,
							properties: {
								_keyed_alike_available: 'true',
								_requested_ship_date: getNearestWeekdayTwoDaysAhead()
							},
						};
						newKaLib.push(newKaProdObj);
					}
					console.log(newKaLib);
					CartJS.addItems(newKaLib, {
						success: function (data, textStatus, jqXHR) {
							updateCart(openCart);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					});
				}
			}

			$('.ka__groupCompleteButton, .kaMFooter__completeButton').on(
				'click',
				function () {
					completeKA(true);
					pageState = 'completed';
					stateCSS(pageState);
				}
			);

			$('#cartDrawer .btn-close').on('click', function () {
				if (pageState == 'completed') {
					pageState = 'saved';
					stateCSS(pageState);
				}
			});
		}

		if ($('#shopify-section-downloadHero').length > 0) {
			$('.topbar').remove();
		}

		if ($('#shopify-section-matterNotify').length > 0) {
			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}
	});

	$(document).ready(function () {
		$('#smart-safe .pdp__options button:first-of-type').on(
			'click',
			function () {
				$('.worksWith__1').show();
				$('.worksWith__2').hide();
				var newImgSrc = $('.pdp__image .ftd__swap .product__one').attr(
					'src'
				);
				$('.pdp__image .ftd__image img').attr('src', newImgSrc);
				var newThumbSrc = $(
					'.pdp__thumbs .ftd__swap .product__one'
				).attr('src');
				$('.pdp__thumbs .ftd__image img').attr('src', newThumbSrc);

				$('.pdp__featuresContainer').html(
					$(this).attr('data-features')
				);
				$('.pdp__technical .nestFaq__drop').html(
					$(this).attr('data-specs')
				);
			}
		);

		$('#smart-safe .pdp__options button:last-of-type').on(
			'click',
			function () {
				$('.worksWith__1').hide();
				$('.worksWith__2').show();
				var newImgSrc = $('.pdp__image .ftd__swap .product__two').attr(
					'src'
				);
				$('.pdp__image .ftd__image img').attr('src', newImgSrc);
				var newThumbSrc = $(
					'.pdp__thumbs .ftd__swap .product__two'
				).attr('src');
				$('.pdp__thumbs .ftd__image img').attr('src', newThumbSrc);

				$('.pdp__featuresContainer').html(
					$(this).attr('data-features')
				);
				$('.pdp__technical .nestFaq__drop').html(
					$(this).attr('data-specs')
				);
			}
		);

		/*$('.collection-menu .nav .nav-item div a[aria-label="Yale Assure Lock 2_img"]').attr('href', '/pages/smart-locks');*/
		$(
			'.collection-menu .nav .nav-item div a[aria-label="Yale Assure Lock 2_title"]'
		).attr('href', '/pages/yale-assure-lock-2');

		$(
			'.index-shop-collection a[aria-label="Yale Assure Lock 2_image"'
		).hide();
		$(
			'.index-shop-collection a[aria-label="Yale Assure Lock 2_desc"'
		).hide();

		$('.index-shop-collection a[aria-label="Safes_image"').attr(
			'href',
			'/pages/smart-safe'
		);
		$('.index-shop-collection a[aria-label="Safes_desc"').text(
			'Smart Safes'
		);

		$('.smartWifiPDP .smartPDP__images').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.smartWifiPDP .smartPDP__thumbs',
			infinite: true,
		});

		$('.smartWifiPDP .smartPDP__thumbs').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.smartWifiPDP .smartPDP__images',
			dots: false,
			centerMode: false,
			vertical: true,
			focusOnSelect: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 950,
					settings: {
						slidesToShow: 3,
						vertical: false,
					},
				},
			],
		});

		$('.smartZwavePDP .smartPDP__images').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.smartZwavePDP .smartPDP__thumbs',
			infinite: true,
		});

		$('.smartZwavePDP .smartPDP__thumbs').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.smartZwavePDP .smartPDP__images',
			dots: false,
			centerMode: false,
			vertical: true,
			focusOnSelect: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 950,
					settings: {
						slidesToShow: 3,
						vertical: false,
					},
				},
			],
		});

		$('.smartMatterPDP .smartPDP__images').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.smartMatterPDP .smartPDP__thumbs',
			infinite: true,
		});

		$('.smartMatterPDP .smartPDP__thumbs').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			asNavFor: '.smartMatterPDP .smartPDP__images',
			dots: false,
			centerMode: false,
			vertical: true,
			focusOnSelect: true,
			infinite: true,
			responsive: [
				{
					breakpoint: 950,
					settings: {
						slidesToShow: 3,
						vertical: false,
					},
				},
			],
		});

		$('.smartPDP__techButton').on('click', function () {
			var target = $(this).parent().find('.smartPDP__techSled');
			if (target.is(':visible')) {
				target.slideUp();
				$(this).removeClass('smartPDP__accordion--active');
			} else {
				target.slideDown();
				$(this).addClass('smartPDP__accordion--active');
			}
		});

		$('.smartPDP__compatButton').on('click', function () {
			var target = $(this).parent().find('.smartPDP__compatSled');
			if (target.is(':visible')) {
				target.slideUp();
				$(this).removeClass('smartPDP__accordion--active');
			} else {
				target.slideDown();
				$(this).addClass('smartPDP__accordion--active');
			}
		});

		function updateCart() {
			app._getCartData();
			app._vibrateDevice();
			app.$snotify.clear();
			setTimeout(function () {
				if (
					((app.isLoading = false),
					(app.loadingEvent = null),
					app.storeUtilities.cartUpsells.settings.showOnPopUp)
				) {
					var origin = app.cart.items.find(function (data) {
						return data.variant_id === keys;
					});
					app._openModalCartUpsell(origin);
				} else {
					app._toggleCartDrawer();
				}
			}, 300);
		}

		function addToCart(variant, qty) {
			if (checkDiscountLimitFull(variant)) {
				alert(
					'You can only order up to ' +
						$('body').attr('data-qty-limit') * 1 +
						' discounted items.'
				);
				return;
			}
			CartJS.addItem(
				variant,
				qty,
				{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
				{
					success: function (data, textStatus, jqXHR) {
						updateCart();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log('Error: ' + errorThrown + '!');
					},
				}
			);
		}

		$('.smartPDP__buy').on('click', function () {
			var variant = $(this).attr('data-id');
			var qty = $(this)
				.closest('.smartPDP__buyRow')
				.find('.smartPDP__qty')
				.val();
			addToCart(variant, qty);
		});

		$('.smartPDP__qtyMinus').on('click', function () {
			var target = $(this).parent().find('input');
			var qty = target.val() * 1;
			if (qty > 1) {
				target.val(qty - 1).change();
			}
		});

		$('.smartPDP__qtyPlus').on('click', function () {
			var target = $(this).parent().find('input');
			var qty = target.val() * 1;
			target.val(qty + 1).change();
		});

		if ($('#shopify-section-smart-module-banner').length > 0) {
			function notifyMe(email, variantID, productID, target) {
				var apiKey = 'VdEWmd';
				var platform = 'shopify';

				fetch(
					'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
					{
						headers: {
							accept: 'application/json, text/plain, */*',
							'content-type':
								'application/x-www-form-urlencoded;charset=UTF-8',
						},
						body: new URLSearchParams({
							a: apiKey,
							email: email,
							platform: 'shopify',
							variant: variantID,
							product: productID,
						}),
						method: 'POST',
					}
				)
					.then((response) => {
						console.log(response);
						target.find('.notifyMe__success').show();
						target.find('.notifyMe__error').hide();
					})
					.catch((err) => {
						console.error(err);
						target.find('.notifyMe__error').text(err).show();
					});
			}

			$('.notifyMe__submit').on('click', function (e) {
				e.preventDefault();
				var target = $(this).closest('.notifyMe');

				var email = $('.notifyMe__input').val();
				var variantID = $(this).attr('data-variant');
				var productID = $(this).attr('data-product');
				if (email.includes('@')) {
					notifyMe(email, variantID, productID, target);
				} else {
					$('.notifyMe__error').show();
				}
			});
		}

		var windowWidth = $(window).width();

		if (windowWidth <= 560) {
			$('.assure-grid .grid-list').slick({
				infinite: true,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
			});
		}

		if (windowWidth <= 900) {
			$('.assure-cta .grid-list').slick({
				infinite: false,
				variableWidth: true,
				fade: false,
				centerMode: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
			});

			$(
				'.template-page-assure-plus-landing .assure-access .images--mobile'
			).slick({
				infinite: true,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				asNavFor: '.assure-access .tabs-list',
			});

			$(
				'.template-page-assure-plus-landing .assure-access .tabs-list'
			).slick({
				infinite: true,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				asNavFor: '.assure-access .images--mobile',
			});

			$(
				'.template-page-assure-touch-landing .assure-access .images--mobile'
			).slick({
				infinite: true,
				fade: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
			});
		}

		$('.assure-switch button').on('click', function () {
			var dataID = $(this).attr('data-id');
			console.log(dataID);

			$('.assure-switch button').removeClass('active');
			$('.assure-switch .images img').removeClass('active');

			$(this).addClass('active');
			$('.assure-switch .images img[data-id="' + dataID + '"]').addClass(
				'active'
			);
		});

		$('.assure-access button').on('click', function () {
			var dataID = $(this).attr('data-id');
			console.log(dataID);

			$('.assure-access .tab-item').removeClass('active');
			$('.assure-access .images img').removeClass('active');

			$(this).closest('.tab-item').addClass('active');
			$('.assure-access .images img[data-id="' + dataID + '"]').addClass(
				'active'
			);
		});

		/*$('.template-page-assure-touch-landing  .al2Faq__titleWrapper, .template-page-assure-plus-landing  .al2Faq__titleWrapper').on('click', function(){
      if ($(this).hasClass('al2Faq__titleWrapper--active')){
        $(this).removeClass('al2Faq__titleWrapper--active');
        $(this).parent().find('.al2Faq__shelf').slideUp();
      }
      else{
        $(this).addClass('al2Faq__titleWrapper--active');
        $(this).parent().find('.al2Faq__shelf').slideDown();
      }
    });*/

		$('.pantonePage .pantone__slider .slider__slides').slick({
			infinite: true,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			// responsive: [
			//   {
			//     breakpoint: 990,
			//     settings: {
			//       slidesToShow: 3,
			//       arrows:true,
			//       dots: true
			//     }
			//   },
			//   {
			//     breakpoint: 750,
			//     settings: {
			//       slidesToShow: 2,
			//       arrows:true,
			//       dots: true
			//     }
			//   },
			//   {
			//     breakpoint: 510,
			//     settings: {
			//       slidesToShow: 1,
			//       arrows:true,
			//       dots: true
			//     }
			//   }
			// ]
		});

		$('.pantonePage .al2Faq__titleWrapper').on('click', function () {
			if ($(this).hasClass('al2Faq__titleWrapper--active')) {
				$(this).removeClass('al2Faq__titleWrapper--active');
				$(this).parent().find('.al2Faq__shelf').slideUp();
			} else {
				$(this).addClass('al2Faq__titleWrapper--active');
				$(this).parent().find('.al2Faq__shelf').slideDown();
			}
		});

		$('.pantonePage .tabs__slider .slider-top').slick({
			infinite: true,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
			asNavFor: '.pantonePage .tabs__slider .slider-bottom',
		});

		$('.pantonePage .tabs__slider .slider-bottom').slick({
			infinite: true,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			asNavFor: '.pantonePage .tabs__slider .slider-top',
		});

		// asNavFor: '.accessMobile__textSliderInner'

		$('.pantonePage .pantone__tabs button').on('click', function () {
			var dataID = $(this).closest('.tab').attr('data-id');

			$('.pantonePage .pantone__tabs .tab').removeClass('tab--active');
			$('.pantonePage .pantone__tabs .image').removeClass(
				'image--active'
			);

			$(this).closest('.tab').addClass('tab--active');
			$(
				'.pantonePage .pantone__tabs .image[data-id="' + dataID + '"]'
			).addClass('image--active');
		});

		$('.panProd__slideshow').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			dots: true,
		});

		if ($('#shopify-section-pantone-plp-product').length > 0) {
			var currentPrice = $('.panProd__colorSelector--active').attr(
				'data-price'
			);
			var currentComparePrice = $('.panProd__colorSelector--active').attr(
				'data-compare-price'
			);

			var currentRawPrice =
				$('.panProd__colorSelector--active').attr('data-price-raw') * 1;
			var currentRawComparePrice =
				$('.panProd__colorSelector--active').attr(
					'data-compare-price-raw'
				) * 1;

			$('.panProd__price').text(currentPrice);
			if (currentRawPrice < currentRawComparePrice) {
				$('.panProd__comparePrice').text(currentComparePrice);
			}

			var currentCoreColor = $('.panProd__colorRow')
				.find('.panProd__colorSelector')
				.first()
				.attr('data-color-name');
			$('.panProd__colorTitle').text(currentCoreColor);

			var currentURL = $('.panProd__colorSelector--active').attr(
				'data-url'
			);
			$('.panProd__leanMore').attr('href', currentURL);

			$('.panProd__colorSelector').on('click', function () {
				$('.panProd__colorSelector').removeClass(
					'panProd__colorSelector--active'
				);
				$(this).addClass('panProd__colorSelector--active');

				var newVariantId = $(this).attr('data-id');
				var newPrice = $(this).attr('data-price');
				var newComparePrice = $(this).attr('data-compare-price');
				var newPriceRaw = $(this).attr('data-price-raw') * 1;
				var newComparePriceRaw =
					$(this).attr('data-compare-price--raw') * 1;
				var newURL = $(this).attr('data-url');
				var newImgOne = $(this).attr('data-image-one');
				var newImgTwo = $(this).attr('data-image-two');
				var newImgThree = $(this).attr('data-image-three');
				var newImgFour = $(this).attr('data-image-four');

				$('.panProd__price').text(newPrice);
				if (newPriceRaw < newComparePriceRaw) {
					$('.panProd__comparePrice').text(newComparePrice);
				}

				$('.panProd__buy').attr('data-id', newVariantId);
				$('.panProd__leanMore').attr('href', newURL);

				$('.panProd__slideImage--one').attr('src', newImgOne);
				$('.panProd__slideImage--two').attr('src', newImgTwo);
				$('.panProd__slideImage--three').attr('src', newImgThree);
				$('.panProd__slideImage--four').attr('src', newImgFour);

				if (!$(this).hasClass('panProd__colorSelector--limited')) {
					var newColorName = $(this).attr('data-color-name');

					$('.panProd__colorTitle').text(newColorName);
				}
			});

			$('.panProd__qtyMinus').on('click', function () {
				var currentQty = $('.panProd__qty').attr('data-qty') * 1;
				if (currentQty > 1) {
					$('.panProd__qty').attr('data-qty', currentQty - 1);
					$('.panProd__qty').text(currentQty - 1);
				}
			});

			$('.panProd__qtyPlus').on('click', function () {
				var currentQty = $('.panProd__qty').attr('data-qty') * 1;
				$('.panProd__qty').attr('data-qty', currentQty + 1);
				$('.panProd__qty').text(currentQty + 1);
			});

			function PantoneAddToCart(variant, qty) {
				if (checkDiscountLimitFull(variant)) {
					alert(
						'You can only order up to ' +
							$('body').attr('data-qty-limit') * 1 +
							' discounted items.'
					);
					return;
				}
				CartJS.addItem(
					variant,
					qty,
					{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
					{
						success: function (data, textStatus, jqXHR) {
							updateCart(true);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			}

			$('.panProd__buy').on('click', function () {
				var currentVariant = $(this).attr('data-id');
				var currentQty = $('.panProd__qty').attr('data-qty');
				PantoneAddToCart(currentVariant, currentQty);
			});
		}

		$('.panInsta__slider').slick({
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			dots: true,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

		$('.panInsta__playButtonWrapper').on('click', function () {
			var iframeCode = $(this).attr('data-iframe');
			$('.panInsta__modalIframeWrapper').html(iframeCode);
			$('.panInsta__modal').fadeIn();
		});

		$('.panInsta__modalBkg, .panInsta__modalClose').on(
			'click',
			function () {
				$('.panInsta__modalIframeWrapper').html('');
				$('.panInsta__modal').fadeOut();
			}
		);
	});

	if ($('#redirect').length > 0) {
		window.location.replace(
			'https://support.shopyalehome.com/en_us/faq-keyed-alike-BJAtsdIJ2'
		);
	}

	$(document).ready(function () {
		if ($('.assure-compare').length > 0) {
			var setHeight = 0;
			$('.asCompare__row--one').each(function () {
				if ($(this).outerHeight() > setHeight) {
					setHeight = $(this).outerHeight();
				}
			});
			$('.asCompare__row--one').attr(
				'style',
				'height:' + setHeight + 'px;'
			);

			setHeight = 0;
			$('.asCompare__row--two').each(function () {
				if ($(this).outerHeight() > setHeight) {
					setHeight = $(this).outerHeight();
				}
			});
			$('.asCompare__row--two').attr(
				'style',
				'height:' + setHeight + 'px;'
			);

			setHeight = 0;
			$('.asCompare__row--three').each(function () {
				if ($(this).outerHeight() > setHeight) {
					setHeight = $(this).outerHeight();
				}
			});
			$('.asCompare__row--three').attr(
				'style',
				'height:' + setHeight + 'px;'
			);

			setHeight = 0;
			$('.asCompare__row--four').each(function () {
				if ($(this).outerHeight() > setHeight) {
					setHeight = $(this).outerHeight();
				}
			});
			$('.asCompare__row--four').attr(
				'style',
				'height:' + setHeight + 'px;'
			);

			setHeight = 0;
			$('.asCompare__row--five').each(function () {
				if ($(this).outerHeight() > setHeight) {
					setHeight = $(this).outerHeight();
				}
			});
			$('.asCompare__row--five').attr(
				'style',
				'height:' + setHeight + 'px;'
			);
		}

		$('.asProdColumn__toggleButton').on('click', function () {
			var column = $(this).closest('.asProdColumn');
			column
				.find('.asProdColumn__toggleButton')
				.removeClass('asProdColumn__toggleButton--active');
			$(this).addClass('asProdColumn__toggleButton--active');
			if ($(this).attr('data-toggle') == 'bluetooth') {
				column
					.find('.asProdColumn__slider')
					.removeClass('asProdColumn__slider--wifi')
					.addClass('asProdColumn__slider--bluetooth');
				column
					.find('.asProdColumn__sled')
					.removeClass('asProdColumn__sled--wifi')
					.addClass('asProdColumn__sled--bluetooth');
			} else {
				column
					.find('.asProdColumn__slider')
					.removeClass('asProdColumn__slider--bluetooth')
					.addClass('asProdColumn__slider--wifi');
				column
					.find('.asProdColumn__sled')
					.removeClass('asProdColumn__sled--bluetooth')
					.addClass('asProdColumn__sled--wifi');
			}
		});

		function setCompareMobileProds() {
			var firstColumnNum = $('.asMobComp__select--one').attr(
				'data-number'
			);
			var secondColumnNum = $('.asMobComp__select--two').attr(
				'data-number'
			);

			var firstColumnTech = $('.asMobComp__toggleWrapper--one')
				.find('.asMobComp__toggleButton--active')
				.attr('data-tech');
			var secondColumnTech = $('.asMobComp__toggleWrapper--two')
				.find('.asMobComp__toggleButton--active')
				.attr('data-tech');

			$('.asMobComp__iconBlock--one')
				.find('.asMobComp__iconWrapper')
				.removeClass('asMobComp__iconWrapper--active');
			$('.asMobComp__iconBlock--one')
				.find('[data-number="' + firstColumnNum + '"]')
				.addClass('asMobComp__iconWrapper--active');

			$('.asMobComp__stat--one')
				.find('.asMobComp__statWrapper')
				.removeClass('asMobComp__statWrapper--active');
			$('.asMobComp__stat--one')
				.find('[data-number="' + firstColumnNum + '"]')
				.addClass('asMobComp__statWrapper--active');

			$('.asMobComp__priceWrapper--one')
				.find('.asMobComp__priceBox')
				.removeClass('asMobComp__priceBox--active');
			$('.asMobComp__priceWrapper--one')
				.find('[data-number="' + firstColumnNum + '"]')
				.addClass('asMobComp__priceBox--active');

			$('.asMobComp__buyWrapper--one')
				.find('.asMobComp__buyBox')
				.removeClass('asMobComp__buyBox--active');
			$('.asMobComp__buyWrapper--one')
				.find('[data-number="' + firstColumnNum + '"]')
				.addClass('asMobComp__buyBox--active');

			$('.asMobComp__learnWrapper--one')
				.find('.asMobComp__learnBox')
				.removeClass('asMobComp__learnBox--active');
			$('.asMobComp__learnWrapper--one')
				.find('[data-number="' + firstColumnNum + '"]')
				.addClass('asMobComp__learnBox--active');

			$('.asMobComp__iconBlock--two')
				.find('.asMobComp__iconWrapper')
				.removeClass('asMobComp__iconWrapper--active');
			$('.asMobComp__iconBlock--two')
				.find('[data-number="' + secondColumnNum + '"]')
				.addClass('asMobComp__iconWrapper--active');

			$('.asMobComp__stat--two')
				.find('.asMobComp__statWrapper')
				.removeClass('asMobComp__statWrapper--active');
			$('.asMobComp__stat--two')
				.find('[data-number="' + secondColumnNum + '"]')
				.addClass('asMobComp__statWrapper--active');

			$('.asMobComp__priceWrapper--two')
				.find('.asMobComp__priceBox')
				.removeClass('asMobComp__priceBox--active');
			$('.asMobComp__priceWrapper--two')
				.find('[data-number="' + secondColumnNum + '"]')
				.addClass('asMobComp__priceBox--active');

			$('.asMobComp__buyWrapper--two')
				.find('.asMobComp__buyBox')
				.removeClass('asMobComp__buyBox--active');
			$('.asMobComp__buyWrapper--two')
				.find('[data-number="' + secondColumnNum + '"]')
				.addClass('asMobComp__buyBox--active');

			$('.asMobComp__learnWrapper--two')
				.find('.asMobComp__learnBox')
				.removeClass('asMobComp__learnBox--active');
			$('.asMobComp__learnWrapper--two')
				.find('[data-number="' + secondColumnNum + '"]')
				.addClass('asMobComp__learnBox--active');

			if (firstColumnTech == 'bluetooth') {
				$('.asMobComp__iconBlock--one')
					.find('.asMobComp__icon--bluetooth')
					.show();
				$('.asMobComp__iconBlock--one')
					.find('.asMobComp__icon--wifi')
					.hide();

				$('.asMobComp__stat--one')
					.find('.asMobComp__statText--bluetooth')
					.show();
				$('.asMobComp__stat--one')
					.find('.asMobComp__statText--wifi')
					.hide();

				$('.asMobComp__priceWrapper--one')
					.find('.asMobComp__price--bluetooth')
					.show();
				$('.asMobComp__priceWrapper--one')
					.find('.asMobComp__price--wifi')
					.hide();

				$('.asMobComp__buyWrapper--one')
					.find('.asMobComp__buy--bluetooth')
					.show();
				$('.asMobComp__buyWrapper--one')
					.find('.asMobComp__buy--wifi')
					.hide();

				$('.asMobComp__learnWrapper--one')
					.find('.asMobComp__learn--bluetooth')
					.show();
				$('.asMobComp__learnWrapper--one')
					.find('.asMobComp__learn--wifi')
					.hide();
			} else {
				$('.asMobComp__iconBlock--one')
					.find('.asMobComp__icon--bluetooth')
					.hide();
				$('.asMobComp__iconBlock--one')
					.find('.asMobComp__icon--wifi')
					.show();

				$('.asMobComp__stat--one')
					.find('.asMobComp__statText--bluetooth')
					.hide();
				$('.asMobComp__stat--one')
					.find('.asMobComp__statText--wifi')
					.show();

				$('.asMobComp__priceWrapper--one')
					.find('.asMobComp__price--bluetooth')
					.hide();
				$('.asMobComp__priceWrapper--one')
					.find('.asMobComp__price--wifi')
					.show();

				$('.asMobComp__buyWrapper--one')
					.find('.asMobComp__buy--bluetooth')
					.hide();
				$('.asMobComp__buyWrapper--one')
					.find('.asMobComp__buy--wifi')
					.show();

				$('.asMobComp__learnWrapper--one')
					.find('.asMobComp__learn--bluetooth')
					.hide();
				$('.asMobComp__learnWrapper--one')
					.find('.asMobComp__learn--wifi')
					.show();
			}

			if (secondColumnTech == 'bluetooth') {
				$('.asMobComp__iconBlock--two')
					.find('.asMobComp__icon--bluetooth')
					.show();
				$('.asMobComp__iconBlock--two')
					.find('.asMobComp__icon--wifi')
					.hide();

				$('.asMobComp__stat--two')
					.find('.asMobComp__statText--bluetooth')
					.show();
				$('.asMobComp__stat--two')
					.find('.asMobComp__statText--wifi')
					.hide();

				$('.asMobComp__priceWrapper--two')
					.find('.asMobComp__price--bluetooth')
					.show();
				$('.asMobComp__priceWrapper--two')
					.find('.asMobComp__price--wifi')
					.hide();

				$('.asMobComp__buyWrapper--two')
					.find('.asMobComp__buy--bluetooth')
					.show();
				$('.asMobComp__buyWrapper--two')
					.find('.asMobComp__buy--wifi')
					.hide();

				$('.asMobComp__learnWrapper--two')
					.find('.asMobComp__learn--bluetooth')
					.show();
				$('.asMobComp__learnWrapper--two')
					.find('.asMobComp__learn--wifi')
					.hide();
			} else {
				$('.asMobComp__iconBlock--two')
					.find('.asMobComp__icon--bluetooth')
					.hide();
				$('.asMobComp__iconBlock--two')
					.find('.asMobComp__icon--wifi')
					.show();

				$('.asMobComp__stat--two')
					.find('.asMobComp__statText--bluetooth')
					.hide();
				$('.asMobComp__stat--two')
					.find('.asMobComp__statText--wifi')
					.show();

				$('.asMobComp__priceWrapper--two')
					.find('.asMobComp__price--bluetooth')
					.hide();
				$('.asMobComp__priceWrapper--two')
					.find('.asMobComp__price--wifi')
					.show();

				$('.asMobComp__buyWrapper--two')
					.find('.asMobComp__buy--bluetooth')
					.hide();
				$('.asMobComp__buyWrapper--two')
					.find('.asMobComp__buy--wifi')
					.show();

				$('.asMobComp__learnWrapper--two')
					.find('.asMobComp__learn--bluetooth')
					.hide();
				$('.asMobComp__learnWrapper--two')
					.find('.asMobComp__learn--wifi')
					.show();
			}
		}
		setCompareMobileProds();

		$('.asMobComp__selectDropButton').on('click', function () {
			var container = $(this).closest('.asMobComp__select');
			var thisThing = $(this);
			container.attr('data-number', thisThing.attr('data-number'));
			container.find('.asMobComp__selectedName').text(thisThing.text());

			setCompareMobileProds();
		});

		$('.asMobComp__toggleButton').on('click', function () {
			var container = $(this).closest('.asMobComp__toggleWrapper');
			var thisThing = $(this);

			container
				.find('.asMobComp__toggleButton')
				.removeClass('asMobComp__toggleButton--active');
			thisThing.addClass('asMobComp__toggleButton--active');

			if (thisThing.attr('data-tech') == 'bluetooth') {
				container
					.find('.asMobComp__toggleBkg')
					.removeClass('asMobComp__toggleBkg--wifi');
				container
					.find('.asMobComp__toggleBkg')
					.addClass('asMobComp__toggleBkg--bluetooth');
			} else {
				container
					.find('.asMobComp__toggleBkg')
					.addClass('asMobComp__toggleBkg--wifi');
				container
					.find('.asMobComp__toggleBkg')
					.removeClass('asMobComp__toggleBkg--bluetooth');
			}

			setCompareMobileProds();
		});

		$('.assure-switch [data-iframe]').on('click', function () {
			var target = $('.touchVidModal');
			var iframe = $(this).attr('data-iframe');

			target.find('.touchVidModal__iframeWrapper').html(iframe);
			target.fadeIn();
		});

		$('.touchVidModal__bkg, .touchVidModal__close').on(
			'click',
			function () {
				var target = $('.touchVidModal');

				target.find('.touchVidModal__iframeWrapper').html('');
				target.fadeOut();
			}
		);
		if ($('.al2Prod__colorButtonInner').length > 0) {
			$('.al2Prod__colorButtonInner:first').click();
		}

		$('.workPill__slider .slider__slides').slick({
			slidesToShow: 3,
			variableWidth: false,
			infinite: false,
			arrows: true,
			dots: false,
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						// variableWidth: false,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						variableWidth: false,
						fade: true,
					},
				},
			],
		});

		$('.workPill__tabs .slider').slick({
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});

		$('.accessCollection__prev--tabs').on('click', function () {
			$('.workPill__tabs .slider').slick('slickPrev');
		});

		$('.accessCollection__next--tabs').on('click', function () {
			$('.workPill__tabs .slider').slick('slickNext');
		});

		$('.workPill__slider .slider__slides').on(
			'afterChange',
			function (event, slick, currentSlide) {
				if (
					slick.currentSlide >=
					slick.slideCount - slick.options.slidesToShow
				) {
					$('.workPill__slider .slider__slides').slick(
						'slickGoTo',
						0
					);
				}
			}
		);

		$('.workPill__tabs .tab-btn button').on('click', function () {
			var dataID = $(this).attr('data-id');

			$('.workPill__tabs .tab-btn').removeClass('active');
			$(this).closest('.tab-btn').addClass('active');

			$('.workPill__tabs .tabs__list .tab-block').removeClass('active');
			$(
				'.workPill__tabs .tabs__list .tab-block[data-id="' +
					dataID +
					'"]'
			).addClass('active');
			$(
				'.workPill__tabs .tabs__list .tab-block[data-id="' +
					dataID +
					'"] .slider'
			).slick('setPosition');
		});

		$('.works-with .trigger').on('click', function () {
			$(this).toggleClass('active');
			$(this).next('.copy').slideToggle(350);
		});

		// Works With Pillars Brand Filter - DESKTOP
		$('.workPill__explore .explore__filters--desktop .filter').on(
			'click',
			function () {
				var filterVal = $(this).attr('data-id');

				if ($(this).hasClass('active')) {
					$(this).removeClass('active');
					$('.explore__brands .brand').fadeOut(200, function () {
						setTimeout(function () {
							$('.explore__brands .brand')
								.removeClass('active')
								.fadeIn(100);
							// $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
						}, 200);
					});
				} else {
					$('.workPill__explore .filter').removeClass('active');
					$(this).addClass('active');

					$('.explore__brands .brand').fadeOut(200, function () {
						if (filterVal == 'all') {
							setTimeout(function () {
								$('.explore__brands .brand')
									.removeClass('active')
									.fadeIn(100);
								// $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
							}, 200);
						} else {
							setTimeout(function () {
								$('.explore__brands .brand').removeClass(
									'active'
								);
								$(
									'.explore__brands .brand[data-' +
										filterVal +
										'="true"]'
								)
									.addClass('active')
									.fadeIn(100);
							}, 200);
						}
					});
				}
			}
		);

		// Works With Pillars Brand Filter - MOBILE
		$('.workPill__explore .explore__filters--mobile .chooser .filter').on(
			'click',
			function () {
				$(
					'.workPill__explore .explore__filters--mobile  .chooser'
				).toggleClass('is-open');
				$(
					'.workPill__explore .explore__filters--mobile  .list'
				).slideToggle(400);
			}
		);

		$('.workPill__explore .explore__filters--mobile .list .filter').on(
			'click',
			function () {
				var filterVal = $(this).attr('data-id');
				$(
					'.workPill__explore .explore__filters--mobile  .chooser li'
				).removeClass('active');
				$(
					'.workPill__explore .explore__filters--mobile  .chooser'
				).toggleClass('is-open');

				$(
					'.workPill__explore .explore__filters--mobile .chooser .filter[data-id="' +
						filterVal +
						'"]'
				)
					.closest('li')
					.addClass('active');

				$('.explore__filters--mobile  .list').slideUp(400, function () {
					setTimeout(function () {
						$(
							'.workPill__explore .explore__filters--mobile  .list li'
						).removeClass('active');
						$(
							'.workPill__explore .explore__filters--mobile .list .filter[data-id="' +
								filterVal +
								'"]'
						)
							.closest('li')
							.addClass('active');
					}, 450);
				});

				$('.explore__brands .brand').fadeOut(200, function () {
					if (filterVal == 'all') {
						setTimeout(function () {
							$('.explore__brands .brand')
								.removeClass('active')
								.fadeIn(100);
							// $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
						}, 200);
					} else {
						setTimeout(function () {
							$('.explore__brands .brand').removeClass('active');
							$(
								'.explore__brands .brand[data-' +
									filterVal +
									'="true"]'
							)
								.addClass('active')
								.fadeIn(100);
						}, 200);
					}
				});
			}
		);

		// Works With Tabs Filter - MOBILE
		$('.workPill__tabs .explore__filters--mobile .chooser button').on(
			'click',
			function () {
				$(
					'.workPill__tabs .explore__filters--mobile  .chooser'
				).toggleClass('is-open');
				$(
					'.workPill__tabs .explore__filters--mobile  .list'
				).slideToggle(400);
			}
		);

		$('.workPill__tabs .explore__filters--mobile .list button').on(
			'click',
			function () {
				var filterVal = $(this).attr('data-id');
				$(
					'.workPill__tabs .explore__filters--mobile  .chooser li'
				).removeClass('active');
				$(
					'.workPill__tabs .explore__filters--mobile  .chooser'
				).toggleClass('is-open');

				$(
					'.workPill__tabs .explore__filters--mobile .chooser button[data-id="' +
						filterVal +
						'"]'
				)
					.closest('li')
					.addClass('active');

				$('.explore__filters--mobile .list').slideUp(400, function () {
					setTimeout(function () {
						$(
							'.workPill__tabs .explore__filters--mobile  .list li'
						).removeClass('active');
						$(
							'.workPill__tabs .explore__filters--mobile .list button[data-id="' +
								filterVal +
								'"]'
						)
							.closest('li')
							.addClass('active');
					}, 450);
				});
			}
		);

		$('.sloFeatured__techSwap').on('click', function () {
			$('.sloFeatured__techSwap').removeClass(
				'sloFeatured__techSwap--active'
			);
			$(this).addClass('sloFeatured__techSwap--active');
			if ($(this).attr('data-tech') == 'bluetooth') {
				$('.sloFeatured__techContainer--bluetooth').show();
				$('.sloFeatured__techContainer--wifi').hide();
			} else {
				$('.sloFeatured__techContainer--bluetooth').hide();
				$('.sloFeatured__techContainer--wifi').show();
			}
		});

		function legalScrollRight() {
			$('.newLegalHeader__tabsFrame').animate(
				{ scrollLeft: '+=164' },
				200
			);
		}
		$('.newLegalHeader__tabsNext').on('click', function () {
			legalScrollRight();
		});
		function legalScrollLeft() {
			$('.newLegalHeader__tabsFrame').animate(
				{ scrollLeft: '-=164' },
				200
			);
		}
		$('.newLegalHeader__tabsPrev').on('click', function () {
			legalScrollLeft();
		});

		console.log('test the legal page here');

		function legalCheckScroll() {
			if ($('.newLegalHeader__tabsFrame').length > 0) {
				var $width = $('.newLegalHeader__tabsFrame').outerWidth();
				var $scrollWidth = $('.newLegalHeader__tabsFrame')[0]
					.scrollWidth;
				var $scrollLeft = $('.newLegalHeader__tabsFrame').scrollLeft();

				if ($scrollWidth - $width === $scrollLeft) {
					$('.newLegalHeader__tabsNextBox').fadeOut();
				} else {
					$('.newLegalHeader__tabsNextBox').fadeIn();
				}
				if ($scrollLeft === 0) {
					$('.newLegalHeader__tabsPrevBox').fadeOut();
				} else {
					$('.newLegalHeader__tabsPrevBox').fadeIn();
				}
			}
		}
		legalCheckScroll();

		$('.newLegalHeader__tabsFrame').on('scroll', function () {
			legalCheckScroll();
		});

		$('.newLegalTopButton').on('click', function () {
			$('body, html').animate({ scrollTop: '0' }, 200);
		});

		$('.newLegalHeader__mobileTabSelected').on('click', function () {
			$('.newLegalHeader__mobileTabsDrawer').slideToggle();
		});
	});

	$(document).ready(function () {
		function updateCart(openCart) {
			app._getCartData();
			app._vibrateDevice();
			app.$snotify.clear();
			showHideMiniCartKeyedAlike();
			setTimeout(function () {
				if (
					((app.isLoading = false),
					(app.loadingEvent = null),
					app.storeUtilities.cartUpsells.settings.showOnPopUp)
				) {
					var origin = app.cart.items.find(function (data) {
						return data.variant_id === keys;
					});
					app._openModalCartUpsell(origin);
				} else {
					if (openCart == true) {
						app._openCartDrawer();
					} else {
						app._touchCartDrawer();
					}
				}
			}, 300);
		}

		function showHideMiniCartKeyedAlike() {
			var count = 0;
			var alreadyGroups = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (
					CartJS.cart.items[i].properties['_keyed_alike_available'] ==
					'true'
				) {
					var qty = CartJS.cart.items[i].quantity;
					count += 1 * qty;
				}
				if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
					alreadyGroups = true;
				}
			}
			console.log(count);
			if (count > 1 && alreadyGroups == false) {
				$('.miniCartKA').show();
			} else {
				$('.miniCartKA').hide();
			}
		}

		function getIndexVariantData(targetButton) {
			var targetContainer = targetButton.closest('.card');
			var activeColorTitle = targetContainer
				.find('.color-swatch input:checked')
				.attr('value');

			var targetSelector = targetContainer.find('.indexBuySelect');
			var selectedVariant = false;
			var found = false;
			targetSelector.find('option').each(function () {
				if (
					$(this).attr('data-options').indexOf(activeColorTitle) >=
						0 &&
					found == false
				) {
					selectedVariant = {
						id: $(this).attr('value') * 1,
						available: $(this).attr('data-available'),
						price: $(this).attr('data-price'),
					};
					var imgSrc = $(this).attr('data-image');
					console.log(imgSrc);
					targetContainer.find('.card-img-image').attr('src', imgSrc);
					found = true;
				}
			});

			return selectedVariant;
		}

		function displayIndexVaraintData(variantData, targetButton) {
			var targetContainer = targetButton.closest('.card-body');
			targetContainer.find('.CROProdPrice').text(variantData.price);
			targetContainer
				.find('.indexBuyButton')
				.attr('data-id', variantData.id);
			if (variantData.available == 'true') {
				targetContainer.find('.indexBuyButton').text('Buy Now');
				targetContainer
					.find('.indexBuyButton')
					.removeClass('indexBuyButton--soldOut');
			} else {
				targetContainer.find('.indexBuyButton').text('Out of Stock');
				targetContainer
					.find('.indexBuyButton')
					.addClass('indexBuyButton--soldOut');
			}
		}

		function initializeAllHomeCROButtons() {
			$('.indexBuyButton').each(function () {
				var thisThing = $(this);
				var variantData = getIndexVariantData(thisThing);
				displayIndexVaraintData(variantData, thisThing);
			});
		}

		function bindHomeCROButtons() {
			$('.CROColorButton')
				.unbind('click')
				.on('click', function () {
					var thisThing = $(this);
					var variantData = getIndexVariantData(thisThing);
					displayIndexVaraintData(variantData, thisThing);
				});

			$('.indexBuyButton')
				.unbind('click')
				.on('click', function (e) {
					e.preventDefault();
					var variantID = $(this).attr('data-id');
					if (checkDiscountLimitFull(variantID)) {
						alert(
							'You can only order up to ' +
								$('body').attr('data-qty-limit') * 1 +
								' discounted items.'
						);
						return;
					}
					CartJS.addItem(
						variantID,
						1,
						{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
						{
							success: function (data, textStatus, jqXHR) {
								updateCart(true);
							},
							error: function (jqXHR, textStatus, errorThrown) {
								console.log('Error: ' + errorThrown + '!');
							},
						}
					);
				});
		}
		bindHomeCROButtons();
		initializeAllHomeCROButtons();

		setInterval(function () {
			bindHomeCROButtons();
			//initializeAllHomeCROButtons();
		}, 500);

		if (indexBuyButtonTest == true) {
			$('.showForCROIndexTest').show();
			$('.hideForCROIndexTest').hide();
		} else {
			$('.showForCROIndexTest').hide();
			$('.hideForCROIndexTest').show();
		}

		function setHomeAwardWidths() {
			$('.indexPress__card').each(function () {
				var thisThing = $(this);
				var targetWidth = $(this).find('img').width();
				thisThing.attr('style', 'width:' + targetWidth + 'px;');
			});
		}
		setHomeAwardWidths();

		var homeIndexCount = 0;

		if ($('.indexPress__card').length > 0) {
			setInterval(function () {
				homeIndexCount += 1;
				if (homeIndexCount > 3) {
					homeIndexCount = 0;
				}
				$('.indexPress__dot').removeClass('indexPress__dot--active');
				$('.indexPress__card').removeClass('indexPress__card--active');

				$(
					'.indexPress__dot[data-index="' + homeIndexCount + '"]'
				).addClass('indexPress__dot--active');
				$(
					'.indexPress__card[data-index="' + homeIndexCount + '"]'
				).addClass('indexPress__card--active');

				setHomeAwardWidths();
			}, 2000);
		}

		$('.approachVideos__button').on('click', function () {
			var dataIndex = $(this).attr('data-index');
			var thisParent = $(this).closest('.approachVideos');

			if (!$(this).hasClass('approachVideos__button--active')) {
				thisParent
					.find('.approachVideos__button')
					.removeClass('approachVideos__button--active');
				$(this).addClass('approachVideos__button--active');

				thisParent
					.find('.approachVideos__video')
					.removeClass('approachVideos__video--active');
				thisParent
					.find(
						'.approachVideos__video[data-index="' + dataIndex + '"]'
					)
					.addClass('approachVideos__video--active');
			}
		});

		$('.approachManageButton__button').on('click', function () {
			var dataIndex = $(this).attr('data-index');
			var thisParent = $(this).closest('.approachManage');

			if (!$(this).parent().hasClass('approachManageButton--active')) {
				thisParent
					.find('.approachManageButton')
					.removeClass('approachManageButton--active');
				$(this).parent().addClass('approachManageButton--active');

				thisParent
					.find('.approachManage__image')
					.removeClass('approachManage__image--active');
				thisParent
					.find(
						'.approachManage__image[data-index="' + dataIndex + '"]'
					)
					.addClass('approachManage__image--active');
			}
		});

		$('.approachVideoPlayer__playButton').on('click', function () {
			var iframeHTML = $(this).attr('data-iframe');
			$(this)
				.closest('.shopify-section')
				.find('.approachVideoPopup')
				.fadeIn();
			$(this)
				.closest('.shopify-section')
				.find('.approachVideoPopup__iframeWrapper')
				.html(iframeHTML);
		});

		$('.approachVideoPopup__background, .approachVideoPopup__close').on(
			'click',
			function () {
				var parentTarget = $(this).closest('.approachVideoPopup');
				var iframeWrapper = parentTarget.find(
					'.approachVideoPopup__iframeWrapper'
				);
				iframeWrapper.html('');
				parentTarget.fadeOut();
			}
		);

		const approachAppSlider = new Swiper(
			'.approachApp__mobileSliderContainer',
			{
				pagination: {
					el: '.approachApp__sliderDots',
				},
				navigation: {
					nextEl: '.approachApp__nextSlide',
					prevEl: '.approachApp__previousSlide',
				},
			}
		);

		const approachManageUpperSlider = new Swiper(
			'.approachManage__mobileUpperSliderContainer',
			{
				pagination: {
					el: '.approachManage__dots',
				},
				navigation: {
					nextEl: '.approachManage__next',
					prevEl: '.approachManage__previous',
				},
			}
		);

		const approachManageLowerSlider = new Swiper(
			'.approachManage__mobileLowerSliderContainer',
			{
				pagination: {
					el: '.approachManage__dots',
				},
				navigation: {
					nextEl: '.approachManage__next',
					prevEl: '.approachManage__previous',
				},
			}
		);

		$('.al2Sticky--approach').parent().addClass('newSticky');

		$('.newsList__showMore').on('click', function () {
			$('.newsCard--hidden').removeClass('newsCard--hidden');
			$('.newsList__showFlex').hide();
		});

		if ($('.pressBody__sideBar').length > 0) {
			var sideBarContent = $('.pressBody__sideBar').html();
			$('.pressMobileSidebarContainer').html(sideBarContent);
		}

		if ($('.topbar--countdown').length > 0) {
			var endDateString = $('.headerCountDown__countWrapper').attr(
				'data-date'
			);
			const targetTime = new Date(endDateString);

			setInterval(function () {
				const currentTime = new Date();
				const difference = targetTime - currentTime;

				const days = Math.floor(difference / (1000 * 60 * 60 * 24))
					.toString()
					.padStart(2, '0');
				const hours = Math.floor(
					(difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
				)
					.toString()
					.padStart(2, '0');
				const minutes = Math.floor(
					(difference % (1000 * 60 * 60)) / (1000 * 60)
				)
					.toString()
					.padStart(2, '0');
				const seconds = Math.floor((difference % (1000 * 60)) / 1000)
					.toString()
					.padStart(2, '0');

				$('.headerCountDown__number--days').text(days);
				$('.headerCountDown__number--hours').text(hours);
				$('.headerCountDown__number--minutes').text(minutes);
				$('.headerCountDown__number--seconds').text(seconds);
			}, 100);
		}

		var swiperLib = [];
		var arrayIndex = 0;
		$('.swiper-wrapper').each(function () {
			var origin = $(this).closest('[data-section-index]');
			var builderIndex = origin.attr('data-section-index');

			if (origin.hasClass('expressionCardRow')) {
				swiperLib.push(
					new Swiper(
						'[data-section-index="' +
							builderIndex +
							'"] .expressionCardRow__sliderWrapper',
						{
							loop: false,
							slidesPerView: 1,
							spaceBetween: 20,
							navigation: {
								prevEl:
									'[data-section-index="' +
									builderIndex +
									'"] .expressionCardRow__previous',
								nextEl:
									'[data-section-index="' +
									builderIndex +
									'"] .expressionCardRow__next',
							},
							breakpoints: {
								600: {
									slidesPerView: 2,
								},
								800: {
									slidesPerView: 3,
								},
								1000: {
									slidesPerView: 4,
								},
							},
						}
					)
				);

				arrayIndex += 1;
			} else if (origin.hasClass('liftThreeCards')) {
				swiperLib.push(
					new Swiper(
						'[data-section-index="' +
							builderIndex +
							'"] .liftThreeCards__sliderWrapper',
						{
							loop: false,
							slidesPerView: 1,
							spaceBetween: 20,
							navigation: {
								prevEl:
									'[data-section-index="' +
									builderIndex +
									'"] .liftThreeCards__previous',
								nextEl:
									'[data-section-index="' +
									builderIndex +
									'"] .liftThreeCards__next',
							},
							breakpoints: {
								600: {
									slidesPerView: 2,
								},
								800: {
									slidesPerView: 3,
								},
							},
						}
					)
				);
			} else if (origin.hasClass('liftFourCards')) {
				swiperLib.push(
					new Swiper(
						'[data-section-index="' +
							builderIndex +
							'"] .liftFourCards__sliderWrapper',
						{
							loop: false,
							slidesPerView: 1,
							spaceBetween: 20,
							navigation: {
								prevEl:
									'[data-section-index="' +
									builderIndex +
									'"] .liftFourCards__previous',
								nextEl:
									'[data-section-index="' +
									builderIndex +
									'"] .liftFourCards__next',
							},
							breakpoints: {
								600: {
									slidesPerView: 2,
								},
								800: {
									slidesPerView: 3,
								},
								1000: {
									slidesPerView: 4,
								},
							},
						}
					)
				);
			}
		});

		if ($('.approachPDP').length > 0) {
			if ($('.approachPDP--keypad').length > 0) {
				$('[data-prod-option="wifi"]').on('click', function () {
					$('.al2Prod__newTag').hide();
				});
				$('[data-prod-option="bluetooth"]').on('click', function () {
					$('.al2Prod__newTag').show();
				});
			} else {
				$('[data-key-option="key-free"]').on('click', function () {
					$('.al2Prod__newTag').hide();
				});
				$('[data-key-option="keyed"]').on('click', function () {
					$('.al2Prod__newTag').show();
				});
			}
			$('[data-prod-option="wifi"]').on('click', function () {
				$('[data-key-option="key-free"]').click();
				$('.al2Prod__keyOptionRow').hide();
			});
			$('[data-prod-option="bluetooth"]').on('click', function () {
				$('.al2Prod__keyOptionRow').show();
				$('[data-key-option="keyed"]').click();
			});
		}

		function replaceNavForB2B() {
			$('.topbar').remove();
			$('.b2bHide').hide();
			var desktopNav = $('.navbar-main').find('ul.main-nav');
			var newNavHTML =
				'<li class="nav-item dropdown"><a name="Business Overview" href="/pages/business-and-multi-family" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglebusiness-and-multi-family">Business Overview</a></li>';
			newNavHTML +=
				'<li class="nav-item dropdown"><a name="Multi-Family Housing" href="/pages/multi-family-housing" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglemulti-family-housing">Multi-Family Housing</a></li>';
			newNavHTML +=
				'<li class="nav-item dropdown"><a name="Security Integrators" href="/pages/security-integrators" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglesecurity-integrators">Security Integrators</a></li>';
			newNavHTML +=
				'<li class="nav-item dropdown"><a name="Wholesale Distribution" href="/pages/wholesale-distribution" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglewholesale-distribution">Wholesale Distribution</a></li>';
			newNavHTML +=
				'<li class="nav-item dropdown"><a name="Support" target="_blank" href="https://support.shopyalehome.com/" id="navbarDropdown" role="button" aria-haspopup-"true" aria-expanded="false" rel="noreferrer" class="nav-link border-0 dropdown-togglesupport">Support</a></li>';
			desktopNav.html(newNavHTML);
		}

		function replaceMobNavForB2B() {
			$('header nav a[name="search"]').html('');
			$('header nav a[name="cart"]').html('');
			$('header nav a[name="account"]').html('');
			$('header nav a[name="menu"]').attr('style', 'height:20px;');
			$('.b2bHide').hide();
			var desktopNav = $('.mobile-nav-drawer .navbar-mobile')
				.find('ul.navbar-nav')
				.first();
			var newNavHTML =
				'<li class="nav-item "><a href="/pages/business-and-multi-family" name="Business Overview" title="Business Overview" aria-label="Business Overview" class="nav-link">Business Overview</a></li>';
			newNavHTML +=
				'<li class="nav-item "><a href="/pages/multi-family-housing" name="Multi-Family Housing" title="Multi-Family Housing" aria-label="Multi-Family Housing" class="nav-link">Multi-Family Housing</a></li>';
			newNavHTML +=
				'<li class="nav-item "><a href="/pages/security-integrators" name="Security Integrators" title="Security Integrators" aria-label="Security Integrators" class="nav-link">Security Integrators</a></li>';
			newNavHTML +=
				'<li class="nav-item "><a href="/pages/wholesale-distribution" name="Wholesale Distribution" title="Wholesale Distribution" aria-label="Wholesale Distribution" class="nav-link">Wholesale Distribution</a></li>';
			newNavHTML +=
				'<li class="nav-item "><a href="https://support.shopyalehome.com/" target="_blank" name="Support" title="Support" aria-label="Support" class="nav-link">Support</a></li>';
			desktopNav.html(newNavHTML);
		}

		var isB2bPage = false;
		var b2bClassList = [
			'.template-page-lift-businessmultifamily',
			'.template-page-lift-multifamily',
			'.template-page-lift-security',
			'.template-page-lift-wholesale',
		];
		for (i = 0; i < b2bClassList.length; i++) {
			if ($(b2bClassList[i]).length > 0) {
				isB2bPage = true;
			}
		}
		if (isB2bPage) {
			replaceNavForB2B();
			replaceMobNavForB2B();
		}
	});

	$(document).ready(function () {
		var sliderArray = [];
		var swiperCount = 0;
		$('[data-builder-index] .swiper-wrapper').each(function () {
			var thisIndex = $(this)
				.closest('[data-builder-index]')
				.attr('data-builder-index');
			var thisParent = $(this).parent();
			if (thisParent.hasClass('abnbShop__sliderWrapper')) {
				var swiperData = {
					slidesPerView: 1,
					spaceBetween: 20,
					freeMode: {
						enabled: true,
						sticky: true,
					},
					mousewheel: {
						enabled: true,
						forceToAxis: true,
					},
					navigation: {
						nextEl: '.abnbShop__nextArrow',
						prevEl: '.abnbShop__prevArrow',
					},
					loop: false,
					breakpoints: {
						1000: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
					},
				};
				sliderArray[swiperCount] = new Swiper(
					'[data-builder-index="' +
						thisIndex +
						'"] .abnbShop__sliderWrapper',
					swiperData
				);
				swiperCount++;
			} else if (thisParent.hasClass('abnbLinks__sliderWrapper')) {
				var swiperData = {
					slidesPerView: 1,
					spaceBetween: 20,
					loop: false,
					navigation: {
						nextEl: '.abnbLinks__nextArrow',
						prevEl: '.abnbLinks__prevArrow',
					},
					freeMode: {
						enabled: true,
						sticky: true,
					},
					mousewheel: {
						enabled: true,
						forceToAxis: true,
					},
					breakpoints: {
						1000: {
							slidesPerView: 3,
						},
					},
				};
				sliderArray[swiperCount] = new Swiper(
					'[data-builder-index="' +
						thisIndex +
						'"] .abnbLinks__sliderWrapper',
					swiperData
				);
				swiperCount++;
			} else if (thisParent.hasClass('eco3Cards__sliderWrapper')) {
				var swiperData = {
					slidesPerView: 1,
					spaceBetween: 12,
					loop: false,
					navigation: {
						nextEl:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Card__arrow--next',
						prevEl:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Card__arrow--prev',
					},
					freeMode: {
						enabled: true,
						sticky: true,
					},
					mousewheel: {
						enabled: true,
						forceToAxis: true,
					},
					pagination: {
						el:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Cards__dotsHolder',
					},
					breakpoints: {
						1000: {
							slidesPerView: 3,
						},
					},
				};
				sliderArray[swiperCount] = new Swiper(
					'[data-builder-index="' +
						thisIndex +
						'"] .eco3Cards__sliderWrapper',
					swiperData
				);
				swiperCount++;
			} else if (thisParent.hasClass('eco3Col__sliderWrapper')) {
				var swiperData = {
					slidesPerView: 1,
					spaceBetween: 0,
					loop: false,
					navigation: {
						nextEl:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Card__arrow--next',
						prevEl:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Card__arrow--prev',
					},
					freeMode: {
						enabled: true,
						sticky: true,
					},
					mousewheel: {
						enabled: true,
						forceToAxis: true,
					},
					pagination: {
						el:
							'[data-builder-index="' +
							thisIndex +
							'"] .eco3Cards__dotsHolder',
					},
					breakpoints: {
						1000: {
							slidesPerView: 3,
						},
					},
				};
				sliderArray[swiperCount] = new Swiper(
					'[data-builder-index="' +
						thisIndex +
						'"] .eco3Col__sliderWrapper',
					swiperData
				);
				swiperCount++;
			}
		});

		$('.abnbProdSlide__color').on('click', function () {
			var slideParent = $(this).closest('.abnbProdSlide');
			slideParent
				.find('.abnbProdSlide__color')
				.removeClass('abnbProdSlide__color--active');
			$(this).addClass('abnbProdSlide__color--active');
			var imageTarget = slideParent.find('.abnbProdSlide__image');
			if ($(this).attr('data-name') == 'Black Suede') {
				imageTarget.attr('src', imageTarget.attr('data-black'));
			} else if (
				$(this).attr('data-name') == 'Satin Nickel' ||
				$(this).attr('data-name') == 'Silver'
			) {
				imageTarget.attr('src', imageTarget.attr('data-silver'));
			}
			var colorName = $(this).attr('data-name');
			slideParent.find('.abnbProdSlide__colorLabel').text(colorName);
			var skuNumber = $(this).attr('data-sku');
			slideParent.find('.abnbProdSlide__sku').text(skuNumber);

			if ($(this).attr('data-available') == 'false') {
				slideParent.find('.abnbProdSlide__buy').prop('disabled', true);
				slideParent
					.find('.abnbProdSlide__buy')
					.addClass('abnbProdSlide__buy--disabled');
				slideParent.find('.abnbProdSlide__buyInner').text('Sold Out');
			} else {
				slideParent.find('.abnbProdSlide__buy').prop('disabled', false);
				slideParent
					.find('.abnbProdSlide__buy')
					.removeClass('abnbProdSlide__buy--disabled');
				slideParent.find('.abnbProdSlide__buyInner').text('Buy Now');
			}
		});

		$('.abnbProdSlide__qtyLess').on('click', function () {
			var slideParent = $(this).closest('.abnbProdSlide');
			var qtyNode = slideParent.find('.abnbProdSlide__input');
			var qty = qtyNode.val() * 1;
			if (qty > 1) {
				qtyNode.val(qty - 1);
			}
		});

		$('.abnbProdSlide__qtyMore').on('click', function () {
			var slideParent = $(this).closest('.abnbProdSlide');
			var qtyNode = slideParent.find('.abnbProdSlide__input');
			var qty = qtyNode.val() * 1;
			qtyNode.val(qty + 1);
		});

		function updateCart(openCart) {
			app._getCartData();
			app._vibrateDevice();
			app.$snotify.clear();
			showHideMiniCartKeyedAlike();
			setTimeout(function () {
				if (
					((app.isLoading = false),
					(app.loadingEvent = null),
					app.storeUtilities.cartUpsells.settings.showOnPopUp)
				) {
					var origin = app.cart.items.find(function (data) {
						return data.variant_id === keys;
					});
					app._openModalCartUpsell(origin);
				} else {
					if (openCart == true) {
						app._openCartDrawer();
					} else {
						app._touchCartDrawer();
					}
				}
			}, 300);
		}

		function addToCart(variant, qty, keyed) {
			if (checkDiscountLimitFull(variant)) {
				alert(
					'You can only order up to ' +
						$('body').attr('data-qty-limit') * 1 +
						' discounted items.'
				);
				return;
			}
			if (typeof keyed !== 'undefined' && keyed) {
				CartJS.addItem(
					variant,
					qty,
					{ _keyed_alike_available: keyed, "_requested_ship_date": getNearestWeekdayTwoDaysAhead() },
					{
						success: function (data, textStatus, jqXHR) {
							setTimeout(function () {
								updateCart(true);
							}, 200);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			} else {
				CartJS.addItem(
					variant,
					qty,
					{"_requested_ship_date": getNearestWeekdayTwoDaysAhead()},
					{
						success: function (data, textStatus, jqXHR) {
							updateCart(true);
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.log('Error: ' + errorThrown + '!');
						},
					}
				);
			}
		}

		function showHideMiniCartKeyedAlike() {
			var count = 0;
			var alreadyGroups = false;
			for (i = 0; i < CartJS.cart.items.length; i++) {
				if (
					CartJS.cart.items[i].properties['_keyed_alike_available'] ==
					'true'
				) {
					var qty = CartJS.cart.items[i].quantity;
					count += 1 * qty;
				}
				if (CartJS.cart.items[i].properties['_groups'] * 1 > 0) {
					alreadyGroups = true;
				}
			}
			console.log(count);
			if (count > 1 && alreadyGroups == false) {
				$('.miniCartKA').show();
			} else {
				$('.miniCartKA').hide();
			}
		}

		$('.abnbProdSlide__buy').on('click', function () {
			var slideParent = $(this).closest('.abnbProdSlide');
			var qtyNode = slideParent.find('.abnbProdSlide__input');
			var activeColor = slideParent.find('.abnbProdSlide__color--active');

			var qty = qtyNode.val() * 1;
			var variantId = activeColor.attr('data-id') * 1;
			var keyed = activeColor.attr('data-keyed') == 'true';

			addToCart(variantId, qty, keyed);
		});

		var firstAbnbSbs = $('.abnbSBS').first();
		$(
			'<div class="abnbSBSMob"><div class="abnbSBSMob__inner"><div class="abnbSBSMob__sliderControls"></div><div class="abnbSBSMob__sliderWrapper"><div class="abnbSBSMob__slider swiper-wrapper"></div></div><div class="abnbSBSMob__dotsWrapper"></div></div></div>'
		).insertBefore(firstAbnbSbs);
		$('.abnbSBSMob__sliderControls').html(
			'<button class="abnbSBSMob__prevArrow"><img class="abnbSBSMob__prevArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Rectangle_155.png?v=1721942984" alt="previous arrow icon"></button><button class="abnbSBSMob__nextArrow"><img class="abnbSBSMob__nextArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Rectangle_155.png?v=1721942984" alt="next arrow icon"></button>'
		);

		const html = (strings, ...values) =>
			String.raw({ raw: strings }, ...values);
		var mobAbnbSlideTemplate = html`<div
			class="abnbSBSMobSlide swiper-slide"
		>
			<div class="abnbSBSMobSlide__inner">
				<div class="abnbSBSMobSlide__upper">
					<div class="abnbSBSMobSlide__title"></div>
					<div class="abnbSBSMobSlide__text"></div>
				</div>
				<div class="abnbSBSMobSlide__lower">
					<div class="abnbSBSMobSlide__imageWrapper">
						<img class="abnbSBSMobSlide__image" src="" alt="" />
					</div>
				</div>
			</div>
		</div>`;

		$('.abnbSBSMob').append(mobAbnbSlideTemplate);
		var template = $('.abnbSBSMobSlide').clone(false);
		$('.abnbSBSMobSlide').remove();

		$('.abnbSBS').each(function () {
			var thisElement = template.clone(false);
			var slideTitle = $(this).find('.abnbSBS__title').text();
			thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
			var slideText = $(this).find('.abnbSBS__text').text();
			thisElement.find('.abnbSBSMobSlide__text').text(slideText);
			var slideSrc = $(this).find('.abnbSBS__image').attr('src');
			var slideAlt = $(this).find('.abnbSBS__image').attr('alt');
			thisElement.find('.abnbSBSMobSlide__image').attr('src', slideSrc);
			thisElement.find('.abnbSBSMobSlide__image').attr('alt', slideAlt);

			$('.abnbSBSMob__slider').append(thisElement);
		});

		var abnbSbsSlider = new Swiper('.abnbSBSMob__sliderWrapper', {
			slidesPerView: 1,
			loop: false,
			navigation: {
				nextEl: '.abnbSBSMob__nextArrow',
				prevEl: '.abnbSBSMob__prevArrow',
			},
			freeMode: {
				enabled: true,
				sticky: true,
			},
			mousewheel: {
				enabled: true,
				forceToAxis: true,
			},
			pagination: {
				el: '.abnbSBSMob__dotsWrapper',
				type: 'bullets',
			},
		});

		if ($('.approachPDP--code').length > 0) {
			var firstAbnbSbs = $('.approachSBS').first();
			$(
				'<div class="abnbSBSMob abnbSBSMob--code"><div class="abnbSBSMob__inner"><div class="abnbSBSMob__sliderControls"></div><div class="abnbSBSMob__sliderWrapper"><div class="abnbSBSMob__slider swiper-wrapper"></div></div><div class="abnbSBSMob__dotsWrapper"></div></div></div>'
			).insertBefore(firstAbnbSbs);
			$('.abnbSBSMob__sliderControls').html(
				'<button class="abnbSBSMob__prevArrow"><img class="abnbSBSMob__prevArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Frame_3113_1.png?v=1725648245" alt="previous arrow icon"></button><button class="abnbSBSMob__nextArrow"><img class="abnbSBSMob__nextArrowIcon" src="https://cdn.shopify.com/s/files/1/0097/2433/0084/files/Frame_3112_3.png?v=1725648245" alt="next arrow icon"></button>'
			);

			const html = (strings, ...values) =>
				String.raw({ raw: strings }, ...values);
			var mobAbnbSlideTemplate = html`<div
				class="abnbSBSMobSlide swiper-slide"
			>
				<div class="abnbSBSMobSlide__inner">
					<div class="abnbSBSMobSlide__upper">
						<div class="abnbSBSMobSlide__title"></div>
						<div class="abnbSBSMobSlide__text"></div>
					</div>
					<div class="abnbSBSMobSlide__lower">
						<div class="abnbSBSMobSlide__imageWrapper">
							<img class="abnbSBSMobSlide__image" src="" alt="" />
						</div>
					</div>
				</div>
			</div>`;

			$('.abnbSBSMob').append(mobAbnbSlideTemplate);
			var template = $('.abnbSBSMobSlide').clone(false);
			$('.abnbSBSMobSlide').remove();

			$('.approachSBS').each(function () {
				var thisElement = template.clone(false);
				var slideTitle = $(this).find('.approachSBS__title').text();
				thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
				var slideText = $(this).find('.approachSBS__text').text();
				thisElement.find('.abnbSBSMobSlide__text').text(slideText);
				var slideSrc = $(this).find('.approachSBS__image').attr('src');
				var slideAlt = $(this).find('.approachSBS__image').attr('alt');
				thisElement
					.find('.abnbSBSMobSlide__image')
					.attr('src', slideSrc);
				thisElement
					.find('.abnbSBSMobSlide__image')
					.attr('alt', slideAlt);

				$('.abnbSBSMob__slider').append(thisElement);
			});

			$('.newKeypadColor').each(function () {
				var thisElement = template.clone(false);
				var slideTitle = $(this).find('.newKeypadColor__title').text();
				thisElement.find('.abnbSBSMobSlide__title').text(slideTitle);
				var slideText = $(this).find('.newKeypadColor__text').text();
				thisElement.find('.abnbSBSMobSlide__text').text(slideText);
				var slideSrc = $(this)
					.find('.newKeypadColor__image')
					.attr('src');
				var slideAlt = $(this)
					.find('.newKeypadColor__image')
					.attr('alt');
				thisElement
					.find('.abnbSBSMobSlide__image')
					.attr('src', slideSrc);
				thisElement
					.find('.abnbSBSMobSlide__image')
					.attr('alt', slideAlt);

				$('.abnbSBSMob__slider').append(thisElement);
			});

			var codeSlider = new Swiper('.abnbSBSMob__sliderWrapper', {
				slidesPerView: 1,
				loop: false,
				navigation: {
					nextEl: '.abnbSBSMob__nextArrow',
					prevEl: '.abnbSBSMob__prevArrow',
				},
				freeMode: {
					enabled: true,
					sticky: true,
				},
				mousewheel: {
					enabled: true,
					forceToAxis: true,
				},
				pagination: {
					el: '.abnbSBSMob__dotsWrapper',
					type: 'bullets',
				},
			});
		}

		$('.pdpKA__text').html(
			'The ideal solution to access your new locks with fewer keys. Just $3.99 per lock. Keyed Alike processing time is 5 business days.'
		);

		$('.abnbProdSlide__color--active').click();

		var headerSwiper = new Swiper('.headerSlider__container', {
			loop: true,
			slidesPerView: 1,
			navigation: {
				prevEl: '.headerSlider__prev',
				nextEl: '.headerSlider__next',
			},
			autoplay: {
				delay: 5000,
			},
		});

		if ($('.hdBars').length > 0) {
			$('#shopify-section-header').hide();
		}

		$('[ga-handle]').each(function () {
			var handle = $(this).attr('ga-handle');
			console.log(handle);
			gaView(handle);
		});

		function gaView(productHandle) {
			fetch(
				window.Shopify.routes.root + 'products/' + productHandle + '.js'
			)
				.then((response) => response.json())
				.then(
					(product) =>
						function () {
							window.dataLayer.push({ ecommerce: null });
							window.dataLayer.push({
								event: 'view_item',
								fired_from: 'shopify',
								ecommerce: {
									currency: 'USD',
									value: product.price,
									items: [
										{
											item_id: product.id,
											item_name: product.title,
											item_brand: product.vendor,
											item_category: product.type,
											item_variant:
												product.variants[0].title,
											item_variant_id:
												product.variants[0].sku,
											price: product.price,
											quantity: 1,
										},
									],
								},
							});
						}
				);
		}

		function gaAddToCart(productHandle) {
			fetch(
				window.Shopify.routes.root + 'products/' + productHandle + '.js'
			)
				.then((response) => response.json())
				.then(
					(product) =>
						function () {
							window.dataLayer.push({ ecommerce: null });
							window.dataLayer.push({
								event: 'add_to_cart',
								fired_from: 'shopify',
								ecommerce: {
									currency: 'USD',
									value: product.price,
									items: [
										{
											item_id: product.id,
											item_name: product.title,
											item_brand: product.vendor,
											item_category: product.type,
											item_variant:
												product.variants[0].title,
											item_variant_id:
												product.variants[0].sku,
											price: product.price,
											quantity: 1,
										},
									],
								},
							});
						}
				);
		}

		function gaRemoveFromCart(productHandle) {
			fetch(
				window.Shopify.routes.root + 'products/' + productHandle + '.js'
			)
				.then((response) => response.json())
				.then(
					(product) =>
						function () {
							window.dataLayer.push({ ecommerce: null });
							window.dataLayer.push({
								event: 'remove_from_cart',
								fired_from: 'shopify',
								ecommerce: {
									currency: 'USD',
									value: product.price,
									items: [
										{
											item_id: product.id,
											item_name: product.title,
											item_brand: product.vendor,
											item_category: product.type,
											item_variant:
												product.variants[0].title,
											item_variant_id:
												product.variants[0].sku,
											price: product.price,
											quantity: 1,
										},
									],
								},
							});
						}
				);
		}

		if ($('body.template-product').length > 0) {
			var thisHandle = $('[data-discount-handle]').attr(
				'data-discount-handle'
			);
			for (i = 0; i < discountProds.length; i++) {
				if (discountProds[i].handle == thisHandle) {
					$('.discounted-prices').removeClass('hide');
					$('.non-discounted-prices').addClass('hide');
					$('.discounted-prices')
						.find('.actual-price')
						.text(discountProds[i]['discount_price']);
					var originalPrice =
						$('.discounted-prices')
							.find('.pdp__comparePrice')
							.text()
							.substring(1) * 1;
					var discountedPrice =
						$('.discounted-prices')
							.find('.actual-price')
							.text()
							.substring(1) * 1;
					var discountString =
						(100 - (discountedPrice / originalPrice) * 100).toFixed(
							0
						) + '% OFF';
					$('.discounted-prices')
						.find('.pdp__discountBubble')
						.text(discountString);
				}
			}
		}

		var endDateString = $('.headerCountDown__countWrapper').attr(
			'data-date'
		);
		const targetTime = new Date(endDateString);

		setInterval(function () {
			const currentTime = new Date();
			const difference = targetTime - currentTime;

			const days = Math.floor(difference / (1000 * 60 * 60 * 24))
				.toString()
				.padStart(2, '0');
			const hours = Math.floor(
				(difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			)
				.toString()
				.padStart(2, '0');
			const minutes = Math.floor(
				(difference % (1000 * 60 * 60)) / (1000 * 60)
			)
				.toString()
				.padStart(2, '0');
			const seconds = Math.floor((difference % (1000 * 60)) / 1000)
				.toString()
				.padStart(2, '0');

			$('.headerCountDown__number--days').text(days);
			$('.headerCountDown__number--hours').text(hours);
			$('.headerCountDown__number--minutes').text(minutes);
			$('.headerCountDown__number--seconds').text(seconds);
		}, 100);
	});

	$(document).ready(function () {
		$('.sentryVideo__playButton').on('click', function () {
			var iframeCode = $(this).attr('iframe-code');
			var targetModal = $(this)
				.closest('.shopify-section')
				.find('.sentryModal');
			targetModal.find('.sentryModal__iframeWrapper').html(iframeCode);
			targetModal.fadeIn();
		});
		$('.sentryModal__overlay, .sentryModal__close').on(
			'click',
			function () {
				var targetModal = $(this)
					.closest('.shopify-section')
					.find('.sentryModal');
				targetModal.find('.sentryModal__iframeWrapper').html('');
				targetModal.fadeOut();
			}
		);

		function preloadImage(url) {
			var img = new Image();
			img.src = url;
		}

		$('.al2App--freeConnect .al2App__button').each(function () {
			preloadImage($(this).attr('data-image'));
		});

		$('.al2App--freeConnect .al2App__button').on('click', function () {
			$(this)
				.parent()
				.find('.al2App__button')
				.removeClass('al2App__button--active');
			$(this).addClass('al2App__button--active');

			var imgSrc = $(this).attr('data-image');
			$('.al2App--freeConnect .al2App__image').attr('src', imgSrc);
		});

		if ($('.al2Faq').length > 0) {
			$('.al2Faq__titleWrapper').on('click', function () {
				if ($(this).hasClass('al2Faq__titleWrapper--active')) {
					$(this).removeClass('al2Faq__titleWrapper--active');
					$(this).parent().find('.al2Faq__shelf').slideUp();
				} else {
					$(this).addClass('al2Faq__titleWrapper--active');
					$(this).parent().find('.al2Faq__shelf').slideDown();
				}
			});
		}

		$('.nav-item .linklist a').on('mouseenter', function () {
			let dataID = $(this).attr('data-id');

			console.log(dataID);

			$('.nav-item .linklist a').removeClass('active');

			$(this).addClass('active');
			$('.nav-item .card-wrap').addClass('hidden');
			$('.nav-item .card-wrap[data-id="' + dataID + '"]').removeClass(
				'hidden'
			);
		});

		$('.mobileNav__parent--accordion').on('click', function(){
			var target = $(this).parent().find('.mobileNav__parentDrop');
			$(this).toggleClass('mobileNav__parent--accordionOpen');
			target.slideToggle();
		});

		$('.mobileNav__child--accordion').on('click', function(){
			var target = $(this).parent().find('.mobileNav__childDrop');
			$(this).toggleClass('mobileNav__child--accordionOpen');
			target.slideToggle();
		});
	});
})(jQuery, this);
